var pn = Object.defineProperty;
var dn = (n, s, t) => s in n ? pn(n, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[s] = t;
var B = (n, s, t) => (dn(n, typeof s != "symbol" ? s + "" : s, t), t);
function fn(n, s) {
  for (var t = 0; t < s.length; t++) {
    const e = s[t];
    if (typeof e != "string" && !Array.isArray(e)) {
      for (const r in e)
        if (r !== "default" && !(r in n)) {
          const i = Object.getOwnPropertyDescriptor(e, r);
          i && Object.defineProperty(n, r, i.get ? i : {
            enumerable: !0,
            get: () => e[r]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
let er = !0, tr = !0;
function fe(n, s, t) {
  const e = n.match(s);
  return e && e.length >= t && parseInt(e[t], 10);
}
function Q(n, s, t) {
  if (!n.RTCPeerConnection)
    return;
  const e = n.RTCPeerConnection.prototype, r = e.addEventListener;
  e.addEventListener = function(o, a) {
    if (o !== s)
      return r.apply(this, arguments);
    const d = (u) => {
      const p = t(u);
      p && (a.handleEvent ? a.handleEvent(p) : a(p));
    };
    return this._eventMap = this._eventMap || {}, this._eventMap[s] || (this._eventMap[s] = /* @__PURE__ */ new Map()), this._eventMap[s].set(a, d), r.apply(this, [
      o,
      d
    ]);
  };
  const i = e.removeEventListener;
  e.removeEventListener = function(o, a) {
    if (o !== s || !this._eventMap || !this._eventMap[s])
      return i.apply(this, arguments);
    if (!this._eventMap[s].has(a))
      return i.apply(this, arguments);
    const d = this._eventMap[s].get(a);
    return this._eventMap[s].delete(a), this._eventMap[s].size === 0 && delete this._eventMap[s], Object.keys(this._eventMap).length === 0 && delete this._eventMap, i.apply(this, [
      o,
      d
    ]);
  }, Object.defineProperty(e, "on" + s, {
    get() {
      return this["_on" + s];
    },
    set(o) {
      this["_on" + s] && (this.removeEventListener(
        s,
        this["_on" + s]
      ), delete this["_on" + s]), o && this.addEventListener(
        s,
        this["_on" + s] = o
      );
    },
    enumerable: !0,
    configurable: !0
  });
}
function hn(n) {
  return typeof n != "boolean" ? new Error("Argument type: " + typeof n + ". Please use a boolean.") : (er = n, n ? "adapter.js logging disabled" : "adapter.js logging enabled");
}
function ln(n) {
  return typeof n != "boolean" ? new Error("Argument type: " + typeof n + ". Please use a boolean.") : (tr = !n, "adapter.js deprecation warnings " + (n ? "disabled" : "enabled"));
}
function rr() {
  if (typeof window == "object") {
    if (er)
      return;
    typeof console < "u" && typeof console.log == "function" && console.log.apply(console, arguments);
  }
}
function at(n, s) {
  !tr || console.warn(n + " is deprecated, please use " + s + " instead.");
}
function mn(n) {
  const s = { browser: null, version: null };
  if (typeof n > "u" || !n.navigator)
    return s.browser = "Not a browser.", s;
  const { navigator: t } = n;
  if (t.mozGetUserMedia)
    s.browser = "firefox", s.version = fe(
      t.userAgent,
      /Firefox\/(\d+)\./,
      1
    );
  else if (t.webkitGetUserMedia || n.isSecureContext === !1 && n.webkitRTCPeerConnection && !n.RTCIceGatherer)
    s.browser = "chrome", s.version = fe(
      t.userAgent,
      /Chrom(e|ium)\/(\d+)\./,
      2
    );
  else if (n.RTCPeerConnection && t.userAgent.match(/AppleWebKit\/(\d+)\./))
    s.browser = "safari", s.version = fe(
      t.userAgent,
      /AppleWebKit\/(\d+)\./,
      1
    ), s.supportsUnifiedPlan = n.RTCRtpTransceiver && "currentDirection" in n.RTCRtpTransceiver.prototype;
  else
    return s.browser = "Not a supported browser.", s;
  return s;
}
function lt(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function nr(n) {
  return lt(n) ? Object.keys(n).reduce(function(s, t) {
    const e = lt(n[t]), r = e ? nr(n[t]) : n[t], i = e && !Object.keys(r).length;
    return r === void 0 || i ? s : Object.assign(s, { [t]: r });
  }, {}) : n;
}
function Ye(n, s, t) {
  !s || t.has(s.id) || (t.set(s.id, s), Object.keys(s).forEach((e) => {
    e.endsWith("Id") ? Ye(n, n.get(s[e]), t) : e.endsWith("Ids") && s[e].forEach((r) => {
      Ye(n, n.get(r), t);
    });
  }));
}
function mt(n, s, t) {
  const e = t ? "outbound-rtp" : "inbound-rtp", r = /* @__PURE__ */ new Map();
  if (s === null)
    return r;
  const i = [];
  return n.forEach((o) => {
    o.type === "track" && o.trackIdentifier === s.id && i.push(o);
  }), i.forEach((o) => {
    n.forEach((a) => {
      a.type === e && a.trackId === o.id && Ye(n, a, r);
    });
  }), r;
}
const gt = rr;
function ir(n, s) {
  const t = n && n.navigator;
  if (!t.mediaDevices)
    return;
  const e = function(a) {
    if (typeof a != "object" || a.mandatory || a.optional)
      return a;
    const d = {};
    return Object.keys(a).forEach((u) => {
      if (u === "require" || u === "advanced" || u === "mediaSource")
        return;
      const p = typeof a[u] == "object" ? a[u] : { ideal: a[u] };
      p.exact !== void 0 && typeof p.exact == "number" && (p.min = p.max = p.exact);
      const l = function(m, f) {
        return m ? m + f.charAt(0).toUpperCase() + f.slice(1) : f === "deviceId" ? "sourceId" : f;
      };
      if (p.ideal !== void 0) {
        d.optional = d.optional || [];
        let m = {};
        typeof p.ideal == "number" ? (m[l("min", u)] = p.ideal, d.optional.push(m), m = {}, m[l("max", u)] = p.ideal, d.optional.push(m)) : (m[l("", u)] = p.ideal, d.optional.push(m));
      }
      p.exact !== void 0 && typeof p.exact != "number" ? (d.mandatory = d.mandatory || {}, d.mandatory[l("", u)] = p.exact) : ["min", "max"].forEach((m) => {
        p[m] !== void 0 && (d.mandatory = d.mandatory || {}, d.mandatory[l(m, u)] = p[m]);
      });
    }), a.advanced && (d.optional = (d.optional || []).concat(a.advanced)), d;
  }, r = function(a, d) {
    if (s.version >= 61)
      return d(a);
    if (a = JSON.parse(JSON.stringify(a)), a && typeof a.audio == "object") {
      const u = function(p, l, m) {
        l in p && !(m in p) && (p[m] = p[l], delete p[l]);
      };
      a = JSON.parse(JSON.stringify(a)), u(a.audio, "autoGainControl", "googAutoGainControl"), u(a.audio, "noiseSuppression", "googNoiseSuppression"), a.audio = e(a.audio);
    }
    if (a && typeof a.video == "object") {
      let u = a.video.facingMode;
      u = u && (typeof u == "object" ? u : { ideal: u });
      const p = s.version < 66;
      if (u && (u.exact === "user" || u.exact === "environment" || u.ideal === "user" || u.ideal === "environment") && !(t.mediaDevices.getSupportedConstraints && t.mediaDevices.getSupportedConstraints().facingMode && !p)) {
        delete a.video.facingMode;
        let l;
        if (u.exact === "environment" || u.ideal === "environment" ? l = ["back", "rear"] : (u.exact === "user" || u.ideal === "user") && (l = ["front"]), l)
          return t.mediaDevices.enumerateDevices().then((m) => {
            m = m.filter((h) => h.kind === "videoinput");
            let f = m.find((h) => l.some((g) => h.label.toLowerCase().includes(g)));
            return !f && m.length && l.includes("back") && (f = m[m.length - 1]), f && (a.video.deviceId = u.exact ? { exact: f.deviceId } : { ideal: f.deviceId }), a.video = e(a.video), gt("chrome: " + JSON.stringify(a)), d(a);
          });
      }
      a.video = e(a.video);
    }
    return gt("chrome: " + JSON.stringify(a)), d(a);
  }, i = function(a) {
    return s.version >= 64 ? a : {
      name: {
        PermissionDeniedError: "NotAllowedError",
        PermissionDismissedError: "NotAllowedError",
        InvalidStateError: "NotAllowedError",
        DevicesNotFoundError: "NotFoundError",
        ConstraintNotSatisfiedError: "OverconstrainedError",
        TrackStartError: "NotReadableError",
        MediaDeviceFailedDueToShutdown: "NotAllowedError",
        MediaDeviceKillSwitchOn: "NotAllowedError",
        TabCaptureError: "AbortError",
        ScreenCaptureError: "AbortError",
        DeviceCaptureError: "AbortError"
      }[a.name] || a.name,
      message: a.message,
      constraint: a.constraint || a.constraintName,
      toString() {
        return this.name + (this.message && ": ") + this.message;
      }
    };
  }, o = function(a, d, u) {
    r(a, (p) => {
      t.webkitGetUserMedia(p, d, (l) => {
        u && u(i(l));
      });
    });
  };
  if (t.getUserMedia = o.bind(t), t.mediaDevices.getUserMedia) {
    const a = t.mediaDevices.getUserMedia.bind(t.mediaDevices);
    t.mediaDevices.getUserMedia = function(d) {
      return r(d, (u) => a(u).then((p) => {
        if (u.audio && !p.getAudioTracks().length || u.video && !p.getVideoTracks().length)
          throw p.getTracks().forEach((l) => {
            l.stop();
          }), new DOMException("", "NotFoundError");
        return p;
      }, (p) => Promise.reject(i(p))));
    };
  }
}
function gn(n, s) {
  if (!(n.navigator.mediaDevices && "getDisplayMedia" in n.navigator.mediaDevices) && !!n.navigator.mediaDevices) {
    if (typeof s != "function") {
      console.error("shimGetDisplayMedia: getSourceId argument is not a function");
      return;
    }
    n.navigator.mediaDevices.getDisplayMedia = function(e) {
      return s(e).then((r) => {
        const i = e.video && e.video.width, o = e.video && e.video.height, a = e.video && e.video.frameRate;
        return e.video = {
          mandatory: {
            chromeMediaSource: "desktop",
            chromeMediaSourceId: r,
            maxFrameRate: a || 3
          }
        }, i && (e.video.mandatory.maxWidth = i), o && (e.video.mandatory.maxHeight = o), n.navigator.mediaDevices.getUserMedia(e);
      });
    };
  }
}
function sr(n) {
  n.MediaStream = n.MediaStream || n.webkitMediaStream;
}
function or(n) {
  if (typeof n == "object" && n.RTCPeerConnection && !("ontrack" in n.RTCPeerConnection.prototype)) {
    Object.defineProperty(n.RTCPeerConnection.prototype, "ontrack", {
      get() {
        return this._ontrack;
      },
      set(t) {
        this._ontrack && this.removeEventListener("track", this._ontrack), this.addEventListener("track", this._ontrack = t);
      },
      enumerable: !0,
      configurable: !0
    });
    const s = n.RTCPeerConnection.prototype.setRemoteDescription;
    n.RTCPeerConnection.prototype.setRemoteDescription = function() {
      return this._ontrackpoly || (this._ontrackpoly = (e) => {
        e.stream.addEventListener("addtrack", (r) => {
          let i;
          n.RTCPeerConnection.prototype.getReceivers ? i = this.getReceivers().find((a) => a.track && a.track.id === r.track.id) : i = { track: r.track };
          const o = new Event("track");
          o.track = r.track, o.receiver = i, o.transceiver = { receiver: i }, o.streams = [e.stream], this.dispatchEvent(o);
        }), e.stream.getTracks().forEach((r) => {
          let i;
          n.RTCPeerConnection.prototype.getReceivers ? i = this.getReceivers().find((a) => a.track && a.track.id === r.id) : i = { track: r };
          const o = new Event("track");
          o.track = r, o.receiver = i, o.transceiver = { receiver: i }, o.streams = [e.stream], this.dispatchEvent(o);
        });
      }, this.addEventListener("addstream", this._ontrackpoly)), s.apply(this, arguments);
    };
  } else
    Q(n, "track", (s) => (s.transceiver || Object.defineProperty(
      s,
      "transceiver",
      { value: { receiver: s.receiver } }
    ), s));
}
function ar(n) {
  if (typeof n == "object" && n.RTCPeerConnection && !("getSenders" in n.RTCPeerConnection.prototype) && "createDTMFSender" in n.RTCPeerConnection.prototype) {
    const s = function(r, i) {
      return {
        track: i,
        get dtmf() {
          return this._dtmf === void 0 && (i.kind === "audio" ? this._dtmf = r.createDTMFSender(i) : this._dtmf = null), this._dtmf;
        },
        _pc: r
      };
    };
    if (!n.RTCPeerConnection.prototype.getSenders) {
      n.RTCPeerConnection.prototype.getSenders = function() {
        return this._senders = this._senders || [], this._senders.slice();
      };
      const r = n.RTCPeerConnection.prototype.addTrack;
      n.RTCPeerConnection.prototype.addTrack = function(a, d) {
        let u = r.apply(this, arguments);
        return u || (u = s(this, a), this._senders.push(u)), u;
      };
      const i = n.RTCPeerConnection.prototype.removeTrack;
      n.RTCPeerConnection.prototype.removeTrack = function(a) {
        i.apply(this, arguments);
        const d = this._senders.indexOf(a);
        d !== -1 && this._senders.splice(d, 1);
      };
    }
    const t = n.RTCPeerConnection.prototype.addStream;
    n.RTCPeerConnection.prototype.addStream = function(i) {
      this._senders = this._senders || [], t.apply(this, [i]), i.getTracks().forEach((o) => {
        this._senders.push(s(this, o));
      });
    };
    const e = n.RTCPeerConnection.prototype.removeStream;
    n.RTCPeerConnection.prototype.removeStream = function(i) {
      this._senders = this._senders || [], e.apply(this, [i]), i.getTracks().forEach((o) => {
        const a = this._senders.find((d) => d.track === o);
        a && this._senders.splice(this._senders.indexOf(a), 1);
      });
    };
  } else if (typeof n == "object" && n.RTCPeerConnection && "getSenders" in n.RTCPeerConnection.prototype && "createDTMFSender" in n.RTCPeerConnection.prototype && n.RTCRtpSender && !("dtmf" in n.RTCRtpSender.prototype)) {
    const s = n.RTCPeerConnection.prototype.getSenders;
    n.RTCPeerConnection.prototype.getSenders = function() {
      const e = s.apply(this, []);
      return e.forEach((r) => r._pc = this), e;
    }, Object.defineProperty(n.RTCRtpSender.prototype, "dtmf", {
      get() {
        return this._dtmf === void 0 && (this.track.kind === "audio" ? this._dtmf = this._pc.createDTMFSender(this.track) : this._dtmf = null), this._dtmf;
      }
    });
  }
}
function cr(n) {
  if (!n.RTCPeerConnection)
    return;
  const s = n.RTCPeerConnection.prototype.getStats;
  n.RTCPeerConnection.prototype.getStats = function() {
    const [e, r, i] = arguments;
    if (arguments.length > 0 && typeof e == "function")
      return s.apply(this, arguments);
    if (s.length === 0 && (arguments.length === 0 || typeof e != "function"))
      return s.apply(this, []);
    const o = function(d) {
      const u = {};
      return d.result().forEach((l) => {
        const m = {
          id: l.id,
          timestamp: l.timestamp,
          type: {
            localcandidate: "local-candidate",
            remotecandidate: "remote-candidate"
          }[l.type] || l.type
        };
        l.names().forEach((f) => {
          m[f] = l.stat(f);
        }), u[m.id] = m;
      }), u;
    }, a = function(d) {
      return new Map(Object.keys(d).map((u) => [u, d[u]]));
    };
    if (arguments.length >= 2) {
      const d = function(u) {
        r(a(o(u)));
      };
      return s.apply(this, [
        d,
        e
      ]);
    }
    return new Promise((d, u) => {
      s.apply(this, [
        function(p) {
          d(a(o(p)));
        },
        u
      ]);
    }).then(r, i);
  };
}
function ur(n) {
  if (!(typeof n == "object" && n.RTCPeerConnection && n.RTCRtpSender && n.RTCRtpReceiver))
    return;
  if (!("getStats" in n.RTCRtpSender.prototype)) {
    const t = n.RTCPeerConnection.prototype.getSenders;
    t && (n.RTCPeerConnection.prototype.getSenders = function() {
      const i = t.apply(this, []);
      return i.forEach((o) => o._pc = this), i;
    });
    const e = n.RTCPeerConnection.prototype.addTrack;
    e && (n.RTCPeerConnection.prototype.addTrack = function() {
      const i = e.apply(this, arguments);
      return i._pc = this, i;
    }), n.RTCRtpSender.prototype.getStats = function() {
      const i = this;
      return this._pc.getStats().then((o) => mt(o, i.track, !0));
    };
  }
  if (!("getStats" in n.RTCRtpReceiver.prototype)) {
    const t = n.RTCPeerConnection.prototype.getReceivers;
    t && (n.RTCPeerConnection.prototype.getReceivers = function() {
      const r = t.apply(this, []);
      return r.forEach((i) => i._pc = this), r;
    }), Q(n, "track", (e) => (e.receiver._pc = e.srcElement, e)), n.RTCRtpReceiver.prototype.getStats = function() {
      const r = this;
      return this._pc.getStats().then((i) => mt(i, r.track, !1));
    };
  }
  if (!("getStats" in n.RTCRtpSender.prototype && "getStats" in n.RTCRtpReceiver.prototype))
    return;
  const s = n.RTCPeerConnection.prototype.getStats;
  n.RTCPeerConnection.prototype.getStats = function() {
    if (arguments.length > 0 && arguments[0] instanceof n.MediaStreamTrack) {
      const e = arguments[0];
      let r, i, o;
      return this.getSenders().forEach((a) => {
        a.track === e && (r ? o = !0 : r = a);
      }), this.getReceivers().forEach((a) => (a.track === e && (i ? o = !0 : i = a), a.track === e)), o || r && i ? Promise.reject(new DOMException(
        "There are more than one sender or receiver for the track.",
        "InvalidAccessError"
      )) : r ? r.getStats() : i ? i.getStats() : Promise.reject(new DOMException(
        "There is no sender or receiver for the track.",
        "InvalidAccessError"
      ));
    }
    return s.apply(this, arguments);
  };
}
function pr(n) {
  n.RTCPeerConnection.prototype.getLocalStreams = function() {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, Object.keys(this._shimmedLocalStreams).map((o) => this._shimmedLocalStreams[o][0]);
  };
  const s = n.RTCPeerConnection.prototype.addTrack;
  n.RTCPeerConnection.prototype.addTrack = function(o, a) {
    if (!a)
      return s.apply(this, arguments);
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    const d = s.apply(this, arguments);
    return this._shimmedLocalStreams[a.id] ? this._shimmedLocalStreams[a.id].indexOf(d) === -1 && this._shimmedLocalStreams[a.id].push(d) : this._shimmedLocalStreams[a.id] = [a, d], d;
  };
  const t = n.RTCPeerConnection.prototype.addStream;
  n.RTCPeerConnection.prototype.addStream = function(o) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {}, o.getTracks().forEach((u) => {
      if (this.getSenders().find((l) => l.track === u))
        throw new DOMException(
          "Track already exists.",
          "InvalidAccessError"
        );
    });
    const a = this.getSenders();
    t.apply(this, arguments);
    const d = this.getSenders().filter((u) => a.indexOf(u) === -1);
    this._shimmedLocalStreams[o.id] = [o].concat(d);
  };
  const e = n.RTCPeerConnection.prototype.removeStream;
  n.RTCPeerConnection.prototype.removeStream = function(o) {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, delete this._shimmedLocalStreams[o.id], e.apply(this, arguments);
  };
  const r = n.RTCPeerConnection.prototype.removeTrack;
  n.RTCPeerConnection.prototype.removeTrack = function(o) {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, o && Object.keys(this._shimmedLocalStreams).forEach((a) => {
      const d = this._shimmedLocalStreams[a].indexOf(o);
      d !== -1 && this._shimmedLocalStreams[a].splice(d, 1), this._shimmedLocalStreams[a].length === 1 && delete this._shimmedLocalStreams[a];
    }), r.apply(this, arguments);
  };
}
function dr(n, s) {
  if (!n.RTCPeerConnection)
    return;
  if (n.RTCPeerConnection.prototype.addTrack && s.version >= 65)
    return pr(n);
  const t = n.RTCPeerConnection.prototype.getLocalStreams;
  n.RTCPeerConnection.prototype.getLocalStreams = function() {
    const p = t.apply(this);
    return this._reverseStreams = this._reverseStreams || {}, p.map((l) => this._reverseStreams[l.id]);
  };
  const e = n.RTCPeerConnection.prototype.addStream;
  n.RTCPeerConnection.prototype.addStream = function(p) {
    if (this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, p.getTracks().forEach((l) => {
      if (this.getSenders().find((f) => f.track === l))
        throw new DOMException(
          "Track already exists.",
          "InvalidAccessError"
        );
    }), !this._reverseStreams[p.id]) {
      const l = new n.MediaStream(p.getTracks());
      this._streams[p.id] = l, this._reverseStreams[l.id] = p, p = l;
    }
    e.apply(this, [p]);
  };
  const r = n.RTCPeerConnection.prototype.removeStream;
  n.RTCPeerConnection.prototype.removeStream = function(p) {
    this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, r.apply(this, [this._streams[p.id] || p]), delete this._reverseStreams[this._streams[p.id] ? this._streams[p.id].id : p.id], delete this._streams[p.id];
  }, n.RTCPeerConnection.prototype.addTrack = function(p, l) {
    if (this.signalingState === "closed")
      throw new DOMException(
        "The RTCPeerConnection's signalingState is 'closed'.",
        "InvalidStateError"
      );
    const m = [].slice.call(arguments, 1);
    if (m.length !== 1 || !m[0].getTracks().find((g) => g === p))
      throw new DOMException(
        "The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.",
        "NotSupportedError"
      );
    if (this.getSenders().find((g) => g.track === p))
      throw new DOMException(
        "Track already exists.",
        "InvalidAccessError"
      );
    this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {};
    const h = this._streams[l.id];
    if (h)
      h.addTrack(p), Promise.resolve().then(() => {
        this.dispatchEvent(new Event("negotiationneeded"));
      });
    else {
      const g = new n.MediaStream([p]);
      this._streams[l.id] = g, this._reverseStreams[g.id] = l, this.addStream(g);
    }
    return this.getSenders().find((g) => g.track === p);
  };
  function i(u, p) {
    let l = p.sdp;
    return Object.keys(u._reverseStreams || []).forEach((m) => {
      const f = u._reverseStreams[m], h = u._streams[f.id];
      l = l.replace(
        new RegExp(h.id, "g"),
        f.id
      );
    }), new RTCSessionDescription({
      type: p.type,
      sdp: l
    });
  }
  function o(u, p) {
    let l = p.sdp;
    return Object.keys(u._reverseStreams || []).forEach((m) => {
      const f = u._reverseStreams[m], h = u._streams[f.id];
      l = l.replace(
        new RegExp(f.id, "g"),
        h.id
      );
    }), new RTCSessionDescription({
      type: p.type,
      sdp: l
    });
  }
  ["createOffer", "createAnswer"].forEach(function(u) {
    const p = n.RTCPeerConnection.prototype[u], l = { [u]() {
      const m = arguments;
      return arguments.length && typeof arguments[0] == "function" ? p.apply(this, [
        (h) => {
          const g = i(this, h);
          m[0].apply(null, [g]);
        },
        (h) => {
          m[1] && m[1].apply(null, h);
        },
        arguments[2]
      ]) : p.apply(this, arguments).then((h) => i(this, h));
    } };
    n.RTCPeerConnection.prototype[u] = l[u];
  });
  const a = n.RTCPeerConnection.prototype.setLocalDescription;
  n.RTCPeerConnection.prototype.setLocalDescription = function() {
    return !arguments.length || !arguments[0].type ? a.apply(this, arguments) : (arguments[0] = o(this, arguments[0]), a.apply(this, arguments));
  };
  const d = Object.getOwnPropertyDescriptor(
    n.RTCPeerConnection.prototype,
    "localDescription"
  );
  Object.defineProperty(
    n.RTCPeerConnection.prototype,
    "localDescription",
    {
      get() {
        const u = d.get.apply(this);
        return u.type === "" ? u : i(this, u);
      }
    }
  ), n.RTCPeerConnection.prototype.removeTrack = function(p) {
    if (this.signalingState === "closed")
      throw new DOMException(
        "The RTCPeerConnection's signalingState is 'closed'.",
        "InvalidStateError"
      );
    if (!p._pc)
      throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
    if (!(p._pc === this))
      throw new DOMException(
        "Sender was not created by this connection.",
        "InvalidAccessError"
      );
    this._streams = this._streams || {};
    let m;
    Object.keys(this._streams).forEach((f) => {
      this._streams[f].getTracks().find((g) => p.track === g) && (m = this._streams[f]);
    }), m && (m.getTracks().length === 1 ? this.removeStream(this._reverseStreams[m.id]) : m.removeTrack(p.track), this.dispatchEvent(new Event("negotiationneeded")));
  };
}
function Ze(n, s) {
  !n.RTCPeerConnection && n.webkitRTCPeerConnection && (n.RTCPeerConnection = n.webkitRTCPeerConnection), !!n.RTCPeerConnection && s.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(t) {
    const e = n.RTCPeerConnection.prototype[t], r = { [t]() {
      return arguments[0] = new (t === "addIceCandidate" ? n.RTCIceCandidate : n.RTCSessionDescription)(arguments[0]), e.apply(this, arguments);
    } };
    n.RTCPeerConnection.prototype[t] = r[t];
  });
}
function fr(n, s) {
  Q(n, "negotiationneeded", (t) => {
    const e = t.target;
    if (!((s.version < 72 || e.getConfiguration && e.getConfiguration().sdpSemantics === "plan-b") && e.signalingState !== "stable"))
      return t;
  });
}
const yt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shimMediaStream: sr,
  shimOnTrack: or,
  shimGetSendersWithDtmf: ar,
  shimGetStats: cr,
  shimSenderReceiverGetStats: ur,
  shimAddTrackRemoveTrackWithNative: pr,
  shimAddTrackRemoveTrack: dr,
  shimPeerConnection: Ze,
  fixNegotiationNeeded: fr,
  shimGetUserMedia: ir,
  shimGetDisplayMedia: gn
}, Symbol.toStringTag, { value: "Module" }));
function hr(n, s) {
  const t = n && n.navigator, e = n && n.MediaStreamTrack;
  if (t.getUserMedia = function(r, i, o) {
    at(
      "navigator.getUserMedia",
      "navigator.mediaDevices.getUserMedia"
    ), t.mediaDevices.getUserMedia(r).then(i, o);
  }, !(s.version > 55 && "autoGainControl" in t.mediaDevices.getSupportedConstraints())) {
    const r = function(o, a, d) {
      a in o && !(d in o) && (o[d] = o[a], delete o[a]);
    }, i = t.mediaDevices.getUserMedia.bind(t.mediaDevices);
    if (t.mediaDevices.getUserMedia = function(o) {
      return typeof o == "object" && typeof o.audio == "object" && (o = JSON.parse(JSON.stringify(o)), r(o.audio, "autoGainControl", "mozAutoGainControl"), r(o.audio, "noiseSuppression", "mozNoiseSuppression")), i(o);
    }, e && e.prototype.getSettings) {
      const o = e.prototype.getSettings;
      e.prototype.getSettings = function() {
        const a = o.apply(this, arguments);
        return r(a, "mozAutoGainControl", "autoGainControl"), r(a, "mozNoiseSuppression", "noiseSuppression"), a;
      };
    }
    if (e && e.prototype.applyConstraints) {
      const o = e.prototype.applyConstraints;
      e.prototype.applyConstraints = function(a) {
        return this.kind === "audio" && typeof a == "object" && (a = JSON.parse(JSON.stringify(a)), r(a, "autoGainControl", "mozAutoGainControl"), r(a, "noiseSuppression", "mozNoiseSuppression")), o.apply(this, [a]);
      };
    }
  }
}
function yn(n, s) {
  n.navigator.mediaDevices && "getDisplayMedia" in n.navigator.mediaDevices || !n.navigator.mediaDevices || (n.navigator.mediaDevices.getDisplayMedia = function(e) {
    if (!(e && e.video)) {
      const r = new DOMException("getDisplayMedia without video constraints is undefined");
      return r.name = "NotFoundError", r.code = 8, Promise.reject(r);
    }
    return e.video === !0 ? e.video = { mediaSource: s } : e.video.mediaSource = s, n.navigator.mediaDevices.getUserMedia(e);
  });
}
function lr(n) {
  typeof n == "object" && n.RTCTrackEvent && "receiver" in n.RTCTrackEvent.prototype && !("transceiver" in n.RTCTrackEvent.prototype) && Object.defineProperty(n.RTCTrackEvent.prototype, "transceiver", {
    get() {
      return { receiver: this.receiver };
    }
  });
}
function Qe(n, s) {
  if (typeof n != "object" || !(n.RTCPeerConnection || n.mozRTCPeerConnection))
    return;
  !n.RTCPeerConnection && n.mozRTCPeerConnection && (n.RTCPeerConnection = n.mozRTCPeerConnection), s.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(r) {
    const i = n.RTCPeerConnection.prototype[r], o = { [r]() {
      return arguments[0] = new (r === "addIceCandidate" ? n.RTCIceCandidate : n.RTCSessionDescription)(arguments[0]), i.apply(this, arguments);
    } };
    n.RTCPeerConnection.prototype[r] = o[r];
  });
  const t = {
    inboundrtp: "inbound-rtp",
    outboundrtp: "outbound-rtp",
    candidatepair: "candidate-pair",
    localcandidate: "local-candidate",
    remotecandidate: "remote-candidate"
  }, e = n.RTCPeerConnection.prototype.getStats;
  n.RTCPeerConnection.prototype.getStats = function() {
    const [i, o, a] = arguments;
    return e.apply(this, [i || null]).then((d) => {
      if (s.version < 53 && !o)
        try {
          d.forEach((u) => {
            u.type = t[u.type] || u.type;
          });
        } catch (u) {
          if (u.name !== "TypeError")
            throw u;
          d.forEach((p, l) => {
            d.set(l, Object.assign({}, p, {
              type: t[p.type] || p.type
            }));
          });
        }
      return d;
    }).then(o, a);
  };
}
function mr(n) {
  if (!(typeof n == "object" && n.RTCPeerConnection && n.RTCRtpSender) || n.RTCRtpSender && "getStats" in n.RTCRtpSender.prototype)
    return;
  const s = n.RTCPeerConnection.prototype.getSenders;
  s && (n.RTCPeerConnection.prototype.getSenders = function() {
    const r = s.apply(this, []);
    return r.forEach((i) => i._pc = this), r;
  });
  const t = n.RTCPeerConnection.prototype.addTrack;
  t && (n.RTCPeerConnection.prototype.addTrack = function() {
    const r = t.apply(this, arguments);
    return r._pc = this, r;
  }), n.RTCRtpSender.prototype.getStats = function() {
    return this.track ? this._pc.getStats(this.track) : Promise.resolve(/* @__PURE__ */ new Map());
  };
}
function gr(n) {
  if (!(typeof n == "object" && n.RTCPeerConnection && n.RTCRtpSender) || n.RTCRtpSender && "getStats" in n.RTCRtpReceiver.prototype)
    return;
  const s = n.RTCPeerConnection.prototype.getReceivers;
  s && (n.RTCPeerConnection.prototype.getReceivers = function() {
    const e = s.apply(this, []);
    return e.forEach((r) => r._pc = this), e;
  }), Q(n, "track", (t) => (t.receiver._pc = t.srcElement, t)), n.RTCRtpReceiver.prototype.getStats = function() {
    return this._pc.getStats(this.track);
  };
}
function yr(n) {
  !n.RTCPeerConnection || "removeStream" in n.RTCPeerConnection.prototype || (n.RTCPeerConnection.prototype.removeStream = function(t) {
    at("removeStream", "removeTrack"), this.getSenders().forEach((e) => {
      e.track && t.getTracks().includes(e.track) && this.removeTrack(e);
    });
  });
}
function vr(n) {
  n.DataChannel && !n.RTCDataChannel && (n.RTCDataChannel = n.DataChannel);
}
function Cr(n) {
  if (!(typeof n == "object" && n.RTCPeerConnection))
    return;
  const s = n.RTCPeerConnection.prototype.addTransceiver;
  s && (n.RTCPeerConnection.prototype.addTransceiver = function() {
    this.setParametersPromises = [];
    const e = arguments[1], r = e && "sendEncodings" in e;
    r && e.sendEncodings.forEach((o) => {
      if ("rid" in o && !/^[a-z0-9]{0,16}$/i.test(o.rid))
        throw new TypeError("Invalid RID value provided.");
      if ("scaleResolutionDownBy" in o && !(parseFloat(o.scaleResolutionDownBy) >= 1))
        throw new RangeError("scale_resolution_down_by must be >= 1.0");
      if ("maxFramerate" in o && !(parseFloat(o.maxFramerate) >= 0))
        throw new RangeError("max_framerate must be >= 0.0");
    });
    const i = s.apply(this, arguments);
    if (r) {
      const { sender: o } = i, a = o.getParameters();
      (!("encodings" in a) || a.encodings.length === 1 && Object.keys(a.encodings[0]).length === 0) && (a.encodings = e.sendEncodings, o.sendEncodings = e.sendEncodings, this.setParametersPromises.push(
        o.setParameters(a).then(() => {
          delete o.sendEncodings;
        }).catch(() => {
          delete o.sendEncodings;
        })
      ));
    }
    return i;
  });
}
function br(n) {
  if (!(typeof n == "object" && n.RTCRtpSender))
    return;
  const s = n.RTCRtpSender.prototype.getParameters;
  s && (n.RTCRtpSender.prototype.getParameters = function() {
    const e = s.apply(this, arguments);
    return "encodings" in e || (e.encodings = [].concat(this.sendEncodings || [{}])), e;
  });
}
function Sr(n) {
  if (!(typeof n == "object" && n.RTCPeerConnection))
    return;
  const s = n.RTCPeerConnection.prototype.createOffer;
  n.RTCPeerConnection.prototype.createOffer = function() {
    return this.setParametersPromises && this.setParametersPromises.length ? Promise.all(this.setParametersPromises).then(() => s.apply(this, arguments)).finally(() => {
      this.setParametersPromises = [];
    }) : s.apply(this, arguments);
  };
}
function Tr(n) {
  if (!(typeof n == "object" && n.RTCPeerConnection))
    return;
  const s = n.RTCPeerConnection.prototype.createAnswer;
  n.RTCPeerConnection.prototype.createAnswer = function() {
    return this.setParametersPromises && this.setParametersPromises.length ? Promise.all(this.setParametersPromises).then(() => s.apply(this, arguments)).finally(() => {
      this.setParametersPromises = [];
    }) : s.apply(this, arguments);
  };
}
const vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shimOnTrack: lr,
  shimPeerConnection: Qe,
  shimSenderGetStats: mr,
  shimReceiverGetStats: gr,
  shimRemoveStream: yr,
  shimRTCDataChannel: vr,
  shimAddTransceiver: Cr,
  shimGetParameters: br,
  shimCreateOffer: Sr,
  shimCreateAnswer: Tr,
  shimGetUserMedia: hr,
  shimGetDisplayMedia: yn
}, Symbol.toStringTag, { value: "Module" }));
function Er(n) {
  if (!(typeof n != "object" || !n.RTCPeerConnection)) {
    if ("getLocalStreams" in n.RTCPeerConnection.prototype || (n.RTCPeerConnection.prototype.getLocalStreams = function() {
      return this._localStreams || (this._localStreams = []), this._localStreams;
    }), !("addStream" in n.RTCPeerConnection.prototype)) {
      const s = n.RTCPeerConnection.prototype.addTrack;
      n.RTCPeerConnection.prototype.addStream = function(e) {
        this._localStreams || (this._localStreams = []), this._localStreams.includes(e) || this._localStreams.push(e), e.getAudioTracks().forEach((r) => s.call(
          this,
          r,
          e
        )), e.getVideoTracks().forEach((r) => s.call(
          this,
          r,
          e
        ));
      }, n.RTCPeerConnection.prototype.addTrack = function(e, ...r) {
        return r && r.forEach((i) => {
          this._localStreams ? this._localStreams.includes(i) || this._localStreams.push(i) : this._localStreams = [i];
        }), s.apply(this, arguments);
      };
    }
    "removeStream" in n.RTCPeerConnection.prototype || (n.RTCPeerConnection.prototype.removeStream = function(t) {
      this._localStreams || (this._localStreams = []);
      const e = this._localStreams.indexOf(t);
      if (e === -1)
        return;
      this._localStreams.splice(e, 1);
      const r = t.getTracks();
      this.getSenders().forEach((i) => {
        r.includes(i.track) && this.removeTrack(i);
      });
    });
  }
}
function kr(n) {
  if (!(typeof n != "object" || !n.RTCPeerConnection) && ("getRemoteStreams" in n.RTCPeerConnection.prototype || (n.RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this._remoteStreams ? this._remoteStreams : [];
  }), !("onaddstream" in n.RTCPeerConnection.prototype))) {
    Object.defineProperty(n.RTCPeerConnection.prototype, "onaddstream", {
      get() {
        return this._onaddstream;
      },
      set(t) {
        this._onaddstream && (this.removeEventListener("addstream", this._onaddstream), this.removeEventListener("track", this._onaddstreampoly)), this.addEventListener("addstream", this._onaddstream = t), this.addEventListener("track", this._onaddstreampoly = (e) => {
          e.streams.forEach((r) => {
            if (this._remoteStreams || (this._remoteStreams = []), this._remoteStreams.includes(r))
              return;
            this._remoteStreams.push(r);
            const i = new Event("addstream");
            i.stream = r, this.dispatchEvent(i);
          });
        });
      }
    });
    const s = n.RTCPeerConnection.prototype.setRemoteDescription;
    n.RTCPeerConnection.prototype.setRemoteDescription = function() {
      const e = this;
      return this._onaddstreampoly || this.addEventListener("track", this._onaddstreampoly = function(r) {
        r.streams.forEach((i) => {
          if (e._remoteStreams || (e._remoteStreams = []), e._remoteStreams.indexOf(i) >= 0)
            return;
          e._remoteStreams.push(i);
          const o = new Event("addstream");
          o.stream = i, e.dispatchEvent(o);
        });
      }), s.apply(e, arguments);
    };
  }
}
function Rr(n) {
  if (typeof n != "object" || !n.RTCPeerConnection)
    return;
  const s = n.RTCPeerConnection.prototype, t = s.createOffer, e = s.createAnswer, r = s.setLocalDescription, i = s.setRemoteDescription, o = s.addIceCandidate;
  s.createOffer = function(u, p) {
    const l = arguments.length >= 2 ? arguments[2] : arguments[0], m = t.apply(this, [l]);
    return p ? (m.then(u, p), Promise.resolve()) : m;
  }, s.createAnswer = function(u, p) {
    const l = arguments.length >= 2 ? arguments[2] : arguments[0], m = e.apply(this, [l]);
    return p ? (m.then(u, p), Promise.resolve()) : m;
  };
  let a = function(d, u, p) {
    const l = r.apply(this, [d]);
    return p ? (l.then(u, p), Promise.resolve()) : l;
  };
  s.setLocalDescription = a, a = function(d, u, p) {
    const l = i.apply(this, [d]);
    return p ? (l.then(u, p), Promise.resolve()) : l;
  }, s.setRemoteDescription = a, a = function(d, u, p) {
    const l = o.apply(this, [d]);
    return p ? (l.then(u, p), Promise.resolve()) : l;
  }, s.addIceCandidate = a;
}
function Pr(n) {
  const s = n && n.navigator;
  if (s.mediaDevices && s.mediaDevices.getUserMedia) {
    const t = s.mediaDevices, e = t.getUserMedia.bind(t);
    s.mediaDevices.getUserMedia = (r) => e(xr(r));
  }
  !s.getUserMedia && s.mediaDevices && s.mediaDevices.getUserMedia && (s.getUserMedia = function(e, r, i) {
    s.mediaDevices.getUserMedia(e).then(r, i);
  }.bind(s));
}
function xr(n) {
  return n && n.video !== void 0 ? Object.assign(
    {},
    n,
    { video: nr(n.video) }
  ) : n;
}
function _r(n) {
  if (!n.RTCPeerConnection)
    return;
  const s = n.RTCPeerConnection;
  n.RTCPeerConnection = function(e, r) {
    if (e && e.iceServers) {
      const i = [];
      for (let o = 0; o < e.iceServers.length; o++) {
        let a = e.iceServers[o];
        !a.hasOwnProperty("urls") && a.hasOwnProperty("url") ? (at("RTCIceServer.url", "RTCIceServer.urls"), a = JSON.parse(JSON.stringify(a)), a.urls = a.url, delete a.url, i.push(a)) : i.push(e.iceServers[o]);
      }
      e.iceServers = i;
    }
    return new s(e, r);
  }, n.RTCPeerConnection.prototype = s.prototype, "generateCertificate" in s && Object.defineProperty(n.RTCPeerConnection, "generateCertificate", {
    get() {
      return s.generateCertificate;
    }
  });
}
function Ar(n) {
  typeof n == "object" && n.RTCTrackEvent && "receiver" in n.RTCTrackEvent.prototype && !("transceiver" in n.RTCTrackEvent.prototype) && Object.defineProperty(n.RTCTrackEvent.prototype, "transceiver", {
    get() {
      return { receiver: this.receiver };
    }
  });
}
function Dr(n) {
  const s = n.RTCPeerConnection.prototype.createOffer;
  n.RTCPeerConnection.prototype.createOffer = function(e) {
    if (e) {
      typeof e.offerToReceiveAudio < "u" && (e.offerToReceiveAudio = !!e.offerToReceiveAudio);
      const r = this.getTransceivers().find((o) => o.receiver.track.kind === "audio");
      e.offerToReceiveAudio === !1 && r ? r.direction === "sendrecv" ? r.setDirection ? r.setDirection("sendonly") : r.direction = "sendonly" : r.direction === "recvonly" && (r.setDirection ? r.setDirection("inactive") : r.direction = "inactive") : e.offerToReceiveAudio === !0 && !r && this.addTransceiver("audio", { direction: "recvonly" }), typeof e.offerToReceiveVideo < "u" && (e.offerToReceiveVideo = !!e.offerToReceiveVideo);
      const i = this.getTransceivers().find((o) => o.receiver.track.kind === "video");
      e.offerToReceiveVideo === !1 && i ? i.direction === "sendrecv" ? i.setDirection ? i.setDirection("sendonly") : i.direction = "sendonly" : i.direction === "recvonly" && (i.setDirection ? i.setDirection("inactive") : i.direction = "inactive") : e.offerToReceiveVideo === !0 && !i && this.addTransceiver("video", { direction: "recvonly" });
    }
    return s.apply(this, arguments);
  };
}
function Mr(n) {
  typeof n != "object" || n.AudioContext || (n.AudioContext = n.webkitAudioContext);
}
const Ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shimLocalStreamsAPI: Er,
  shimRemoteStreamsAPI: kr,
  shimCallbacksAPI: Rr,
  shimGetUserMedia: Pr,
  shimConstraints: xr,
  shimRTCIceServerUrls: _r,
  shimTrackEventTransceiver: Ar,
  shimCreateOfferLegacy: Dr,
  shimAudioContext: Mr
}, Symbol.toStringTag, { value: "Module" }));
var $ = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vn(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function Cn(n) {
  var s = n.default;
  if (typeof s == "function") {
    var t = function() {
      return s.apply(this, arguments);
    };
    t.prototype = s.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(n).forEach(function(e) {
    var r = Object.getOwnPropertyDescriptor(n, e);
    Object.defineProperty(t, e, r.get ? r : {
      enumerable: !0,
      get: function() {
        return n[e];
      }
    });
  }), t;
}
var ct = { exports: {} };
(function(n) {
  const s = {};
  s.generateIdentifier = function() {
    return Math.random().toString(36).substr(2, 10);
  }, s.localCName = s.generateIdentifier(), s.splitLines = function(t) {
    return t.trim().split(`
`).map((e) => e.trim());
  }, s.splitSections = function(t) {
    return t.split(`
m=`).map((r, i) => (i > 0 ? "m=" + r : r).trim() + `\r
`);
  }, s.getDescription = function(t) {
    const e = s.splitSections(t);
    return e && e[0];
  }, s.getMediaSections = function(t) {
    const e = s.splitSections(t);
    return e.shift(), e;
  }, s.matchPrefix = function(t, e) {
    return s.splitLines(t).filter((r) => r.indexOf(e) === 0);
  }, s.parseCandidate = function(t) {
    let e;
    t.indexOf("a=candidate:") === 0 ? e = t.substring(12).split(" ") : e = t.substring(10).split(" ");
    const r = {
      foundation: e[0],
      component: { 1: "rtp", 2: "rtcp" }[e[1]] || e[1],
      protocol: e[2].toLowerCase(),
      priority: parseInt(e[3], 10),
      ip: e[4],
      address: e[4],
      port: parseInt(e[5], 10),
      type: e[7]
    };
    for (let i = 8; i < e.length; i += 2)
      switch (e[i]) {
        case "raddr":
          r.relatedAddress = e[i + 1];
          break;
        case "rport":
          r.relatedPort = parseInt(e[i + 1], 10);
          break;
        case "tcptype":
          r.tcpType = e[i + 1];
          break;
        case "ufrag":
          r.ufrag = e[i + 1], r.usernameFragment = e[i + 1];
          break;
        default:
          r[e[i]] === void 0 && (r[e[i]] = e[i + 1]);
          break;
      }
    return r;
  }, s.writeCandidate = function(t) {
    const e = [];
    e.push(t.foundation);
    const r = t.component;
    r === "rtp" ? e.push(1) : r === "rtcp" ? e.push(2) : e.push(r), e.push(t.protocol.toUpperCase()), e.push(t.priority), e.push(t.address || t.ip), e.push(t.port);
    const i = t.type;
    return e.push("typ"), e.push(i), i !== "host" && t.relatedAddress && t.relatedPort && (e.push("raddr"), e.push(t.relatedAddress), e.push("rport"), e.push(t.relatedPort)), t.tcpType && t.protocol.toLowerCase() === "tcp" && (e.push("tcptype"), e.push(t.tcpType)), (t.usernameFragment || t.ufrag) && (e.push("ufrag"), e.push(t.usernameFragment || t.ufrag)), "candidate:" + e.join(" ");
  }, s.parseIceOptions = function(t) {
    return t.substr(14).split(" ");
  }, s.parseRtpMap = function(t) {
    let e = t.substr(9).split(" ");
    const r = {
      payloadType: parseInt(e.shift(), 10)
    };
    return e = e[0].split("/"), r.name = e[0], r.clockRate = parseInt(e[1], 10), r.channels = e.length === 3 ? parseInt(e[2], 10) : 1, r.numChannels = r.channels, r;
  }, s.writeRtpMap = function(t) {
    let e = t.payloadType;
    t.preferredPayloadType !== void 0 && (e = t.preferredPayloadType);
    const r = t.channels || t.numChannels || 1;
    return "a=rtpmap:" + e + " " + t.name + "/" + t.clockRate + (r !== 1 ? "/" + r : "") + `\r
`;
  }, s.parseExtmap = function(t) {
    const e = t.substr(9).split(" ");
    return {
      id: parseInt(e[0], 10),
      direction: e[0].indexOf("/") > 0 ? e[0].split("/")[1] : "sendrecv",
      uri: e[1]
    };
  }, s.writeExtmap = function(t) {
    return "a=extmap:" + (t.id || t.preferredId) + (t.direction && t.direction !== "sendrecv" ? "/" + t.direction : "") + " " + t.uri + `\r
`;
  }, s.parseFmtp = function(t) {
    const e = {};
    let r;
    const i = t.substr(t.indexOf(" ") + 1).split(";");
    for (let o = 0; o < i.length; o++)
      r = i[o].trim().split("="), e[r[0].trim()] = r[1];
    return e;
  }, s.writeFmtp = function(t) {
    let e = "", r = t.payloadType;
    if (t.preferredPayloadType !== void 0 && (r = t.preferredPayloadType), t.parameters && Object.keys(t.parameters).length) {
      const i = [];
      Object.keys(t.parameters).forEach((o) => {
        t.parameters[o] !== void 0 ? i.push(o + "=" + t.parameters[o]) : i.push(o);
      }), e += "a=fmtp:" + r + " " + i.join(";") + `\r
`;
    }
    return e;
  }, s.parseRtcpFb = function(t) {
    const e = t.substr(t.indexOf(" ") + 1).split(" ");
    return {
      type: e.shift(),
      parameter: e.join(" ")
    };
  }, s.writeRtcpFb = function(t) {
    let e = "", r = t.payloadType;
    return t.preferredPayloadType !== void 0 && (r = t.preferredPayloadType), t.rtcpFeedback && t.rtcpFeedback.length && t.rtcpFeedback.forEach((i) => {
      e += "a=rtcp-fb:" + r + " " + i.type + (i.parameter && i.parameter.length ? " " + i.parameter : "") + `\r
`;
    }), e;
  }, s.parseSsrcMedia = function(t) {
    const e = t.indexOf(" "), r = {
      ssrc: parseInt(t.substr(7, e - 7), 10)
    }, i = t.indexOf(":", e);
    return i > -1 ? (r.attribute = t.substr(e + 1, i - e - 1), r.value = t.substr(i + 1)) : r.attribute = t.substr(e + 1), r;
  }, s.parseSsrcGroup = function(t) {
    const e = t.substr(13).split(" ");
    return {
      semantics: e.shift(),
      ssrcs: e.map((r) => parseInt(r, 10))
    };
  }, s.getMid = function(t) {
    const e = s.matchPrefix(t, "a=mid:")[0];
    if (e)
      return e.substr(6);
  }, s.parseFingerprint = function(t) {
    const e = t.substr(14).split(" ");
    return {
      algorithm: e[0].toLowerCase(),
      value: e[1].toUpperCase()
    };
  }, s.getDtlsParameters = function(t, e) {
    const r = s.matchPrefix(
      t + e,
      "a=fingerprint:"
    );
    return {
      role: "auto",
      fingerprints: r.map(s.parseFingerprint)
    };
  }, s.writeDtlsParameters = function(t, e) {
    let r = "a=setup:" + e + `\r
`;
    return t.fingerprints.forEach((i) => {
      r += "a=fingerprint:" + i.algorithm + " " + i.value + `\r
`;
    }), r;
  }, s.parseCryptoLine = function(t) {
    const e = t.substr(9).split(" ");
    return {
      tag: parseInt(e[0], 10),
      cryptoSuite: e[1],
      keyParams: e[2],
      sessionParams: e.slice(3)
    };
  }, s.writeCryptoLine = function(t) {
    return "a=crypto:" + t.tag + " " + t.cryptoSuite + " " + (typeof t.keyParams == "object" ? s.writeCryptoKeyParams(t.keyParams) : t.keyParams) + (t.sessionParams ? " " + t.sessionParams.join(" ") : "") + `\r
`;
  }, s.parseCryptoKeyParams = function(t) {
    if (t.indexOf("inline:") !== 0)
      return null;
    const e = t.substr(7).split("|");
    return {
      keyMethod: "inline",
      keySalt: e[0],
      lifeTime: e[1],
      mkiValue: e[2] ? e[2].split(":")[0] : void 0,
      mkiLength: e[2] ? e[2].split(":")[1] : void 0
    };
  }, s.writeCryptoKeyParams = function(t) {
    return t.keyMethod + ":" + t.keySalt + (t.lifeTime ? "|" + t.lifeTime : "") + (t.mkiValue && t.mkiLength ? "|" + t.mkiValue + ":" + t.mkiLength : "");
  }, s.getCryptoParameters = function(t, e) {
    return s.matchPrefix(
      t + e,
      "a=crypto:"
    ).map(s.parseCryptoLine);
  }, s.getIceParameters = function(t, e) {
    const r = s.matchPrefix(
      t + e,
      "a=ice-ufrag:"
    )[0], i = s.matchPrefix(
      t + e,
      "a=ice-pwd:"
    )[0];
    return r && i ? {
      usernameFragment: r.substr(12),
      password: i.substr(10)
    } : null;
  }, s.writeIceParameters = function(t) {
    let e = "a=ice-ufrag:" + t.usernameFragment + `\r
a=ice-pwd:` + t.password + `\r
`;
    return t.iceLite && (e += `a=ice-lite\r
`), e;
  }, s.parseRtpParameters = function(t) {
    const e = {
      codecs: [],
      headerExtensions: [],
      fecMechanisms: [],
      rtcp: []
    }, i = s.splitLines(t)[0].split(" ");
    for (let o = 3; o < i.length; o++) {
      const a = i[o], d = s.matchPrefix(
        t,
        "a=rtpmap:" + a + " "
      )[0];
      if (d) {
        const u = s.parseRtpMap(d), p = s.matchPrefix(
          t,
          "a=fmtp:" + a + " "
        );
        switch (u.parameters = p.length ? s.parseFmtp(p[0]) : {}, u.rtcpFeedback = s.matchPrefix(
          t,
          "a=rtcp-fb:" + a + " "
        ).map(s.parseRtcpFb), e.codecs.push(u), u.name.toUpperCase()) {
          case "RED":
          case "ULPFEC":
            e.fecMechanisms.push(u.name.toUpperCase());
            break;
        }
      }
    }
    return s.matchPrefix(t, "a=extmap:").forEach((o) => {
      e.headerExtensions.push(s.parseExtmap(o));
    }), e;
  }, s.writeRtpDescription = function(t, e) {
    let r = "";
    r += "m=" + t + " ", r += e.codecs.length > 0 ? "9" : "0", r += " UDP/TLS/RTP/SAVPF ", r += e.codecs.map((o) => o.preferredPayloadType !== void 0 ? o.preferredPayloadType : o.payloadType).join(" ") + `\r
`, r += `c=IN IP4 0.0.0.0\r
`, r += `a=rtcp:9 IN IP4 0.0.0.0\r
`, e.codecs.forEach((o) => {
      r += s.writeRtpMap(o), r += s.writeFmtp(o), r += s.writeRtcpFb(o);
    });
    let i = 0;
    return e.codecs.forEach((o) => {
      o.maxptime > i && (i = o.maxptime);
    }), i > 0 && (r += "a=maxptime:" + i + `\r
`), e.headerExtensions && e.headerExtensions.forEach((o) => {
      r += s.writeExtmap(o);
    }), r;
  }, s.parseRtpEncodingParameters = function(t) {
    const e = [], r = s.parseRtpParameters(t), i = r.fecMechanisms.indexOf("RED") !== -1, o = r.fecMechanisms.indexOf("ULPFEC") !== -1, a = s.matchPrefix(t, "a=ssrc:").map((m) => s.parseSsrcMedia(m)).filter((m) => m.attribute === "cname"), d = a.length > 0 && a[0].ssrc;
    let u;
    const p = s.matchPrefix(t, "a=ssrc-group:FID").map((m) => m.substr(17).split(" ").map((h) => parseInt(h, 10)));
    p.length > 0 && p[0].length > 1 && p[0][0] === d && (u = p[0][1]), r.codecs.forEach((m) => {
      if (m.name.toUpperCase() === "RTX" && m.parameters.apt) {
        let f = {
          ssrc: d,
          codecPayloadType: parseInt(m.parameters.apt, 10)
        };
        d && u && (f.rtx = { ssrc: u }), e.push(f), i && (f = JSON.parse(JSON.stringify(f)), f.fec = {
          ssrc: d,
          mechanism: o ? "red+ulpfec" : "red"
        }, e.push(f));
      }
    }), e.length === 0 && d && e.push({
      ssrc: d
    });
    let l = s.matchPrefix(t, "b=");
    return l.length && (l[0].indexOf("b=TIAS:") === 0 ? l = parseInt(l[0].substr(7), 10) : l[0].indexOf("b=AS:") === 0 ? l = parseInt(l[0].substr(5), 10) * 1e3 * 0.95 - 50 * 40 * 8 : l = void 0, e.forEach((m) => {
      m.maxBitrate = l;
    })), e;
  }, s.parseRtcpParameters = function(t) {
    const e = {}, r = s.matchPrefix(t, "a=ssrc:").map((a) => s.parseSsrcMedia(a)).filter((a) => a.attribute === "cname")[0];
    r && (e.cname = r.value, e.ssrc = r.ssrc);
    const i = s.matchPrefix(t, "a=rtcp-rsize");
    e.reducedSize = i.length > 0, e.compound = i.length === 0;
    const o = s.matchPrefix(t, "a=rtcp-mux");
    return e.mux = o.length > 0, e;
  }, s.writeRtcpParameters = function(t) {
    let e = "";
    return t.reducedSize && (e += `a=rtcp-rsize\r
`), t.mux && (e += `a=rtcp-mux\r
`), t.ssrc !== void 0 && t.cname && (e += "a=ssrc:" + t.ssrc + " cname:" + t.cname + `\r
`), e;
  }, s.parseMsid = function(t) {
    let e;
    const r = s.matchPrefix(t, "a=msid:");
    if (r.length === 1)
      return e = r[0].substr(7).split(" "), { stream: e[0], track: e[1] };
    const i = s.matchPrefix(t, "a=ssrc:").map((o) => s.parseSsrcMedia(o)).filter((o) => o.attribute === "msid");
    if (i.length > 0)
      return e = i[0].value.split(" "), { stream: e[0], track: e[1] };
  }, s.parseSctpDescription = function(t) {
    const e = s.parseMLine(t), r = s.matchPrefix(t, "a=max-message-size:");
    let i;
    r.length > 0 && (i = parseInt(r[0].substr(19), 10)), isNaN(i) && (i = 65536);
    const o = s.matchPrefix(t, "a=sctp-port:");
    if (o.length > 0)
      return {
        port: parseInt(o[0].substr(12), 10),
        protocol: e.fmt,
        maxMessageSize: i
      };
    const a = s.matchPrefix(t, "a=sctpmap:");
    if (a.length > 0) {
      const d = a[0].substr(10).split(" ");
      return {
        port: parseInt(d[0], 10),
        protocol: d[1],
        maxMessageSize: i
      };
    }
  }, s.writeSctpDescription = function(t, e) {
    let r = [];
    return t.protocol !== "DTLS/SCTP" ? r = [
      "m=" + t.kind + " 9 " + t.protocol + " " + e.protocol + `\r
`,
      `c=IN IP4 0.0.0.0\r
`,
      "a=sctp-port:" + e.port + `\r
`
    ] : r = [
      "m=" + t.kind + " 9 " + t.protocol + " " + e.port + `\r
`,
      `c=IN IP4 0.0.0.0\r
`,
      "a=sctpmap:" + e.port + " " + e.protocol + ` 65535\r
`
    ], e.maxMessageSize !== void 0 && r.push("a=max-message-size:" + e.maxMessageSize + `\r
`), r.join("");
  }, s.generateSessionId = function() {
    return Math.random().toString().substr(2, 21);
  }, s.writeSessionBoilerplate = function(t, e, r) {
    let i;
    const o = e !== void 0 ? e : 2;
    return t ? i = t : i = s.generateSessionId(), `v=0\r
o=` + (r || "thisisadapterortc") + " " + i + " " + o + ` IN IP4 127.0.0.1\r
s=-\r
t=0 0\r
`;
  }, s.getDirection = function(t, e) {
    const r = s.splitLines(t);
    for (let i = 0; i < r.length; i++)
      switch (r[i]) {
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
          return r[i].substr(2);
      }
    return e ? s.getDirection(e) : "sendrecv";
  }, s.getKind = function(t) {
    return s.splitLines(t)[0].split(" ")[0].substr(2);
  }, s.isRejected = function(t) {
    return t.split(" ", 2)[1] === "0";
  }, s.parseMLine = function(t) {
    const r = s.splitLines(t)[0].substr(2).split(" ");
    return {
      kind: r[0],
      port: parseInt(r[1], 10),
      protocol: r[2],
      fmt: r.slice(3).join(" ")
    };
  }, s.parseOLine = function(t) {
    const r = s.matchPrefix(t, "o=")[0].substr(2).split(" ");
    return {
      username: r[0],
      sessionId: r[1],
      sessionVersion: parseInt(r[2], 10),
      netType: r[3],
      addressType: r[4],
      address: r[5]
    };
  }, s.isValidSDP = function(t) {
    if (typeof t != "string" || t.length === 0)
      return !1;
    const e = s.splitLines(t);
    for (let r = 0; r < e.length; r++)
      if (e[r].length < 2 || e[r].charAt(1) !== "=")
        return !1;
    return !0;
  }, n.exports = s;
})(ct);
const ne = ct.exports, bn = /* @__PURE__ */ fn({
  __proto__: null,
  default: ne
}, [ct.exports]);
function he(n) {
  if (!n.RTCIceCandidate || n.RTCIceCandidate && "foundation" in n.RTCIceCandidate.prototype)
    return;
  const s = n.RTCIceCandidate;
  n.RTCIceCandidate = function(e) {
    if (typeof e == "object" && e.candidate && e.candidate.indexOf("a=") === 0 && (e = JSON.parse(JSON.stringify(e)), e.candidate = e.candidate.substr(2)), e.candidate && e.candidate.length) {
      const r = new s(e), i = ne.parseCandidate(e.candidate), o = Object.assign(
        r,
        i
      );
      return o.toJSON = function() {
        return {
          candidate: o.candidate,
          sdpMid: o.sdpMid,
          sdpMLineIndex: o.sdpMLineIndex,
          usernameFragment: o.usernameFragment
        };
      }, o;
    }
    return new s(e);
  }, n.RTCIceCandidate.prototype = s.prototype, Q(n, "icecandidate", (t) => (t.candidate && Object.defineProperty(t, "candidate", {
    value: new n.RTCIceCandidate(t.candidate),
    writable: "false"
  }), t));
}
function le(n, s) {
  if (!n.RTCPeerConnection)
    return;
  "sctp" in n.RTCPeerConnection.prototype || Object.defineProperty(n.RTCPeerConnection.prototype, "sctp", {
    get() {
      return typeof this._sctp > "u" ? null : this._sctp;
    }
  });
  const t = function(a) {
    if (!a || !a.sdp)
      return !1;
    const d = ne.splitSections(a.sdp);
    return d.shift(), d.some((u) => {
      const p = ne.parseMLine(u);
      return p && p.kind === "application" && p.protocol.indexOf("SCTP") !== -1;
    });
  }, e = function(a) {
    const d = a.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
    if (d === null || d.length < 2)
      return -1;
    const u = parseInt(d[1], 10);
    return u !== u ? -1 : u;
  }, r = function(a) {
    let d = 65536;
    return s.browser === "firefox" && (s.version < 57 ? a === -1 ? d = 16384 : d = 2147483637 : s.version < 60 ? d = s.version === 57 ? 65535 : 65536 : d = 2147483637), d;
  }, i = function(a, d) {
    let u = 65536;
    s.browser === "firefox" && s.version === 57 && (u = 65535);
    const p = ne.matchPrefix(
      a.sdp,
      "a=max-message-size:"
    );
    return p.length > 0 ? u = parseInt(p[0].substr(19), 10) : s.browser === "firefox" && d !== -1 && (u = 2147483637), u;
  }, o = n.RTCPeerConnection.prototype.setRemoteDescription;
  n.RTCPeerConnection.prototype.setRemoteDescription = function() {
    if (this._sctp = null, s.browser === "chrome" && s.version >= 76) {
      const { sdpSemantics: d } = this.getConfiguration();
      d === "plan-b" && Object.defineProperty(this, "sctp", {
        get() {
          return typeof this._sctp > "u" ? null : this._sctp;
        },
        enumerable: !0,
        configurable: !0
      });
    }
    if (t(arguments[0])) {
      const d = e(arguments[0]), u = r(d), p = i(arguments[0], d);
      let l;
      u === 0 && p === 0 ? l = Number.POSITIVE_INFINITY : u === 0 || p === 0 ? l = Math.max(u, p) : l = Math.min(u, p);
      const m = {};
      Object.defineProperty(m, "maxMessageSize", {
        get() {
          return l;
        }
      }), this._sctp = m;
    }
    return o.apply(this, arguments);
  };
}
function me(n) {
  if (!(n.RTCPeerConnection && "createDataChannel" in n.RTCPeerConnection.prototype))
    return;
  function s(e, r) {
    const i = e.send;
    e.send = function() {
      const a = arguments[0], d = a.length || a.size || a.byteLength;
      if (e.readyState === "open" && r.sctp && d > r.sctp.maxMessageSize)
        throw new TypeError("Message too large (can send a maximum of " + r.sctp.maxMessageSize + " bytes)");
      return i.apply(e, arguments);
    };
  }
  const t = n.RTCPeerConnection.prototype.createDataChannel;
  n.RTCPeerConnection.prototype.createDataChannel = function() {
    const r = t.apply(this, arguments);
    return s(r, this), r;
  }, Q(n, "datachannel", (e) => (s(e.channel, e.target), e));
}
function et(n) {
  if (!n.RTCPeerConnection || "connectionState" in n.RTCPeerConnection.prototype)
    return;
  const s = n.RTCPeerConnection.prototype;
  Object.defineProperty(s, "connectionState", {
    get() {
      return {
        completed: "connected",
        checking: "connecting"
      }[this.iceConnectionState] || this.iceConnectionState;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(s, "onconnectionstatechange", {
    get() {
      return this._onconnectionstatechange || null;
    },
    set(t) {
      this._onconnectionstatechange && (this.removeEventListener(
        "connectionstatechange",
        this._onconnectionstatechange
      ), delete this._onconnectionstatechange), t && this.addEventListener(
        "connectionstatechange",
        this._onconnectionstatechange = t
      );
    },
    enumerable: !0,
    configurable: !0
  }), ["setLocalDescription", "setRemoteDescription"].forEach((t) => {
    const e = s[t];
    s[t] = function() {
      return this._connectionstatechangepoly || (this._connectionstatechangepoly = (r) => {
        const i = r.target;
        if (i._lastConnectionState !== i.connectionState) {
          i._lastConnectionState = i.connectionState;
          const o = new Event("connectionstatechange", r);
          i.dispatchEvent(o);
        }
        return r;
      }, this.addEventListener(
        "iceconnectionstatechange",
        this._connectionstatechangepoly
      )), e.apply(this, arguments);
    };
  });
}
function tt(n, s) {
  if (!n.RTCPeerConnection || s.browser === "chrome" && s.version >= 71 || s.browser === "safari" && s.version >= 605)
    return;
  const t = n.RTCPeerConnection.prototype.setRemoteDescription;
  n.RTCPeerConnection.prototype.setRemoteDescription = function(r) {
    if (r && r.sdp && r.sdp.indexOf(`
a=extmap-allow-mixed`) !== -1) {
      const i = r.sdp.split(`
`).filter((o) => o.trim() !== "a=extmap-allow-mixed").join(`
`);
      n.RTCSessionDescription && r instanceof n.RTCSessionDescription ? arguments[0] = new n.RTCSessionDescription({
        type: r.type,
        sdp: i
      }) : r.sdp = i;
    }
    return t.apply(this, arguments);
  };
}
function ge(n, s) {
  if (!(n.RTCPeerConnection && n.RTCPeerConnection.prototype))
    return;
  const t = n.RTCPeerConnection.prototype.addIceCandidate;
  !t || t.length === 0 || (n.RTCPeerConnection.prototype.addIceCandidate = function() {
    return arguments[0] ? (s.browser === "chrome" && s.version < 78 || s.browser === "firefox" && s.version < 68 || s.browser === "safari") && arguments[0] && arguments[0].candidate === "" ? Promise.resolve() : t.apply(this, arguments) : (arguments[1] && arguments[1].apply(null), Promise.resolve());
  });
}
function ye(n, s) {
  if (!(n.RTCPeerConnection && n.RTCPeerConnection.prototype))
    return;
  const t = n.RTCPeerConnection.prototype.setLocalDescription;
  !t || t.length === 0 || (n.RTCPeerConnection.prototype.setLocalDescription = function() {
    let r = arguments[0] || {};
    if (typeof r != "object" || r.type && r.sdp)
      return t.apply(this, arguments);
    if (r = { type: r.type, sdp: r.sdp }, !r.type)
      switch (this.signalingState) {
        case "stable":
        case "have-local-offer":
        case "have-remote-pranswer":
          r.type = "offer";
          break;
        default:
          r.type = "answer";
          break;
      }
    return r.sdp || r.type !== "offer" && r.type !== "answer" ? t.apply(this, [r]) : (r.type === "offer" ? this.createOffer : this.createAnswer).apply(this).then((o) => t.apply(this, [o]));
  });
}
const Sn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shimRTCIceCandidate: he,
  shimMaxMessageSize: le,
  shimSendThrowTypeError: me,
  shimConnectionState: et,
  removeExtmapAllowMixed: tt,
  shimAddIceCandidateNullOrEmpty: ge,
  shimParameterlessSetLocalDescription: ye
}, Symbol.toStringTag, { value: "Module" }));
function Tn({ window: n } = {}, s = {
  shimChrome: !0,
  shimFirefox: !0,
  shimSafari: !0
}) {
  const t = rr, e = mn(n), r = {
    browserDetails: e,
    commonShim: Sn,
    extractVersion: fe,
    disableLog: hn,
    disableWarnings: ln,
    sdp: bn
  };
  switch (e.browser) {
    case "chrome":
      if (!yt || !Ze || !s.shimChrome)
        return t("Chrome shim is not included in this adapter release."), r;
      if (e.version === null)
        return t("Chrome shim can not determine version, not shimming."), r;
      t("adapter.js shimming chrome."), r.browserShim = yt, ge(n, e), ye(n), ir(n, e), sr(n), Ze(n, e), or(n), dr(n, e), ar(n), cr(n), ur(n), fr(n, e), he(n), et(n), le(n, e), me(n), tt(n, e);
      break;
    case "firefox":
      if (!vt || !Qe || !s.shimFirefox)
        return t("Firefox shim is not included in this adapter release."), r;
      t("adapter.js shimming firefox."), r.browserShim = vt, ge(n, e), ye(n), hr(n, e), Qe(n, e), lr(n), yr(n), mr(n), gr(n), vr(n), Cr(n), br(n), Sr(n), Tr(n), he(n), et(n), le(n, e), me(n);
      break;
    case "safari":
      if (!Ct || !s.shimSafari)
        return t("Safari shim is not included in this adapter release."), r;
      t("adapter.js shimming safari."), r.browserShim = Ct, ge(n, e), ye(n), _r(n), Dr(n), Rr(n), Er(n), kr(n), Ar(n), Pr(n), Mr(n), he(n), le(n, e), me(n), tt(n, e);
      break;
    default:
      t("Unsupported browser!");
      break;
  }
  return r;
}
Tn({ window: typeof window > "u" ? void 0 : window });
var Ir = /* @__PURE__ */ ((n) => (n.HIGH_STREAM = "1", n.LOW_STREAM = "2", n.AUTO_STREAM = "auto", n))(Ir || {});
const N = {
  USER_JOINED: "user-joined",
  USER_LEFT: "user-left",
  USER_PUBLISHED: "user-published",
  USER_UNPUBLISHED: "user-unpublished",
  TRACK_ENDED: "track-ended",
  VOLUME_INDICATOR: "volume-indicator",
  NETWORK_QUALITY: "network-quality",
  CONNECTION_STATE_CHANGE: "connection-state-change",
  DUAL_STREAM_CHANGE: "dual-stream-change",
  USER_VIDEO_SEI: "user-video-sei"
};
var Z = /* @__PURE__ */ ((n) => (n.LEAVE = "LEAVE", n.NETWORK_ERROR = "NETWORK_ERROR", n.SERVER_ERROR = "SERVER_ERROR", n.UID_BANNED = "UID_BANNED", n.IP_BANNED = "IP_BANNED", n.CHANNEL_BANNED = "CHANNEL_BANNED", n.FALLBACK = "FALLBACK", n))(Z || {});
class Or {
  constructor() {
    B(this, "callbackCollection", {});
  }
  checkRepeatCallback(s, t) {
    return s.find((e) => e === t);
  }
  addCallback(s, t) {
    const e = this.callbackCollection[s];
    e ? this.checkRepeatCallback(e, t) || e.push(t) : this.callbackCollection[s] = [t];
  }
  on(s, t) {
    if (!t || typeof t != "function") {
      console.warn("\u5FC5\u987B\u4F20\u5165\u56DE\u8C03\u51FD\u6570\uFF1A", t);
      return;
    }
    this.addCallback(s, t);
  }
  off(s, t) {
    const e = this.callbackCollection[s];
    if (!(!e || !e.length))
      if (typeof t == "function") {
        const r = e.findIndex((i) => i === t);
        r >= 0 && e.splice(r, 1);
      } else {
        console.warn("\u5FC5\u987B\u4F20\u5165\u56DE\u8C03\u51FD\u6570\uFF1A", t);
        return;
      }
  }
  removeAllListeners(s) {
    if (s) {
      const t = this.callbackCollection[s];
      t && t.length > 0 && (this.callbackCollection[s] = []);
    } else
      this.callbackCollection = {};
  }
  emit(s, ...t) {
    const e = this.callbackCollection[s];
    !e || !e.length || (t && t.length > 0 ? e.forEach((r) => {
      r && typeof r == "function" && r(...t);
    }) : e.forEach((r) => {
      r && typeof r == "function" && r();
    }));
  }
}
var Br = { exports: {} };
function En(n) {
  throw new Error('Could not dynamically require "' + n + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var xe = { exports: {} };
const kn = {}, Rn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kn
}, Symbol.toStringTag, { value: "Module" })), Pn = /* @__PURE__ */ Cn(Rn);
var bt;
function Te() {
  return bt || (bt = 1, function(n, s) {
    (function(t, e) {
      n.exports = e();
    })($, function() {
      var t = t || function(e, r) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof $ < "u" && $.crypto && (i = $.crypto), !i && typeof En == "function")
          try {
            i = Pn;
          } catch {
          }
        var o = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, a = Object.create || function() {
          function v() {
          }
          return function(b) {
            var C;
            return v.prototype = b, C = new v(), v.prototype = null, C;
          };
        }(), d = {}, u = d.lib = {}, p = u.Base = function() {
          return {
            extend: function(v) {
              var b = a(this);
              return v && b.mixIn(v), (!b.hasOwnProperty("init") || this.init === b.init) && (b.init = function() {
                b.$super.init.apply(this, arguments);
              }), b.init.prototype = b, b.$super = this, b;
            },
            create: function() {
              var v = this.extend();
              return v.init.apply(v, arguments), v;
            },
            init: function() {
            },
            mixIn: function(v) {
              for (var b in v)
                v.hasOwnProperty(b) && (this[b] = v[b]);
              v.hasOwnProperty("toString") && (this.toString = v.toString);
            },
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), l = u.WordArray = p.extend({
          init: function(v, b) {
            v = this.words = v || [], b != r ? this.sigBytes = b : this.sigBytes = v.length * 4;
          },
          toString: function(v) {
            return (v || f).stringify(this);
          },
          concat: function(v) {
            var b = this.words, C = v.words, S = this.sigBytes, T = v.sigBytes;
            if (this.clamp(), S % 4)
              for (var x = 0; x < T; x++) {
                var E = C[x >>> 2] >>> 24 - x % 4 * 8 & 255;
                b[S + x >>> 2] |= E << 24 - (S + x) % 4 * 8;
              }
            else
              for (var k = 0; k < T; k += 4)
                b[S + k >>> 2] = C[k >>> 2];
            return this.sigBytes += T, this;
          },
          clamp: function() {
            var v = this.words, b = this.sigBytes;
            v[b >>> 2] &= 4294967295 << 32 - b % 4 * 8, v.length = e.ceil(b / 4);
          },
          clone: function() {
            var v = p.clone.call(this);
            return v.words = this.words.slice(0), v;
          },
          random: function(v) {
            for (var b = [], C = 0; C < v; C += 4)
              b.push(o());
            return new l.init(b, v);
          }
        }), m = d.enc = {}, f = m.Hex = {
          stringify: function(v) {
            for (var b = v.words, C = v.sigBytes, S = [], T = 0; T < C; T++) {
              var x = b[T >>> 2] >>> 24 - T % 4 * 8 & 255;
              S.push((x >>> 4).toString(16)), S.push((x & 15).toString(16));
            }
            return S.join("");
          },
          parse: function(v) {
            for (var b = v.length, C = [], S = 0; S < b; S += 2)
              C[S >>> 3] |= parseInt(v.substr(S, 2), 16) << 24 - S % 8 * 4;
            return new l.init(C, b / 2);
          }
        }, h = m.Latin1 = {
          stringify: function(v) {
            for (var b = v.words, C = v.sigBytes, S = [], T = 0; T < C; T++) {
              var x = b[T >>> 2] >>> 24 - T % 4 * 8 & 255;
              S.push(String.fromCharCode(x));
            }
            return S.join("");
          },
          parse: function(v) {
            for (var b = v.length, C = [], S = 0; S < b; S++)
              C[S >>> 2] |= (v.charCodeAt(S) & 255) << 24 - S % 4 * 8;
            return new l.init(C, b);
          }
        }, g = m.Utf8 = {
          stringify: function(v) {
            try {
              return decodeURIComponent(escape(h.stringify(v)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          parse: function(v) {
            return h.parse(unescape(encodeURIComponent(v)));
          }
        }, c = u.BufferedBlockAlgorithm = p.extend({
          reset: function() {
            this._data = new l.init(), this._nDataBytes = 0;
          },
          _append: function(v) {
            typeof v == "string" && (v = g.parse(v)), this._data.concat(v), this._nDataBytes += v.sigBytes;
          },
          _process: function(v) {
            var b, C = this._data, S = C.words, T = C.sigBytes, x = this.blockSize, E = x * 4, k = T / E;
            v ? k = e.ceil(k) : k = e.max((k | 0) - this._minBufferSize, 0);
            var R = k * x, P = e.min(R * 4, T);
            if (R) {
              for (var A = 0; A < R; A += x)
                this._doProcessBlock(S, A);
              b = S.splice(0, R), C.sigBytes -= P;
            }
            return new l.init(b, P);
          },
          clone: function() {
            var v = p.clone.call(this);
            return v._data = this._data.clone(), v;
          },
          _minBufferSize: 0
        });
        u.Hasher = c.extend({
          cfg: p.extend(),
          init: function(v) {
            this.cfg = this.cfg.extend(v), this.reset();
          },
          reset: function() {
            c.reset.call(this), this._doReset();
          },
          update: function(v) {
            return this._append(v), this._process(), this;
          },
          finalize: function(v) {
            v && this._append(v);
            var b = this._doFinalize();
            return b;
          },
          blockSize: 16,
          _createHelper: function(v) {
            return function(b, C) {
              return new v.init(C).finalize(b);
            };
          },
          _createHmacHelper: function(v) {
            return function(b, C) {
              return new y.HMAC.init(v, C).finalize(b);
            };
          }
        });
        var y = d.algo = {};
        return d;
      }(Math);
      return t;
    });
  }(xe)), xe.exports;
}
var _e = { exports: {} }, St;
function xn() {
  return St || (St = 1, function(n, s) {
    (function(t, e) {
      n.exports = e(Te());
    })($, function(t) {
      return function() {
        var e = t, r = e.lib, i = r.WordArray, o = r.Hasher, a = e.algo, d = [], u = a.SHA1 = o.extend({
          _doReset: function() {
            this._hash = new i.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(p, l) {
            for (var m = this._hash.words, f = m[0], h = m[1], g = m[2], c = m[3], y = m[4], v = 0; v < 80; v++) {
              if (v < 16)
                d[v] = p[l + v] | 0;
              else {
                var b = d[v - 3] ^ d[v - 8] ^ d[v - 14] ^ d[v - 16];
                d[v] = b << 1 | b >>> 31;
              }
              var C = (f << 5 | f >>> 27) + y + d[v];
              v < 20 ? C += (h & g | ~h & c) + 1518500249 : v < 40 ? C += (h ^ g ^ c) + 1859775393 : v < 60 ? C += (h & g | h & c | g & c) - 1894007588 : C += (h ^ g ^ c) - 899497514, y = c, c = g, g = h << 30 | h >>> 2, h = f, f = C;
            }
            m[0] = m[0] + f | 0, m[1] = m[1] + h | 0, m[2] = m[2] + g | 0, m[3] = m[3] + c | 0, m[4] = m[4] + y | 0;
          },
          _doFinalize: function() {
            var p = this._data, l = p.words, m = this._nDataBytes * 8, f = p.sigBytes * 8;
            return l[f >>> 5] |= 128 << 24 - f % 32, l[(f + 64 >>> 9 << 4) + 14] = Math.floor(m / 4294967296), l[(f + 64 >>> 9 << 4) + 15] = m, p.sigBytes = l.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var p = o.clone.call(this);
            return p._hash = this._hash.clone(), p;
          }
        });
        e.SHA1 = o._createHelper(u), e.HmacSHA1 = o._createHmacHelper(u);
      }(), t.SHA1;
    });
  }(_e)), _e.exports;
}
var Ae = { exports: {} }, Tt;
function _n() {
  return Tt || (Tt = 1, function(n, s) {
    (function(t, e) {
      n.exports = e(Te());
    })($, function(t) {
      (function() {
        var e = t, r = e.lib, i = r.Base, o = e.enc, a = o.Utf8, d = e.algo;
        d.HMAC = i.extend({
          init: function(u, p) {
            u = this._hasher = new u.init(), typeof p == "string" && (p = a.parse(p));
            var l = u.blockSize, m = l * 4;
            p.sigBytes > m && (p = u.finalize(p)), p.clamp();
            for (var f = this._oKey = p.clone(), h = this._iKey = p.clone(), g = f.words, c = h.words, y = 0; y < l; y++)
              g[y] ^= 1549556828, c[y] ^= 909522486;
            f.sigBytes = h.sigBytes = m, this.reset();
          },
          reset: function() {
            var u = this._hasher;
            u.reset(), u.update(this._iKey);
          },
          update: function(u) {
            return this._hasher.update(u), this;
          },
          finalize: function(u) {
            var p = this._hasher, l = p.finalize(u);
            p.reset();
            var m = p.finalize(this._oKey.clone().concat(l));
            return m;
          }
        });
      })();
    });
  }(Ae)), Ae.exports;
}
(function(n, s) {
  (function(t, e, r) {
    n.exports = e(Te(), xn(), _n());
  })($, function(t) {
    return t.HmacSHA1;
  });
})(Br);
const An = Br.exports;
var Nr = { exports: {} };
(function(n, s) {
  (function(t, e) {
    n.exports = e(Te());
  })($, function(t) {
    return t.enc.Hex;
  });
})(Nr);
const Dn = Nr.exports, ee = -1, K = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "+",
  "/"
];
function Mn(n) {
  const s = n;
  let t = 0;
  function e() {
    if (!s || t >= s.length)
      return ee;
    const d = s.charCodeAt(t) & 255;
    return t++, d;
  }
  let r = "";
  const i = new Array(3);
  let o = 0, a = !1;
  for (; !a && (i[0] = e()) !== ee; )
    i[1] = e(), i[2] = e(), r += K[i[0] >> 2], i[1] !== ee ? (r += K[i[0] << 4 & 48 | i[1] >> 4], i[2] !== ee ? (r += K[i[1] << 2 & 60 | i[2] >> 6], r += K[i[2] & 63]) : (r += K[i[1] << 2 & 60], r += "=", a = !0)) : (r += K[i[0] << 4 & 48], r += "=", r += "=", a = !0), o += 4, o >= 76 && (r += `
`, o = 0);
  return r;
}
function In(n, s) {
  const e = An(n, s).toString(Dn);
  return Mn(e);
}
var Fr = { exports: {} }, ut = { exports: {} }, Ur = function(s, t) {
  return function() {
    for (var r = new Array(arguments.length), i = 0; i < r.length; i++)
      r[i] = arguments[i];
    return s.apply(t, r);
  };
}, On = Ur, J = Object.prototype.toString;
function pt(n) {
  return J.call(n) === "[object Array]";
}
function rt(n) {
  return typeof n > "u";
}
function Bn(n) {
  return n !== null && !rt(n) && n.constructor !== null && !rt(n.constructor) && typeof n.constructor.isBuffer == "function" && n.constructor.isBuffer(n);
}
function Nn(n) {
  return J.call(n) === "[object ArrayBuffer]";
}
function Fn(n) {
  return typeof FormData < "u" && n instanceof FormData;
}
function Un(n) {
  var s;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? s = ArrayBuffer.isView(n) : s = n && n.buffer && n.buffer instanceof ArrayBuffer, s;
}
function Ln(n) {
  return typeof n == "string";
}
function wn(n) {
  return typeof n == "number";
}
function Lr(n) {
  return n !== null && typeof n == "object";
}
function ve(n) {
  if (J.call(n) !== "[object Object]")
    return !1;
  var s = Object.getPrototypeOf(n);
  return s === null || s === Object.prototype;
}
function jn(n) {
  return J.call(n) === "[object Date]";
}
function Vn(n) {
  return J.call(n) === "[object File]";
}
function qn(n) {
  return J.call(n) === "[object Blob]";
}
function wr(n) {
  return J.call(n) === "[object Function]";
}
function Hn(n) {
  return Lr(n) && wr(n.pipe);
}
function zn(n) {
  return typeof URLSearchParams < "u" && n instanceof URLSearchParams;
}
function $n(n) {
  return n.trim ? n.trim() : n.replace(/^\s+|\s+$/g, "");
}
function Wn() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function dt(n, s) {
  if (!(n === null || typeof n > "u"))
    if (typeof n != "object" && (n = [n]), pt(n))
      for (var t = 0, e = n.length; t < e; t++)
        s.call(null, n[t], t, n);
    else
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && s.call(null, n[r], r, n);
}
function nt() {
  var n = {};
  function s(r, i) {
    ve(n[i]) && ve(r) ? n[i] = nt(n[i], r) : ve(r) ? n[i] = nt({}, r) : pt(r) ? n[i] = r.slice() : n[i] = r;
  }
  for (var t = 0, e = arguments.length; t < e; t++)
    dt(arguments[t], s);
  return n;
}
function Gn(n, s, t) {
  return dt(s, function(r, i) {
    t && typeof r == "function" ? n[i] = On(r, t) : n[i] = r;
  }), n;
}
function Jn(n) {
  return n.charCodeAt(0) === 65279 && (n = n.slice(1)), n;
}
var H = {
  isArray: pt,
  isArrayBuffer: Nn,
  isBuffer: Bn,
  isFormData: Fn,
  isArrayBufferView: Un,
  isString: Ln,
  isNumber: wn,
  isObject: Lr,
  isPlainObject: ve,
  isUndefined: rt,
  isDate: jn,
  isFile: Vn,
  isBlob: qn,
  isFunction: wr,
  isStream: Hn,
  isURLSearchParams: zn,
  isStandardBrowserEnv: Wn,
  forEach: dt,
  merge: nt,
  extend: Gn,
  trim: $n,
  stripBOM: Jn
}, X = H;
function Et(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var jr = function(s, t, e) {
  if (!t)
    return s;
  var r;
  if (e)
    r = e(t);
  else if (X.isURLSearchParams(t))
    r = t.toString();
  else {
    var i = [];
    X.forEach(t, function(d, u) {
      d === null || typeof d > "u" || (X.isArray(d) ? u = u + "[]" : d = [d], X.forEach(d, function(l) {
        X.isDate(l) ? l = l.toISOString() : X.isObject(l) && (l = JSON.stringify(l)), i.push(Et(u) + "=" + Et(l));
      }));
    }), r = i.join("&");
  }
  if (r) {
    var o = s.indexOf("#");
    o !== -1 && (s = s.slice(0, o)), s += (s.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return s;
}, Kn = H;
function Ee() {
  this.handlers = [];
}
Ee.prototype.use = function(s, t, e) {
  return this.handlers.push({
    fulfilled: s,
    rejected: t,
    synchronous: e ? e.synchronous : !1,
    runWhen: e ? e.runWhen : null
  }), this.handlers.length - 1;
};
Ee.prototype.eject = function(s) {
  this.handlers[s] && (this.handlers[s] = null);
};
Ee.prototype.forEach = function(s) {
  Kn.forEach(this.handlers, function(e) {
    e !== null && s(e);
  });
};
var Xn = Ee, Yn = H, Zn = function(s, t) {
  Yn.forEach(s, function(r, i) {
    i !== t && i.toUpperCase() === t.toUpperCase() && (s[t] = r, delete s[i]);
  });
}, Vr = function(s, t, e, r, i) {
  return s.config = t, e && (s.code = e), s.request = r, s.response = i, s.isAxiosError = !0, s.toJSON = function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, s;
}, De, kt;
function qr() {
  if (kt)
    return De;
  kt = 1;
  var n = Vr;
  return De = function(t, e, r, i, o) {
    var a = new Error(t);
    return n(a, e, r, i, o);
  }, De;
}
var Me, Rt;
function Qn() {
  if (Rt)
    return Me;
  Rt = 1;
  var n = qr();
  return Me = function(t, e, r) {
    var i = r.config.validateStatus;
    !r.status || !i || i(r.status) ? t(r) : e(n(
      "Request failed with status code " + r.status,
      r.config,
      null,
      r.request,
      r
    ));
  }, Me;
}
var Ie, Pt;
function ei() {
  if (Pt)
    return Ie;
  Pt = 1;
  var n = H;
  return Ie = n.isStandardBrowserEnv() ? function() {
    return {
      write: function(e, r, i, o, a, d) {
        var u = [];
        u.push(e + "=" + encodeURIComponent(r)), n.isNumber(i) && u.push("expires=" + new Date(i).toGMTString()), n.isString(o) && u.push("path=" + o), n.isString(a) && u.push("domain=" + a), d === !0 && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function(e) {
        var r = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(e) {
        this.write(e, "", Date.now() - 864e5);
      }
    };
  }() : function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }(), Ie;
}
var Oe, xt;
function ti() {
  return xt || (xt = 1, Oe = function(s) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(s);
  }), Oe;
}
var Be, _t;
function ri() {
  return _t || (_t = 1, Be = function(s, t) {
    return t ? s.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : s;
  }), Be;
}
var Ne, At;
function ni() {
  if (At)
    return Ne;
  At = 1;
  var n = ti(), s = ri();
  return Ne = function(e, r) {
    return e && !n(r) ? s(e, r) : r;
  }, Ne;
}
var Fe, Dt;
function ii() {
  if (Dt)
    return Fe;
  Dt = 1;
  var n = H, s = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return Fe = function(e) {
    var r = {}, i, o, a;
    return e && n.forEach(e.split(`
`), function(u) {
      if (a = u.indexOf(":"), i = n.trim(u.substr(0, a)).toLowerCase(), o = n.trim(u.substr(a + 1)), i) {
        if (r[i] && s.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? r[i] = (r[i] ? r[i] : []).concat([o]) : r[i] = r[i] ? r[i] + ", " + o : o;
      }
    }), r;
  }, Fe;
}
var Ue, Mt;
function si() {
  if (Mt)
    return Ue;
  Mt = 1;
  var n = H;
  return Ue = n.isStandardBrowserEnv() ? function() {
    var t = /(msie|trident)/i.test(navigator.userAgent), e = document.createElement("a"), r;
    function i(o) {
      var a = o;
      return t && (e.setAttribute("href", a), a = e.href), e.setAttribute("href", a), {
        href: e.href,
        protocol: e.protocol ? e.protocol.replace(/:$/, "") : "",
        host: e.host,
        search: e.search ? e.search.replace(/^\?/, "") : "",
        hash: e.hash ? e.hash.replace(/^#/, "") : "",
        hostname: e.hostname,
        port: e.port,
        pathname: e.pathname.charAt(0) === "/" ? e.pathname : "/" + e.pathname
      };
    }
    return r = i(window.location.href), function(a) {
      var d = n.isString(a) ? i(a) : a;
      return d.protocol === r.protocol && d.host === r.host;
    };
  }() : function() {
    return function() {
      return !0;
    };
  }(), Ue;
}
var Le, It;
function ke() {
  if (It)
    return Le;
  It = 1;
  function n(s) {
    this.message = s;
  }
  return n.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, n.prototype.__CANCEL__ = !0, Le = n, Le;
}
var we, Ot;
function Bt() {
  if (Ot)
    return we;
  Ot = 1;
  var n = H, s = Qn(), t = ei(), e = jr, r = ni(), i = ii(), o = si(), a = qr(), d = Re(), u = ke();
  return we = function(l) {
    return new Promise(function(f, h) {
      var g = l.data, c = l.headers, y = l.responseType, v;
      function b() {
        l.cancelToken && l.cancelToken.unsubscribe(v), l.signal && l.signal.removeEventListener("abort", v);
      }
      n.isFormData(g) && delete c["Content-Type"];
      var C = new XMLHttpRequest();
      if (l.auth) {
        var S = l.auth.username || "", T = l.auth.password ? unescape(encodeURIComponent(l.auth.password)) : "";
        c.Authorization = "Basic " + btoa(S + ":" + T);
      }
      var x = r(l.baseURL, l.url);
      C.open(l.method.toUpperCase(), e(x, l.params, l.paramsSerializer), !0), C.timeout = l.timeout;
      function E() {
        if (!!C) {
          var R = "getAllResponseHeaders" in C ? i(C.getAllResponseHeaders()) : null, P = !y || y === "text" || y === "json" ? C.responseText : C.response, A = {
            data: P,
            status: C.status,
            statusText: C.statusText,
            headers: R,
            config: l,
            request: C
          };
          s(function(M) {
            f(M), b();
          }, function(M) {
            h(M), b();
          }, A), C = null;
        }
      }
      if ("onloadend" in C ? C.onloadend = E : C.onreadystatechange = function() {
        !C || C.readyState !== 4 || C.status === 0 && !(C.responseURL && C.responseURL.indexOf("file:") === 0) || setTimeout(E);
      }, C.onabort = function() {
        !C || (h(a("Request aborted", l, "ECONNABORTED", C)), C = null);
      }, C.onerror = function() {
        h(a("Network Error", l, null, C)), C = null;
      }, C.ontimeout = function() {
        var P = l.timeout ? "timeout of " + l.timeout + "ms exceeded" : "timeout exceeded", A = l.transitional || d.transitional;
        l.timeoutErrorMessage && (P = l.timeoutErrorMessage), h(a(
          P,
          l,
          A.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          C
        )), C = null;
      }, n.isStandardBrowserEnv()) {
        var k = (l.withCredentials || o(x)) && l.xsrfCookieName ? t.read(l.xsrfCookieName) : void 0;
        k && (c[l.xsrfHeaderName] = k);
      }
      "setRequestHeader" in C && n.forEach(c, function(P, A) {
        typeof g > "u" && A.toLowerCase() === "content-type" ? delete c[A] : C.setRequestHeader(A, P);
      }), n.isUndefined(l.withCredentials) || (C.withCredentials = !!l.withCredentials), y && y !== "json" && (C.responseType = l.responseType), typeof l.onDownloadProgress == "function" && C.addEventListener("progress", l.onDownloadProgress), typeof l.onUploadProgress == "function" && C.upload && C.upload.addEventListener("progress", l.onUploadProgress), (l.cancelToken || l.signal) && (v = function(R) {
        !C || (h(!R || R && R.type ? new u("canceled") : R), C.abort(), C = null);
      }, l.cancelToken && l.cancelToken.subscribe(v), l.signal && (l.signal.aborted ? v() : l.signal.addEventListener("abort", v))), g || (g = null), C.send(g);
    });
  }, we;
}
var je, Nt;
function Re() {
  if (Nt)
    return je;
  Nt = 1;
  var n = H, s = Zn, t = Vr, e = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function r(d, u) {
    !n.isUndefined(d) && n.isUndefined(d["Content-Type"]) && (d["Content-Type"] = u);
  }
  function i() {
    var d;
    return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (d = Bt()), d;
  }
  function o(d, u, p) {
    if (n.isString(d))
      try {
        return (u || JSON.parse)(d), n.trim(d);
      } catch (l) {
        if (l.name !== "SyntaxError")
          throw l;
      }
    return (p || JSON.stringify)(d);
  }
  var a = {
    transitional: {
      silentJSONParsing: !0,
      forcedJSONParsing: !0,
      clarifyTimeoutError: !1
    },
    adapter: i(),
    transformRequest: [function(u, p) {
      return s(p, "Accept"), s(p, "Content-Type"), n.isFormData(u) || n.isArrayBuffer(u) || n.isBuffer(u) || n.isStream(u) || n.isFile(u) || n.isBlob(u) ? u : n.isArrayBufferView(u) ? u.buffer : n.isURLSearchParams(u) ? (r(p, "application/x-www-form-urlencoded;charset=utf-8"), u.toString()) : n.isObject(u) || p && p["Content-Type"] === "application/json" ? (r(p, "application/json"), o(u)) : u;
    }],
    transformResponse: [function(u) {
      var p = this.transitional || a.transitional, l = p && p.silentJSONParsing, m = p && p.forcedJSONParsing, f = !l && this.responseType === "json";
      if (f || m && n.isString(u) && u.length)
        try {
          return JSON.parse(u);
        } catch (h) {
          if (f)
            throw h.name === "SyntaxError" ? t(h, this, "E_JSON_PARSE") : h;
        }
      return u;
    }],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function(u) {
      return u >= 200 && u < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  return n.forEach(["delete", "get", "head"], function(u) {
    a.headers[u] = {};
  }), n.forEach(["post", "put", "patch"], function(u) {
    a.headers[u] = n.merge(e);
  }), je = a, je;
}
var oi = H, ai = Re(), ci = function(s, t, e) {
  var r = this || ai;
  return oi.forEach(e, function(o) {
    s = o.call(r, s, t);
  }), s;
}, Ve, Ft;
function Hr() {
  return Ft || (Ft = 1, Ve = function(s) {
    return !!(s && s.__CANCEL__);
  }), Ve;
}
var Ut = H, qe = ci, ui = Hr(), pi = Re(), di = ke();
function He(n) {
  if (n.cancelToken && n.cancelToken.throwIfRequested(), n.signal && n.signal.aborted)
    throw new di("canceled");
}
var fi = function(s) {
  He(s), s.headers = s.headers || {}, s.data = qe.call(
    s,
    s.data,
    s.headers,
    s.transformRequest
  ), s.headers = Ut.merge(
    s.headers.common || {},
    s.headers[s.method] || {},
    s.headers
  ), Ut.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(r) {
      delete s.headers[r];
    }
  );
  var t = s.adapter || pi.adapter;
  return t(s).then(function(r) {
    return He(s), r.data = qe.call(
      s,
      r.data,
      r.headers,
      s.transformResponse
    ), r;
  }, function(r) {
    return ui(r) || (He(s), r && r.response && (r.response.data = qe.call(
      s,
      r.response.data,
      r.response.headers,
      s.transformResponse
    ))), Promise.reject(r);
  });
}, j = H, zr = function(s, t) {
  t = t || {};
  var e = {};
  function r(p, l) {
    return j.isPlainObject(p) && j.isPlainObject(l) ? j.merge(p, l) : j.isPlainObject(l) ? j.merge({}, l) : j.isArray(l) ? l.slice() : l;
  }
  function i(p) {
    if (j.isUndefined(t[p])) {
      if (!j.isUndefined(s[p]))
        return r(void 0, s[p]);
    } else
      return r(s[p], t[p]);
  }
  function o(p) {
    if (!j.isUndefined(t[p]))
      return r(void 0, t[p]);
  }
  function a(p) {
    if (j.isUndefined(t[p])) {
      if (!j.isUndefined(s[p]))
        return r(void 0, s[p]);
    } else
      return r(void 0, t[p]);
  }
  function d(p) {
    if (p in t)
      return r(s[p], t[p]);
    if (p in s)
      return r(void 0, s[p]);
  }
  var u = {
    url: o,
    method: o,
    data: o,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: d
  };
  return j.forEach(Object.keys(s).concat(Object.keys(t)), function(l) {
    var m = u[l] || i, f = m(l);
    j.isUndefined(f) && m !== d || (e[l] = f);
  }), e;
}, ze, Lt;
function $r() {
  return Lt || (Lt = 1, ze = {
    version: "0.24.0"
  }), ze;
}
var hi = $r().version, ft = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(n, s) {
  ft[n] = function(e) {
    return typeof e === n || "a" + (s < 1 ? "n " : " ") + n;
  };
});
var wt = {};
ft.transitional = function(s, t, e) {
  function r(i, o) {
    return "[Axios v" + hi + "] Transitional option '" + i + "'" + o + (e ? ". " + e : "");
  }
  return function(i, o, a) {
    if (s === !1)
      throw new Error(r(o, " has been removed" + (t ? " in " + t : "")));
    return t && !wt[o] && (wt[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), s ? s(i, o, a) : !0;
  };
};
function li(n, s, t) {
  if (typeof n != "object")
    throw new TypeError("options must be an object");
  for (var e = Object.keys(n), r = e.length; r-- > 0; ) {
    var i = e[r], o = s[i];
    if (o) {
      var a = n[i], d = a === void 0 || o(a, i, n);
      if (d !== !0)
        throw new TypeError("option " + i + " must be " + d);
      continue;
    }
    if (t !== !0)
      throw Error("Unknown option " + i);
  }
}
var mi = {
  assertOptions: li,
  validators: ft
}, Wr = H, gi = jr, jt = Xn, Vt = fi, Pe = zr, Gr = mi, Y = Gr.validators;
function ae(n) {
  this.defaults = n, this.interceptors = {
    request: new jt(),
    response: new jt()
  };
}
ae.prototype.request = function(s) {
  typeof s == "string" ? (s = arguments[1] || {}, s.url = arguments[0]) : s = s || {}, s = Pe(this.defaults, s), s.method ? s.method = s.method.toLowerCase() : this.defaults.method ? s.method = this.defaults.method.toLowerCase() : s.method = "get";
  var t = s.transitional;
  t !== void 0 && Gr.assertOptions(t, {
    silentJSONParsing: Y.transitional(Y.boolean),
    forcedJSONParsing: Y.transitional(Y.boolean),
    clarifyTimeoutError: Y.transitional(Y.boolean)
  }, !1);
  var e = [], r = !0;
  this.interceptors.request.forEach(function(m) {
    typeof m.runWhen == "function" && m.runWhen(s) === !1 || (r = r && m.synchronous, e.unshift(m.fulfilled, m.rejected));
  });
  var i = [];
  this.interceptors.response.forEach(function(m) {
    i.push(m.fulfilled, m.rejected);
  });
  var o;
  if (!r) {
    var a = [Vt, void 0];
    for (Array.prototype.unshift.apply(a, e), a = a.concat(i), o = Promise.resolve(s); a.length; )
      o = o.then(a.shift(), a.shift());
    return o;
  }
  for (var d = s; e.length; ) {
    var u = e.shift(), p = e.shift();
    try {
      d = u(d);
    } catch (l) {
      p(l);
      break;
    }
  }
  try {
    o = Vt(d);
  } catch (l) {
    return Promise.reject(l);
  }
  for (; i.length; )
    o = o.then(i.shift(), i.shift());
  return o;
};
ae.prototype.getUri = function(s) {
  return s = Pe(this.defaults, s), gi(s.url, s.params, s.paramsSerializer).replace(/^\?/, "");
};
Wr.forEach(["delete", "get", "head", "options"], function(s) {
  ae.prototype[s] = function(t, e) {
    return this.request(Pe(e || {}, {
      method: s,
      url: t,
      data: (e || {}).data
    }));
  };
});
Wr.forEach(["post", "put", "patch"], function(s) {
  ae.prototype[s] = function(t, e, r) {
    return this.request(Pe(r || {}, {
      method: s,
      url: t,
      data: e
    }));
  };
});
var yi = ae, $e, qt;
function vi() {
  if (qt)
    return $e;
  qt = 1;
  var n = ke();
  function s(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var e;
    this.promise = new Promise(function(o) {
      e = o;
    });
    var r = this;
    this.promise.then(function(i) {
      if (!!r._listeners) {
        var o, a = r._listeners.length;
        for (o = 0; o < a; o++)
          r._listeners[o](i);
        r._listeners = null;
      }
    }), this.promise.then = function(i) {
      var o, a = new Promise(function(d) {
        r.subscribe(d), o = d;
      }).then(i);
      return a.cancel = function() {
        r.unsubscribe(o);
      }, a;
    }, t(function(o) {
      r.reason || (r.reason = new n(o), e(r.reason));
    });
  }
  return s.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, s.prototype.subscribe = function(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }, s.prototype.unsubscribe = function(e) {
    if (!!this._listeners) {
      var r = this._listeners.indexOf(e);
      r !== -1 && this._listeners.splice(r, 1);
    }
  }, s.source = function() {
    var e, r = new s(function(o) {
      e = o;
    });
    return {
      token: r,
      cancel: e
    };
  }, $e = s, $e;
}
var We, Ht;
function Ci() {
  return Ht || (Ht = 1, We = function(s) {
    return function(e) {
      return s.apply(null, e);
    };
  }), We;
}
var Ge, zt;
function bi() {
  return zt || (zt = 1, Ge = function(s) {
    return typeof s == "object" && s.isAxiosError === !0;
  }), Ge;
}
var $t = H, Si = Ur, Ce = yi, Ti = zr, Ei = Re();
function Jr(n) {
  var s = new Ce(n), t = Si(Ce.prototype.request, s);
  return $t.extend(t, Ce.prototype, s), $t.extend(t, s), t.create = function(r) {
    return Jr(Ti(n, r));
  }, t;
}
var z = Jr(Ei);
z.Axios = Ce;
z.Cancel = ke();
z.CancelToken = vi();
z.isCancel = Hr();
z.VERSION = $r().version;
z.all = function(s) {
  return Promise.all(s);
};
z.spread = Ci();
z.isAxiosError = bi();
ut.exports = z;
ut.exports.default = z;
(function(n) {
  n.exports = ut.exports;
})(Fr);
const ki = /* @__PURE__ */ vn(Fr.exports), Ri = {
  headers: {
    "Content-Type": "application/json"
  }
}, Pi = (n) => {
  const { data: { err: s, data: t, msg: e } } = n;
  return s ? Promise.reject(new Error(s + ":" + e)) : t;
}, xi = () => {
  const n = "\u7F51\u7EDC\u8FDE\u63A5\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5";
  return Promise.reject(new Error(n));
}, Kr = ki.create(Ri);
Kr.interceptors.response.use(Pi, xi);
const _i = (n, s, t, e) => Kr.post("/leiaapi/createToken", s, {
  baseURL: n,
  headers: {
    Authorization: t
  },
  signal: e
});
var Xr = { exports: {} };
/*!
 * Socket.IO v2.5.0
 * (c) 2014-2021 Guillermo Rauch
 * Released under the MIT License.
 */
(function(n, s) {
  (function(t, e) {
    n.exports = e();
  })($, function() {
    return function(t) {
      function e(i) {
        if (r[i])
          return r[i].exports;
        var o = r[i] = { exports: {}, id: i, loaded: !1 };
        return t[i].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
      }
      var r = {};
      return e.m = t, e.c = r, e.p = "", e(0);
    }([function(t, e, r) {
      function i(l, m) {
        typeof l == "object" && (m = l, l = void 0), m = m || {};
        var f, h = o(l), g = h.source, c = h.id, y = h.path, v = p[c] && y in p[c].nsps, b = m.forceNew || m["force new connection"] || m.multiplex === !1 || v;
        return b ? (u("ignoring socket cache for %s", g), f = d(g, m)) : (p[c] || (u("new io instance for %s", g), p[c] = d(g, m)), f = p[c]), h.query && !m.query && (m.query = h.query), f.socket(h.path, m);
      }
      var o = r(1), a = r(7), d = r(12), u = r(3)("socket.io-client");
      t.exports = e = i;
      var p = e.managers = {};
      e.protocol = a.protocol, e.connect = i, e.Manager = r(12), e.Socket = r(37);
    }, function(t, e, r) {
      function i(d, u) {
        var p = d;
        u = u || typeof location < "u" && location, d == null && (d = u.protocol + "//" + u.host), typeof d == "string" && (d.charAt(0) === "/" && (d = d.charAt(1) === "/" ? u.protocol + d : u.host + d), /^(https?|wss?):\/\//.test(d) || (a("protocol-less url %s", d), d = typeof u < "u" ? u.protocol + "//" + d : "https://" + d), a("parse %s", d), p = o(d)), p.port || (/^(http|ws)$/.test(p.protocol) ? p.port = "80" : /^(http|ws)s$/.test(p.protocol) && (p.port = "443")), p.path = p.path || "/";
        var l = p.host.indexOf(":") !== -1, m = l ? "[" + p.host + "]" : p.host;
        return p.id = p.protocol + "://" + m + ":" + p.port, p.href = p.protocol + "://" + m + (u && u.port === p.port ? "" : ":" + p.port), p;
      }
      var o = r(2), a = r(3)("socket.io-client:url");
      t.exports = i;
    }, function(t, e) {
      function r(d, u) {
        var p = /\/{2,9}/g, l = u.replace(p, "/").split("/");
        return u.substr(0, 1) != "/" && u.length !== 0 || l.splice(0, 1), u.substr(u.length - 1, 1) == "/" && l.splice(l.length - 1, 1), l;
      }
      function i(d, u) {
        var p = {};
        return u.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(l, m, f) {
          m && (p[m] = f);
        }), p;
      }
      var o = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, a = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];
      t.exports = function(d) {
        var u = d, p = d.indexOf("["), l = d.indexOf("]");
        p != -1 && l != -1 && (d = d.substring(0, p) + d.substring(p, l).replace(/:/g, ";") + d.substring(l, d.length));
        for (var m = o.exec(d || ""), f = {}, h = 14; h--; )
          f[a[h]] = m[h] || "";
        return p != -1 && l != -1 && (f.source = u, f.host = f.host.substring(1, f.host.length - 1).replace(/;/g, ":"), f.authority = f.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), f.ipv6uri = !0), f.pathNames = r(f, f.path), f.queryKey = i(f, f.query), f;
      };
    }, function(t, e, r) {
      (function(i) {
        function o() {
          return !(typeof window > "u" || !window.process || window.process.type !== "renderer") || (typeof navigator > "u" || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && (typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
        }
        function a(f) {
          var h = this.useColors;
          if (f[0] = (h ? "%c" : "") + this.namespace + (h ? " %c" : " ") + f[0] + (h ? "%c " : " ") + "+" + e.humanize(this.diff), h) {
            var g = "color: " + this.color;
            f.splice(1, 0, g, "color: inherit");
            var c = 0, y = 0;
            f[0].replace(/%[a-zA-Z%]/g, function(v) {
              v !== "%%" && (c++, v === "%c" && (y = c));
            }), f.splice(y, 0, g);
          }
        }
        function d() {
          return (typeof console > "u" ? "undefined" : m(console)) === "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
        }
        function u(f) {
          try {
            f == null ? e.storage.removeItem("debug") : e.storage.debug = f;
          } catch {
          }
        }
        function p() {
          var f;
          try {
            f = e.storage.debug;
          } catch {
          }
          return !f && typeof i < "u" && "env" in i && (f = i.env.DEBUG), f;
        }
        function l() {
          try {
            return window.localStorage;
          } catch {
          }
        }
        var m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
          return typeof f;
        } : function(f) {
          return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
        };
        e = t.exports = r(5), e.log = d, e.formatArgs = a, e.save = u, e.load = p, e.useColors = o, e.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : l(), e.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e.formatters.j = function(f) {
          try {
            return JSON.stringify(f);
          } catch (h) {
            return "[UnexpectedJSONParseError]: " + h.message;
          }
        }, e.enable(p());
      }).call(e, r(4));
    }, function(t, e) {
      function r() {
        throw new Error("setTimeout has not been defined");
      }
      function i() {
        throw new Error("clearTimeout has not been defined");
      }
      function o(b) {
        if (m === setTimeout)
          return setTimeout(b, 0);
        if ((m === r || !m) && setTimeout)
          return m = setTimeout, setTimeout(b, 0);
        try {
          return m(b, 0);
        } catch {
          try {
            return m.call(null, b, 0);
          } catch {
            return m.call(this, b, 0);
          }
        }
      }
      function a(b) {
        if (f === clearTimeout)
          return clearTimeout(b);
        if ((f === i || !f) && clearTimeout)
          return f = clearTimeout, clearTimeout(b);
        try {
          return f(b);
        } catch {
          try {
            return f.call(null, b);
          } catch {
            return f.call(this, b);
          }
        }
      }
      function d() {
        y && g && (y = !1, g.length ? c = g.concat(c) : v = -1, c.length && u());
      }
      function u() {
        if (!y) {
          var b = o(d);
          y = !0;
          for (var C = c.length; C; ) {
            for (g = c, c = []; ++v < C; )
              g && g[v].run();
            v = -1, C = c.length;
          }
          g = null, y = !1, a(b);
        }
      }
      function p(b, C) {
        this.fun = b, this.array = C;
      }
      function l() {
      }
      var m, f, h = t.exports = {};
      (function() {
        try {
          m = typeof setTimeout == "function" ? setTimeout : r;
        } catch {
          m = r;
        }
        try {
          f = typeof clearTimeout == "function" ? clearTimeout : i;
        } catch {
          f = i;
        }
      })();
      var g, c = [], y = !1, v = -1;
      h.nextTick = function(b) {
        var C = new Array(arguments.length - 1);
        if (arguments.length > 1)
          for (var S = 1; S < arguments.length; S++)
            C[S - 1] = arguments[S];
        c.push(new p(b, C)), c.length !== 1 || y || o(u);
      }, p.prototype.run = function() {
        this.fun.apply(null, this.array);
      }, h.title = "browser", h.browser = !0, h.env = {}, h.argv = [], h.version = "", h.versions = {}, h.on = l, h.addListener = l, h.once = l, h.off = l, h.removeListener = l, h.removeAllListeners = l, h.emit = l, h.prependListener = l, h.prependOnceListener = l, h.listeners = function(b) {
        return [];
      }, h.binding = function(b) {
        throw new Error("process.binding is not supported");
      }, h.cwd = function() {
        return "/";
      }, h.chdir = function(b) {
        throw new Error("process.chdir is not supported");
      }, h.umask = function() {
        return 0;
      };
    }, function(t, e, r) {
      function i(m) {
        var f, h = 0;
        for (f in m)
          h = (h << 5) - h + m.charCodeAt(f), h |= 0;
        return e.colors[Math.abs(h) % e.colors.length];
      }
      function o(m) {
        function f() {
          if (f.enabled) {
            var g = f, c = +new Date(), y = c - (h || c);
            g.diff = y, g.prev = h, g.curr = c, h = c;
            for (var v = new Array(arguments.length), b = 0; b < v.length; b++)
              v[b] = arguments[b];
            v[0] = e.coerce(v[0]), typeof v[0] != "string" && v.unshift("%O");
            var C = 0;
            v[0] = v[0].replace(/%([a-zA-Z%])/g, function(T, x) {
              if (T === "%%")
                return T;
              C++;
              var E = e.formatters[x];
              if (typeof E == "function") {
                var k = v[C];
                T = E.call(g, k), v.splice(C, 1), C--;
              }
              return T;
            }), e.formatArgs.call(g, v);
            var S = f.log || e.log || console.log.bind(console);
            S.apply(g, v);
          }
        }
        var h;
        return f.namespace = m, f.enabled = e.enabled(m), f.useColors = e.useColors(), f.color = i(m), f.destroy = a, typeof e.init == "function" && e.init(f), e.instances.push(f), f;
      }
      function a() {
        var m = e.instances.indexOf(this);
        return m !== -1 && (e.instances.splice(m, 1), !0);
      }
      function d(m) {
        e.save(m), e.names = [], e.skips = [];
        var f, h = (typeof m == "string" ? m : "").split(/[\s,]+/), g = h.length;
        for (f = 0; f < g; f++)
          h[f] && (m = h[f].replace(/\*/g, ".*?"), m[0] === "-" ? e.skips.push(new RegExp("^" + m.substr(1) + "$")) : e.names.push(new RegExp("^" + m + "$")));
        for (f = 0; f < e.instances.length; f++) {
          var c = e.instances[f];
          c.enabled = e.enabled(c.namespace);
        }
      }
      function u() {
        e.enable("");
      }
      function p(m) {
        if (m[m.length - 1] === "*")
          return !0;
        var f, h;
        for (f = 0, h = e.skips.length; f < h; f++)
          if (e.skips[f].test(m))
            return !1;
        for (f = 0, h = e.names.length; f < h; f++)
          if (e.names[f].test(m))
            return !0;
        return !1;
      }
      function l(m) {
        return m instanceof Error ? m.stack || m.message : m;
      }
      e = t.exports = o.debug = o.default = o, e.coerce = l, e.disable = u, e.enable = d, e.enabled = p, e.humanize = r(6), e.instances = [], e.names = [], e.skips = [], e.formatters = {};
    }, function(t, e) {
      function r(f) {
        if (f = String(f), !(f.length > 100)) {
          var h = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(f);
          if (h) {
            var g = parseFloat(h[1]), c = (h[2] || "ms").toLowerCase();
            switch (c) {
              case "years":
              case "year":
              case "yrs":
              case "yr":
              case "y":
                return g * m;
              case "days":
              case "day":
              case "d":
                return g * l;
              case "hours":
              case "hour":
              case "hrs":
              case "hr":
              case "h":
                return g * p;
              case "minutes":
              case "minute":
              case "mins":
              case "min":
              case "m":
                return g * u;
              case "seconds":
              case "second":
              case "secs":
              case "sec":
              case "s":
                return g * d;
              case "milliseconds":
              case "millisecond":
              case "msecs":
              case "msec":
              case "ms":
                return g;
              default:
                return;
            }
          }
        }
      }
      function i(f) {
        return f >= l ? Math.round(f / l) + "d" : f >= p ? Math.round(f / p) + "h" : f >= u ? Math.round(f / u) + "m" : f >= d ? Math.round(f / d) + "s" : f + "ms";
      }
      function o(f) {
        return a(f, l, "day") || a(f, p, "hour") || a(f, u, "minute") || a(f, d, "second") || f + " ms";
      }
      function a(f, h, g) {
        if (!(f < h))
          return f < 1.5 * h ? Math.floor(f / h) + " " + g : Math.ceil(f / h) + " " + g + "s";
      }
      var d = 1e3, u = 60 * d, p = 60 * u, l = 24 * p, m = 365.25 * l;
      t.exports = function(f, h) {
        h = h || {};
        var g = typeof f;
        if (g === "string" && f.length > 0)
          return r(f);
        if (g === "number" && isNaN(f) === !1)
          return h.long ? o(f) : i(f);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(f));
      };
    }, function(t, e, r) {
      function i() {
      }
      function o(C) {
        var S = "" + C.type;
        if (e.BINARY_EVENT !== C.type && e.BINARY_ACK !== C.type || (S += C.attachments + "-"), C.nsp && C.nsp !== "/" && (S += C.nsp + ","), C.id != null && (S += C.id), C.data != null) {
          var T = a(C.data);
          if (T === !1)
            return b;
          S += T;
        }
        return h("encoded %j as %s", C, S), S;
      }
      function a(C) {
        try {
          return JSON.stringify(C);
        } catch {
          return !1;
        }
      }
      function d(C, S) {
        function T(x) {
          var E = c.deconstructPacket(x), k = o(E.packet), R = E.buffers;
          R.unshift(k), S(R);
        }
        c.removeBlobs(C, T);
      }
      function u() {
        this.reconstructor = null;
      }
      function p(C) {
        var S = 0, T = { type: Number(C.charAt(0)) };
        if (e.types[T.type] == null)
          return f("unknown packet type " + T.type);
        if (e.BINARY_EVENT === T.type || e.BINARY_ACK === T.type) {
          for (var x = ""; C.charAt(++S) !== "-" && (x += C.charAt(S), S != C.length); )
            ;
          if (x != Number(x) || C.charAt(S) !== "-")
            throw new Error("Illegal attachments");
          T.attachments = Number(x);
        }
        if (C.charAt(S + 1) === "/")
          for (T.nsp = ""; ++S; ) {
            var E = C.charAt(S);
            if (E === "," || (T.nsp += E, S === C.length))
              break;
          }
        else
          T.nsp = "/";
        var k = C.charAt(S + 1);
        if (k !== "" && Number(k) == k) {
          for (T.id = ""; ++S; ) {
            var E = C.charAt(S);
            if (E == null || Number(E) != E) {
              --S;
              break;
            }
            if (T.id += C.charAt(S), S === C.length)
              break;
          }
          T.id = Number(T.id);
        }
        if (C.charAt(++S)) {
          var R = l(C.substr(S)), P = R !== !1 && (T.type === e.ERROR || y(R));
          if (!P)
            return f("invalid payload");
          T.data = R;
        }
        return h("decoded %s as %j", C, T), T;
      }
      function l(C) {
        try {
          return JSON.parse(C);
        } catch {
          return !1;
        }
      }
      function m(C) {
        this.reconPack = C, this.buffers = [];
      }
      function f(C) {
        return { type: e.ERROR, data: "parser error: " + C };
      }
      var h = r(3)("socket.io-parser"), g = r(8), c = r(9), y = r(10), v = r(11);
      e.protocol = 4, e.types = ["CONNECT", "DISCONNECT", "EVENT", "ACK", "ERROR", "BINARY_EVENT", "BINARY_ACK"], e.CONNECT = 0, e.DISCONNECT = 1, e.EVENT = 2, e.ACK = 3, e.ERROR = 4, e.BINARY_EVENT = 5, e.BINARY_ACK = 6, e.Encoder = i, e.Decoder = u;
      var b = e.ERROR + '"encode error"';
      i.prototype.encode = function(C, S) {
        if (h("encoding packet %j", C), e.BINARY_EVENT === C.type || e.BINARY_ACK === C.type)
          d(C, S);
        else {
          var T = o(C);
          S([T]);
        }
      }, g(u.prototype), u.prototype.add = function(C) {
        var S;
        if (typeof C == "string")
          S = p(C), e.BINARY_EVENT === S.type || e.BINARY_ACK === S.type ? (this.reconstructor = new m(S), this.reconstructor.reconPack.attachments === 0 && this.emit("decoded", S)) : this.emit("decoded", S);
        else {
          if (!v(C) && !C.base64)
            throw new Error("Unknown type: " + C);
          if (!this.reconstructor)
            throw new Error("got binary data when not reconstructing a packet");
          S = this.reconstructor.takeBinaryData(C), S && (this.reconstructor = null, this.emit("decoded", S));
        }
      }, u.prototype.destroy = function() {
        this.reconstructor && this.reconstructor.finishedReconstruction();
      }, m.prototype.takeBinaryData = function(C) {
        if (this.buffers.push(C), this.buffers.length === this.reconPack.attachments) {
          var S = c.reconstructPacket(this.reconPack, this.buffers);
          return this.finishedReconstruction(), S;
        }
        return null;
      }, m.prototype.finishedReconstruction = function() {
        this.reconPack = null, this.buffers = [];
      };
    }, function(t, e, r) {
      function i(a) {
        if (a)
          return o(a);
      }
      function o(a) {
        for (var d in i.prototype)
          a[d] = i.prototype[d];
        return a;
      }
      t.exports = i, i.prototype.on = i.prototype.addEventListener = function(a, d) {
        return this._callbacks = this._callbacks || {}, (this._callbacks["$" + a] = this._callbacks["$" + a] || []).push(d), this;
      }, i.prototype.once = function(a, d) {
        function u() {
          this.off(a, u), d.apply(this, arguments);
        }
        return u.fn = d, this.on(a, u), this;
      }, i.prototype.off = i.prototype.removeListener = i.prototype.removeAllListeners = i.prototype.removeEventListener = function(a, d) {
        if (this._callbacks = this._callbacks || {}, arguments.length == 0)
          return this._callbacks = {}, this;
        var u = this._callbacks["$" + a];
        if (!u)
          return this;
        if (arguments.length == 1)
          return delete this._callbacks["$" + a], this;
        for (var p, l = 0; l < u.length; l++)
          if (p = u[l], p === d || p.fn === d) {
            u.splice(l, 1);
            break;
          }
        return u.length === 0 && delete this._callbacks["$" + a], this;
      }, i.prototype.emit = function(a) {
        this._callbacks = this._callbacks || {};
        for (var d = new Array(arguments.length - 1), u = this._callbacks["$" + a], p = 1; p < arguments.length; p++)
          d[p - 1] = arguments[p];
        if (u) {
          u = u.slice(0);
          for (var p = 0, l = u.length; p < l; ++p)
            u[p].apply(this, d);
        }
        return this;
      }, i.prototype.listeners = function(a) {
        return this._callbacks = this._callbacks || {}, this._callbacks["$" + a] || [];
      }, i.prototype.hasListeners = function(a) {
        return !!this.listeners(a).length;
      };
    }, function(t, e, r) {
      function i(m, f) {
        if (!m)
          return m;
        if (d(m)) {
          var h = { _placeholder: !0, num: f.length };
          return f.push(m), h;
        }
        if (a(m)) {
          for (var g = new Array(m.length), c = 0; c < m.length; c++)
            g[c] = i(m[c], f);
          return g;
        }
        if (typeof m == "object" && !(m instanceof Date)) {
          var g = {};
          for (var y in m)
            g[y] = i(m[y], f);
          return g;
        }
        return m;
      }
      function o(m, f) {
        if (!m)
          return m;
        if (m && m._placeholder)
          return f[m.num];
        if (a(m))
          for (var h = 0; h < m.length; h++)
            m[h] = o(m[h], f);
        else if (typeof m == "object")
          for (var g in m)
            m[g] = o(m[g], f);
        return m;
      }
      var a = r(10), d = r(11), u = Object.prototype.toString, p = typeof Blob == "function" || typeof Blob < "u" && u.call(Blob) === "[object BlobConstructor]", l = typeof File == "function" || typeof File < "u" && u.call(File) === "[object FileConstructor]";
      e.deconstructPacket = function(m) {
        var f = [], h = m.data, g = m;
        return g.data = i(h, f), g.attachments = f.length, { packet: g, buffers: f };
      }, e.reconstructPacket = function(m, f) {
        return m.data = o(m.data, f), m.attachments = void 0, m;
      }, e.removeBlobs = function(m, f) {
        function h(y, v, b) {
          if (!y)
            return y;
          if (p && y instanceof Blob || l && y instanceof File) {
            g++;
            var C = new FileReader();
            C.onload = function() {
              b ? b[v] = this.result : c = this.result, --g || f(c);
            }, C.readAsArrayBuffer(y);
          } else if (a(y))
            for (var S = 0; S < y.length; S++)
              h(y[S], S, y);
          else if (typeof y == "object" && !d(y))
            for (var T in y)
              h(y[T], T, y);
        }
        var g = 0, c = m;
        h(c), g || f(c);
      };
    }, function(t, e) {
      var r = {}.toString;
      t.exports = Array.isArray || function(i) {
        return r.call(i) == "[object Array]";
      };
    }, function(t, e) {
      function r(d) {
        return i && Buffer.isBuffer(d) || o && (d instanceof ArrayBuffer || a(d));
      }
      t.exports = r;
      var i = typeof Buffer == "function" && typeof Buffer.isBuffer == "function", o = typeof ArrayBuffer == "function", a = function(d) {
        return typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(d) : d.buffer instanceof ArrayBuffer;
      };
    }, function(t, e, r) {
      function i(c, y) {
        if (!(this instanceof i))
          return new i(c, y);
        c && typeof c == "object" && (y = c, c = void 0), y = y || {}, y.path = y.path || "/socket.io", this.nsps = {}, this.subs = [], this.opts = y, this.reconnection(y.reconnection !== !1), this.reconnectionAttempts(y.reconnectionAttempts || 1 / 0), this.reconnectionDelay(y.reconnectionDelay || 1e3), this.reconnectionDelayMax(y.reconnectionDelayMax || 5e3), this.randomizationFactor(y.randomizationFactor || 0.5), this.backoff = new h({ min: this.reconnectionDelay(), max: this.reconnectionDelayMax(), jitter: this.randomizationFactor() }), this.timeout(y.timeout == null ? 2e4 : y.timeout), this.readyState = "closed", this.uri = c, this.connecting = [], this.lastPing = null, this.encoding = !1, this.packetBuffer = [];
        var v = y.parser || u;
        this.encoder = new v.Encoder(), this.decoder = new v.Decoder(), this.autoConnect = y.autoConnect !== !1, this.autoConnect && this.open();
      }
      var o = r(13), a = r(37), d = r(8), u = r(7), p = r(39), l = r(40), m = r(3)("socket.io-client:manager"), f = r(36), h = r(41), g = Object.prototype.hasOwnProperty;
      t.exports = i, i.prototype.emitAll = function() {
        this.emit.apply(this, arguments);
        for (var c in this.nsps)
          g.call(this.nsps, c) && this.nsps[c].emit.apply(this.nsps[c], arguments);
      }, i.prototype.updateSocketIds = function() {
        for (var c in this.nsps)
          g.call(this.nsps, c) && (this.nsps[c].id = this.generateId(c));
      }, i.prototype.generateId = function(c) {
        return (c === "/" ? "" : c + "#") + this.engine.id;
      }, d(i.prototype), i.prototype.reconnection = function(c) {
        return arguments.length ? (this._reconnection = !!c, this) : this._reconnection;
      }, i.prototype.reconnectionAttempts = function(c) {
        return arguments.length ? (this._reconnectionAttempts = c, this) : this._reconnectionAttempts;
      }, i.prototype.reconnectionDelay = function(c) {
        return arguments.length ? (this._reconnectionDelay = c, this.backoff && this.backoff.setMin(c), this) : this._reconnectionDelay;
      }, i.prototype.randomizationFactor = function(c) {
        return arguments.length ? (this._randomizationFactor = c, this.backoff && this.backoff.setJitter(c), this) : this._randomizationFactor;
      }, i.prototype.reconnectionDelayMax = function(c) {
        return arguments.length ? (this._reconnectionDelayMax = c, this.backoff && this.backoff.setMax(c), this) : this._reconnectionDelayMax;
      }, i.prototype.timeout = function(c) {
        return arguments.length ? (this._timeout = c, this) : this._timeout;
      }, i.prototype.maybeReconnectOnOpen = function() {
        !this.reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
      }, i.prototype.open = i.prototype.connect = function(c, y) {
        if (m("readyState %s", this.readyState), ~this.readyState.indexOf("open"))
          return this;
        m("opening %s", this.uri), this.engine = o(this.uri, this.opts);
        var v = this.engine, b = this;
        this.readyState = "opening", this.skipReconnect = !1;
        var C = p(v, "open", function() {
          b.onopen(), c && c();
        }), S = p(v, "error", function(E) {
          if (m("connect_error"), b.cleanup(), b.readyState = "closed", b.emitAll("connect_error", E), c) {
            var k = new Error("Connection error");
            k.data = E, c(k);
          } else
            b.maybeReconnectOnOpen();
        });
        if (this._timeout !== !1) {
          var T = this._timeout;
          m("connect attempt will timeout after %d", T), T === 0 && C.destroy();
          var x = setTimeout(function() {
            m("connect attempt timed out after %d", T), C.destroy(), v.close(), v.emit("error", "timeout"), b.emitAll("connect_timeout", T);
          }, T);
          this.subs.push({ destroy: function() {
            clearTimeout(x);
          } });
        }
        return this.subs.push(C), this.subs.push(S), this;
      }, i.prototype.onopen = function() {
        m("open"), this.cleanup(), this.readyState = "open", this.emit("open");
        var c = this.engine;
        this.subs.push(p(c, "data", l(this, "ondata"))), this.subs.push(p(c, "ping", l(this, "onping"))), this.subs.push(p(c, "pong", l(this, "onpong"))), this.subs.push(p(c, "error", l(this, "onerror"))), this.subs.push(p(c, "close", l(this, "onclose"))), this.subs.push(p(this.decoder, "decoded", l(this, "ondecoded")));
      }, i.prototype.onping = function() {
        this.lastPing = new Date(), this.emitAll("ping");
      }, i.prototype.onpong = function() {
        this.emitAll("pong", new Date() - this.lastPing);
      }, i.prototype.ondata = function(c) {
        this.decoder.add(c);
      }, i.prototype.ondecoded = function(c) {
        this.emit("packet", c);
      }, i.prototype.onerror = function(c) {
        m("error", c), this.emitAll("error", c);
      }, i.prototype.socket = function(c, y) {
        function v() {
          ~f(C.connecting, b) || C.connecting.push(b);
        }
        var b = this.nsps[c];
        if (!b) {
          b = new a(this, c, y), this.nsps[c] = b;
          var C = this;
          b.on("connecting", v), b.on("connect", function() {
            b.id = C.generateId(c);
          }), this.autoConnect && v();
        }
        return b;
      }, i.prototype.destroy = function(c) {
        var y = f(this.connecting, c);
        ~y && this.connecting.splice(y, 1), this.connecting.length || this.close();
      }, i.prototype.packet = function(c) {
        m("writing packet %j", c);
        var y = this;
        c.query && c.type === 0 && (c.nsp += "?" + c.query), y.encoding ? y.packetBuffer.push(c) : (y.encoding = !0, this.encoder.encode(c, function(v) {
          for (var b = 0; b < v.length; b++)
            y.engine.write(v[b], c.options);
          y.encoding = !1, y.processPacketQueue();
        }));
      }, i.prototype.processPacketQueue = function() {
        if (this.packetBuffer.length > 0 && !this.encoding) {
          var c = this.packetBuffer.shift();
          this.packet(c);
        }
      }, i.prototype.cleanup = function() {
        m("cleanup");
        for (var c = this.subs.length, y = 0; y < c; y++) {
          var v = this.subs.shift();
          v.destroy();
        }
        this.packetBuffer = [], this.encoding = !1, this.lastPing = null, this.decoder.destroy();
      }, i.prototype.close = i.prototype.disconnect = function() {
        m("disconnect"), this.skipReconnect = !0, this.reconnecting = !1, this.readyState === "opening" && this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.engine && this.engine.close();
      }, i.prototype.onclose = function(c) {
        m("onclose"), this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.emit("close", c), this._reconnection && !this.skipReconnect && this.reconnect();
      }, i.prototype.reconnect = function() {
        if (this.reconnecting || this.skipReconnect)
          return this;
        var c = this;
        if (this.backoff.attempts >= this._reconnectionAttempts)
          m("reconnect failed"), this.backoff.reset(), this.emitAll("reconnect_failed"), this.reconnecting = !1;
        else {
          var y = this.backoff.duration();
          m("will wait %dms before reconnect attempt", y), this.reconnecting = !0;
          var v = setTimeout(function() {
            c.skipReconnect || (m("attempting reconnect"), c.emitAll("reconnect_attempt", c.backoff.attempts), c.emitAll("reconnecting", c.backoff.attempts), c.skipReconnect || c.open(function(b) {
              b ? (m("reconnect attempt error"), c.reconnecting = !1, c.reconnect(), c.emitAll("reconnect_error", b.data)) : (m("reconnect success"), c.onreconnect());
            }));
          }, y);
          this.subs.push({ destroy: function() {
            clearTimeout(v);
          } });
        }
      }, i.prototype.onreconnect = function() {
        var c = this.backoff.attempts;
        this.reconnecting = !1, this.backoff.reset(), this.updateSocketIds(), this.emitAll("reconnect", c);
      };
    }, function(t, e, r) {
      t.exports = r(14), t.exports.parser = r(22);
    }, function(t, e, r) {
      function i(h, g) {
        return this instanceof i ? (g = g || {}, h && typeof h == "object" && (g = h, h = null), h ? (h = m(h), g.hostname = h.host, g.secure = h.protocol === "https" || h.protocol === "wss", g.port = h.port, h.query && (g.query = h.query)) : g.host && (g.hostname = m(g.host).host), this.secure = g.secure != null ? g.secure : typeof location < "u" && location.protocol === "https:", g.hostname && !g.port && (g.port = this.secure ? "443" : "80"), this.agent = g.agent || !1, this.hostname = g.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = g.port || (typeof location < "u" && location.port ? location.port : this.secure ? 443 : 80), this.query = g.query || {}, typeof this.query == "string" && (this.query = f.decode(this.query)), this.upgrade = g.upgrade !== !1, this.path = (g.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!g.forceJSONP, this.jsonp = g.jsonp !== !1, this.forceBase64 = !!g.forceBase64, this.enablesXDR = !!g.enablesXDR, this.withCredentials = g.withCredentials !== !1, this.timestampParam = g.timestampParam || "t", this.timestampRequests = g.timestampRequests, this.transports = g.transports || ["polling", "websocket"], this.transportOptions = g.transportOptions || {}, this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.policyPort = g.policyPort || 843, this.rememberUpgrade = g.rememberUpgrade || !1, this.binaryType = null, this.onlyBinaryUpgrades = g.onlyBinaryUpgrades, this.perMessageDeflate = g.perMessageDeflate !== !1 && (g.perMessageDeflate || {}), this.perMessageDeflate === !0 && (this.perMessageDeflate = {}), this.perMessageDeflate && this.perMessageDeflate.threshold == null && (this.perMessageDeflate.threshold = 1024), this.pfx = g.pfx || null, this.key = g.key || null, this.passphrase = g.passphrase || null, this.cert = g.cert || null, this.ca = g.ca || null, this.ciphers = g.ciphers || null, this.rejectUnauthorized = g.rejectUnauthorized === void 0 || g.rejectUnauthorized, this.forceNode = !!g.forceNode, this.isReactNative = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", (typeof self > "u" || this.isReactNative) && (g.extraHeaders && Object.keys(g.extraHeaders).length > 0 && (this.extraHeaders = g.extraHeaders), g.localAddress && (this.localAddress = g.localAddress)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingIntervalTimer = null, this.pingTimeoutTimer = null, void this.open()) : new i(h, g);
      }
      function o(h) {
        var g = {};
        for (var c in h)
          h.hasOwnProperty(c) && (g[c] = h[c]);
        return g;
      }
      var a = r(15), d = r(8), u = r(3)("engine.io-client:socket"), p = r(36), l = r(22), m = r(2), f = r(30);
      t.exports = i, i.priorWebsocketSuccess = !1, d(i.prototype), i.protocol = l.protocol, i.Socket = i, i.Transport = r(21), i.transports = r(15), i.parser = r(22), i.prototype.createTransport = function(h) {
        u('creating transport "%s"', h);
        var g = o(this.query);
        g.EIO = l.protocol, g.transport = h;
        var c = this.transportOptions[h] || {};
        this.id && (g.sid = this.id);
        var y = new a[h]({ query: g, socket: this, agent: c.agent || this.agent, hostname: c.hostname || this.hostname, port: c.port || this.port, secure: c.secure || this.secure, path: c.path || this.path, forceJSONP: c.forceJSONP || this.forceJSONP, jsonp: c.jsonp || this.jsonp, forceBase64: c.forceBase64 || this.forceBase64, enablesXDR: c.enablesXDR || this.enablesXDR, withCredentials: c.withCredentials || this.withCredentials, timestampRequests: c.timestampRequests || this.timestampRequests, timestampParam: c.timestampParam || this.timestampParam, policyPort: c.policyPort || this.policyPort, pfx: c.pfx || this.pfx, key: c.key || this.key, passphrase: c.passphrase || this.passphrase, cert: c.cert || this.cert, ca: c.ca || this.ca, ciphers: c.ciphers || this.ciphers, rejectUnauthorized: c.rejectUnauthorized || this.rejectUnauthorized, perMessageDeflate: c.perMessageDeflate || this.perMessageDeflate, extraHeaders: c.extraHeaders || this.extraHeaders, forceNode: c.forceNode || this.forceNode, localAddress: c.localAddress || this.localAddress, requestTimeout: c.requestTimeout || this.requestTimeout, protocols: c.protocols || void 0, isReactNative: this.isReactNative });
        return y;
      }, i.prototype.open = function() {
        var h;
        if (this.rememberUpgrade && i.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
          h = "websocket";
        else {
          if (this.transports.length === 0) {
            var g = this;
            return void setTimeout(function() {
              g.emit("error", "No transports available");
            }, 0);
          }
          h = this.transports[0];
        }
        this.readyState = "opening";
        try {
          h = this.createTransport(h);
        } catch {
          return this.transports.shift(), void this.open();
        }
        h.open(), this.setTransport(h);
      }, i.prototype.setTransport = function(h) {
        u("setting transport %s", h.name);
        var g = this;
        this.transport && (u("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = h, h.on("drain", function() {
          g.onDrain();
        }).on("packet", function(c) {
          g.onPacket(c);
        }).on("error", function(c) {
          g.onError(c);
        }).on("close", function() {
          g.onClose("transport close");
        });
      }, i.prototype.probe = function(h) {
        function g() {
          if (E.onlyBinaryUpgrades) {
            var k = !this.supportsBinary && E.transport.supportsBinary;
            x = x || k;
          }
          x || (u('probe transport "%s" opened', h), T.send([{ type: "ping", data: "probe" }]), T.once("packet", function(R) {
            if (!x)
              if (R.type === "pong" && R.data === "probe") {
                if (u('probe transport "%s" pong', h), E.upgrading = !0, E.emit("upgrading", T), !T)
                  return;
                i.priorWebsocketSuccess = T.name === "websocket", u('pausing current transport "%s"', E.transport.name), E.transport.pause(function() {
                  x || E.readyState !== "closed" && (u("changing transport and sending upgrade packet"), S(), E.setTransport(T), T.send([{ type: "upgrade" }]), E.emit("upgrade", T), T = null, E.upgrading = !1, E.flush());
                });
              } else {
                u('probe transport "%s" failed', h);
                var P = new Error("probe error");
                P.transport = T.name, E.emit("upgradeError", P);
              }
          }));
        }
        function c() {
          x || (x = !0, S(), T.close(), T = null);
        }
        function y(k) {
          var R = new Error("probe error: " + k);
          R.transport = T.name, c(), u('probe transport "%s" failed because of error: %s', h, k), E.emit("upgradeError", R);
        }
        function v() {
          y("transport closed");
        }
        function b() {
          y("socket closed");
        }
        function C(k) {
          T && k.name !== T.name && (u('"%s" works - aborting "%s"', k.name, T.name), c());
        }
        function S() {
          T.removeListener("open", g), T.removeListener("error", y), T.removeListener("close", v), E.removeListener("close", b), E.removeListener("upgrading", C);
        }
        u('probing transport "%s"', h);
        var T = this.createTransport(h, { probe: 1 }), x = !1, E = this;
        i.priorWebsocketSuccess = !1, T.once("open", g), T.once("error", y), T.once("close", v), this.once("close", b), this.once("upgrading", C), T.open();
      }, i.prototype.onOpen = function() {
        if (u("socket open"), this.readyState = "open", i.priorWebsocketSuccess = this.transport.name === "websocket", this.emit("open"), this.flush(), this.readyState === "open" && this.upgrade && this.transport.pause) {
          u("starting upgrade probes");
          for (var h = 0, g = this.upgrades.length; h < g; h++)
            this.probe(this.upgrades[h]);
        }
      }, i.prototype.onPacket = function(h) {
        if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
          switch (u('socket receive: type "%s", data "%s"', h.type, h.data), this.emit("packet", h), this.emit("heartbeat"), h.type) {
            case "open":
              this.onHandshake(JSON.parse(h.data));
              break;
            case "pong":
              this.setPing(), this.emit("pong");
              break;
            case "error":
              var g = new Error("server error");
              g.code = h.data, this.onError(g);
              break;
            case "message":
              this.emit("data", h.data), this.emit("message", h.data);
          }
        else
          u('packet received with socket readyState "%s"', this.readyState);
      }, i.prototype.onHandshake = function(h) {
        this.emit("handshake", h), this.id = h.sid, this.transport.query.sid = h.sid, this.upgrades = this.filterUpgrades(h.upgrades), this.pingInterval = h.pingInterval, this.pingTimeout = h.pingTimeout, this.onOpen(), this.readyState !== "closed" && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
      }, i.prototype.onHeartbeat = function(h) {
        clearTimeout(this.pingTimeoutTimer);
        var g = this;
        g.pingTimeoutTimer = setTimeout(function() {
          g.readyState !== "closed" && g.onClose("ping timeout");
        }, h || g.pingInterval + g.pingTimeout);
      }, i.prototype.setPing = function() {
        var h = this;
        clearTimeout(h.pingIntervalTimer), h.pingIntervalTimer = setTimeout(function() {
          u("writing ping packet - expecting pong within %sms", h.pingTimeout), h.ping(), h.onHeartbeat(h.pingTimeout);
        }, h.pingInterval);
      }, i.prototype.ping = function() {
        var h = this;
        this.sendPacket("ping", function() {
          h.emit("ping");
        });
      }, i.prototype.onDrain = function() {
        this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emit("drain") : this.flush();
      }, i.prototype.flush = function() {
        this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length && (u("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
      }, i.prototype.write = i.prototype.send = function(h, g, c) {
        return this.sendPacket("message", h, g, c), this;
      }, i.prototype.sendPacket = function(h, g, c, y) {
        if (typeof g == "function" && (y = g, g = void 0), typeof c == "function" && (y = c, c = null), this.readyState !== "closing" && this.readyState !== "closed") {
          c = c || {}, c.compress = c.compress !== !1;
          var v = { type: h, data: g, options: c };
          this.emit("packetCreate", v), this.writeBuffer.push(v), y && this.once("flush", y), this.flush();
        }
      }, i.prototype.close = function() {
        function h() {
          y.onClose("forced close"), u("socket closing - telling transport to close"), y.transport.close();
        }
        function g() {
          y.removeListener("upgrade", g), y.removeListener("upgradeError", g), h();
        }
        function c() {
          y.once("upgrade", g), y.once("upgradeError", g);
        }
        if (this.readyState === "opening" || this.readyState === "open") {
          this.readyState = "closing";
          var y = this;
          this.writeBuffer.length ? this.once("drain", function() {
            this.upgrading ? c() : h();
          }) : this.upgrading ? c() : h();
        }
        return this;
      }, i.prototype.onError = function(h) {
        u("socket error %j", h), i.priorWebsocketSuccess = !1, this.emit("error", h), this.onClose("transport error", h);
      }, i.prototype.onClose = function(h, g) {
        if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
          u('socket close with reason: "%s"', h);
          var c = this;
          clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", h, g), c.writeBuffer = [], c.prevBufferLen = 0;
        }
      }, i.prototype.filterUpgrades = function(h) {
        for (var g = [], c = 0, y = h.length; c < y; c++)
          ~p(this.transports, h[c]) && g.push(h[c]);
        return g;
      };
    }, function(t, e, r) {
      function i(p) {
        var l, m = !1, f = !1, h = p.jsonp !== !1;
        if (typeof location < "u") {
          var g = location.protocol === "https:", c = location.port;
          c || (c = g ? 443 : 80), m = p.hostname !== location.hostname || c !== p.port, f = p.secure !== g;
        }
        if (p.xdomain = m, p.xscheme = f, l = new o(p), "open" in l && !p.forceJSONP)
          return new a(p);
        if (!h)
          throw new Error("JSONP disabled");
        return new d(p);
      }
      var o = r(16), a = r(19), d = r(33), u = r(34);
      e.polling = i, e.websocket = u;
    }, function(t, e, r) {
      var i = r(17), o = r(18);
      t.exports = function(a) {
        var d = a.xdomain, u = a.xscheme, p = a.enablesXDR;
        try {
          if (typeof XMLHttpRequest < "u" && (!d || i))
            return new XMLHttpRequest();
        } catch {
        }
        try {
          if (typeof XDomainRequest < "u" && !u && p)
            return new XDomainRequest();
        } catch {
        }
        if (!d)
          try {
            return new o[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
          } catch {
          }
      };
    }, function(t, e) {
      try {
        t.exports = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
      } catch {
        t.exports = !1;
      }
    }, function(t, e) {
      t.exports = function() {
        return typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
      }();
    }, function(t, e, r) {
      function i() {
      }
      function o(c) {
        if (p.call(this, c), this.requestTimeout = c.requestTimeout, this.extraHeaders = c.extraHeaders, typeof location < "u") {
          var y = location.protocol === "https:", v = location.port;
          v || (v = y ? 443 : 80), this.xd = typeof location < "u" && c.hostname !== location.hostname || v !== c.port, this.xs = c.secure !== y;
        }
      }
      function a(c) {
        this.method = c.method || "GET", this.uri = c.uri, this.xd = !!c.xd, this.xs = !!c.xs, this.async = c.async !== !1, this.data = c.data !== void 0 ? c.data : null, this.agent = c.agent, this.isBinary = c.isBinary, this.supportsBinary = c.supportsBinary, this.enablesXDR = c.enablesXDR, this.withCredentials = c.withCredentials, this.requestTimeout = c.requestTimeout, this.pfx = c.pfx, this.key = c.key, this.passphrase = c.passphrase, this.cert = c.cert, this.ca = c.ca, this.ciphers = c.ciphers, this.rejectUnauthorized = c.rejectUnauthorized, this.extraHeaders = c.extraHeaders, this.create();
      }
      function d() {
        for (var c in a.requests)
          a.requests.hasOwnProperty(c) && a.requests[c].abort();
      }
      var u = r(16), p = r(20), l = r(8), m = r(31), f = r(3)("engine.io-client:polling-xhr"), h = r(18);
      if (t.exports = o, t.exports.Request = a, m(o, p), o.prototype.supportsBinary = !0, o.prototype.request = function(c) {
        return c = c || {}, c.uri = this.uri(), c.xd = this.xd, c.xs = this.xs, c.agent = this.agent || !1, c.supportsBinary = this.supportsBinary, c.enablesXDR = this.enablesXDR, c.withCredentials = this.withCredentials, c.pfx = this.pfx, c.key = this.key, c.passphrase = this.passphrase, c.cert = this.cert, c.ca = this.ca, c.ciphers = this.ciphers, c.rejectUnauthorized = this.rejectUnauthorized, c.requestTimeout = this.requestTimeout, c.extraHeaders = this.extraHeaders, new a(c);
      }, o.prototype.doWrite = function(c, y) {
        var v = typeof c != "string" && c !== void 0, b = this.request({ method: "POST", data: c, isBinary: v }), C = this;
        b.on("success", y), b.on("error", function(S) {
          C.onError("xhr post error", S);
        }), this.sendXhr = b;
      }, o.prototype.doPoll = function() {
        f("xhr poll");
        var c = this.request(), y = this;
        c.on("data", function(v) {
          y.onData(v);
        }), c.on("error", function(v) {
          y.onError("xhr poll error", v);
        }), this.pollXhr = c;
      }, l(a.prototype), a.prototype.create = function() {
        var c = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
        c.pfx = this.pfx, c.key = this.key, c.passphrase = this.passphrase, c.cert = this.cert, c.ca = this.ca, c.ciphers = this.ciphers, c.rejectUnauthorized = this.rejectUnauthorized;
        var y = this.xhr = new u(c), v = this;
        try {
          f("xhr open %s: %s", this.method, this.uri), y.open(this.method, this.uri, this.async);
          try {
            if (this.extraHeaders) {
              y.setDisableHeaderCheck && y.setDisableHeaderCheck(!0);
              for (var b in this.extraHeaders)
                this.extraHeaders.hasOwnProperty(b) && y.setRequestHeader(b, this.extraHeaders[b]);
            }
          } catch {
          }
          if (this.method === "POST")
            try {
              this.isBinary ? y.setRequestHeader("Content-type", "application/octet-stream") : y.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch {
            }
          try {
            y.setRequestHeader("Accept", "*/*");
          } catch {
          }
          "withCredentials" in y && (y.withCredentials = this.withCredentials), this.requestTimeout && (y.timeout = this.requestTimeout), this.hasXDR() ? (y.onload = function() {
            v.onLoad();
          }, y.onerror = function() {
            v.onError(y.responseText);
          }) : y.onreadystatechange = function() {
            if (y.readyState === 2)
              try {
                var C = y.getResponseHeader("Content-Type");
                (v.supportsBinary && C === "application/octet-stream" || C === "application/octet-stream; charset=UTF-8") && (y.responseType = "arraybuffer");
              } catch {
              }
            y.readyState === 4 && (y.status === 200 || y.status === 1223 ? v.onLoad() : setTimeout(function() {
              v.onError(typeof y.status == "number" ? y.status : 0);
            }, 0));
          }, f("xhr data %s", this.data), y.send(this.data);
        } catch (C) {
          return void setTimeout(function() {
            v.onError(C);
          }, 0);
        }
        typeof document < "u" && (this.index = a.requestsCount++, a.requests[this.index] = this);
      }, a.prototype.onSuccess = function() {
        this.emit("success"), this.cleanup();
      }, a.prototype.onData = function(c) {
        this.emit("data", c), this.onSuccess();
      }, a.prototype.onError = function(c) {
        this.emit("error", c), this.cleanup(!0);
      }, a.prototype.cleanup = function(c) {
        if (typeof this.xhr < "u" && this.xhr !== null) {
          if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = i : this.xhr.onreadystatechange = i, c)
            try {
              this.xhr.abort();
            } catch {
            }
          typeof document < "u" && delete a.requests[this.index], this.xhr = null;
        }
      }, a.prototype.onLoad = function() {
        var c;
        try {
          var y;
          try {
            y = this.xhr.getResponseHeader("Content-Type");
          } catch {
          }
          c = y === "application/octet-stream" || y === "application/octet-stream; charset=UTF-8" ? this.xhr.response || this.xhr.responseText : this.xhr.responseText;
        } catch (v) {
          this.onError(v);
        }
        c != null && this.onData(c);
      }, a.prototype.hasXDR = function() {
        return typeof XDomainRequest < "u" && !this.xs && this.enablesXDR;
      }, a.prototype.abort = function() {
        this.cleanup();
      }, a.requestsCount = 0, a.requests = {}, typeof document < "u") {
        if (typeof attachEvent == "function")
          attachEvent("onunload", d);
        else if (typeof addEventListener == "function") {
          var g = "onpagehide" in h ? "pagehide" : "unload";
          addEventListener(g, d, !1);
        }
      }
    }, function(t, e, r) {
      function i(f) {
        var h = f && f.forceBase64;
        m && !h || (this.supportsBinary = !1), o.call(this, f);
      }
      var o = r(21), a = r(30), d = r(22), u = r(31), p = r(32), l = r(3)("engine.io-client:polling");
      t.exports = i;
      var m = function() {
        var f = r(16), h = new f({ xdomain: !1 });
        return h.responseType != null;
      }();
      u(i, o), i.prototype.name = "polling", i.prototype.doOpen = function() {
        this.poll();
      }, i.prototype.pause = function(f) {
        function h() {
          l("paused"), g.readyState = "paused", f();
        }
        var g = this;
        if (this.readyState = "pausing", this.polling || !this.writable) {
          var c = 0;
          this.polling && (l("we are currently polling - waiting to pause"), c++, this.once("pollComplete", function() {
            l("pre-pause polling complete"), --c || h();
          })), this.writable || (l("we are currently writing - waiting to pause"), c++, this.once("drain", function() {
            l("pre-pause writing complete"), --c || h();
          }));
        } else
          h();
      }, i.prototype.poll = function() {
        l("polling"), this.polling = !0, this.doPoll(), this.emit("poll");
      }, i.prototype.onData = function(f) {
        var h = this;
        l("polling got data %s", f);
        var g = function(c, y, v) {
          return h.readyState === "opening" && c.type === "open" && h.onOpen(), c.type === "close" ? (h.onClose(), !1) : void h.onPacket(c);
        };
        d.decodePayload(f, this.socket.binaryType, g), this.readyState !== "closed" && (this.polling = !1, this.emit("pollComplete"), this.readyState === "open" ? this.poll() : l('ignoring poll - transport state "%s"', this.readyState));
      }, i.prototype.doClose = function() {
        function f() {
          l("writing close packet"), h.write([{ type: "close" }]);
        }
        var h = this;
        this.readyState === "open" ? (l("transport open - closing"), f()) : (l("transport not open - deferring close"), this.once("open", f));
      }, i.prototype.write = function(f) {
        var h = this;
        this.writable = !1;
        var g = function() {
          h.writable = !0, h.emit("drain");
        };
        d.encodePayload(f, this.supportsBinary, function(c) {
          h.doWrite(c, g);
        });
      }, i.prototype.uri = function() {
        var f = this.query || {}, h = this.secure ? "https" : "http", g = "";
        this.timestampRequests !== !1 && (f[this.timestampParam] = p()), this.supportsBinary || f.sid || (f.b64 = 1), f = a.encode(f), this.port && (h === "https" && Number(this.port) !== 443 || h === "http" && Number(this.port) !== 80) && (g = ":" + this.port), f.length && (f = "?" + f);
        var c = this.hostname.indexOf(":") !== -1;
        return h + "://" + (c ? "[" + this.hostname + "]" : this.hostname) + g + this.path + f;
      };
    }, function(t, e, r) {
      function i(d) {
        this.path = d.path, this.hostname = d.hostname, this.port = d.port, this.secure = d.secure, this.query = d.query, this.timestampParam = d.timestampParam, this.timestampRequests = d.timestampRequests, this.readyState = "", this.agent = d.agent || !1, this.socket = d.socket, this.enablesXDR = d.enablesXDR, this.withCredentials = d.withCredentials, this.pfx = d.pfx, this.key = d.key, this.passphrase = d.passphrase, this.cert = d.cert, this.ca = d.ca, this.ciphers = d.ciphers, this.rejectUnauthorized = d.rejectUnauthorized, this.forceNode = d.forceNode, this.isReactNative = d.isReactNative, this.extraHeaders = d.extraHeaders, this.localAddress = d.localAddress;
      }
      var o = r(22), a = r(8);
      t.exports = i, a(i.prototype), i.prototype.onError = function(d, u) {
        var p = new Error(d);
        return p.type = "TransportError", p.description = u, this.emit("error", p), this;
      }, i.prototype.open = function() {
        return this.readyState !== "closed" && this.readyState !== "" || (this.readyState = "opening", this.doOpen()), this;
      }, i.prototype.close = function() {
        return this.readyState !== "opening" && this.readyState !== "open" || (this.doClose(), this.onClose()), this;
      }, i.prototype.send = function(d) {
        if (this.readyState !== "open")
          throw new Error("Transport not open");
        this.write(d);
      }, i.prototype.onOpen = function() {
        this.readyState = "open", this.writable = !0, this.emit("open");
      }, i.prototype.onData = function(d) {
        var u = o.decodePacket(d, this.socket.binaryType);
        this.onPacket(u);
      }, i.prototype.onPacket = function(d) {
        this.emit("packet", d);
      }, i.prototype.onClose = function() {
        this.readyState = "closed", this.emit("close");
      };
    }, function(t, e, r) {
      function i(E, k) {
        var R = "b" + e.packets[E.type] + E.data.data;
        return k(R);
      }
      function o(E, k, R) {
        if (!k)
          return e.encodeBase64Packet(E, R);
        var P = E.data, A = new Uint8Array(P), D = new Uint8Array(1 + P.byteLength);
        D[0] = C[E.type];
        for (var M = 0; M < A.length; M++)
          D[M + 1] = A[M];
        return R(D.buffer);
      }
      function a(E, k, R) {
        if (!k)
          return e.encodeBase64Packet(E, R);
        var P = new FileReader();
        return P.onload = function() {
          e.encodePacket({ type: E.type, data: P.result }, k, !0, R);
        }, P.readAsArrayBuffer(E.data);
      }
      function d(E, k, R) {
        if (!k)
          return e.encodeBase64Packet(E, R);
        if (b)
          return a(E, k, R);
        var P = new Uint8Array(1);
        P[0] = C[E.type];
        var A = new x([P.buffer, E.data]);
        return R(A);
      }
      function u(E) {
        try {
          E = c.decode(E, { strict: !1 });
        } catch {
          return !1;
        }
        return E;
      }
      function p(E, k, R) {
        for (var P = new Array(E.length), A = g(E.length, R), D = function(I, O, F) {
          k(O, function(U, w) {
            P[I] = w, F(U, P);
          });
        }, M = 0; M < E.length; M++)
          D(M, E[M], A);
      }
      var l, m = r(23), f = r(24), h = r(25), g = r(26), c = r(27);
      typeof ArrayBuffer < "u" && (l = r(28));
      var y = typeof navigator < "u" && /Android/i.test(navigator.userAgent), v = typeof navigator < "u" && /PhantomJS/i.test(navigator.userAgent), b = y || v;
      e.protocol = 3;
      var C = e.packets = { open: 0, close: 1, ping: 2, pong: 3, message: 4, upgrade: 5, noop: 6 }, S = m(C), T = { type: "error", data: "parser error" }, x = r(29);
      e.encodePacket = function(E, k, R, P) {
        typeof k == "function" && (P = k, k = !1), typeof R == "function" && (P = R, R = null);
        var A = E.data === void 0 ? void 0 : E.data.buffer || E.data;
        if (typeof ArrayBuffer < "u" && A instanceof ArrayBuffer)
          return o(E, k, P);
        if (typeof x < "u" && A instanceof x)
          return d(E, k, P);
        if (A && A.base64)
          return i(E, P);
        var D = C[E.type];
        return E.data !== void 0 && (D += R ? c.encode(String(E.data), { strict: !1 }) : String(E.data)), P("" + D);
      }, e.encodeBase64Packet = function(E, k) {
        var R = "b" + e.packets[E.type];
        if (typeof x < "u" && E.data instanceof x) {
          var P = new FileReader();
          return P.onload = function() {
            var O = P.result.split(",")[1];
            k(R + O);
          }, P.readAsDataURL(E.data);
        }
        var A;
        try {
          A = String.fromCharCode.apply(null, new Uint8Array(E.data));
        } catch {
          for (var D = new Uint8Array(E.data), M = new Array(D.length), I = 0; I < D.length; I++)
            M[I] = D[I];
          A = String.fromCharCode.apply(null, M);
        }
        return R += btoa(A), k(R);
      }, e.decodePacket = function(E, k, R) {
        if (E === void 0)
          return T;
        if (typeof E == "string") {
          if (E.charAt(0) === "b")
            return e.decodeBase64Packet(E.substr(1), k);
          if (R && (E = u(E), E === !1))
            return T;
          var A = E.charAt(0);
          return Number(A) == A && S[A] ? E.length > 1 ? { type: S[A], data: E.substring(1) } : { type: S[A] } : T;
        }
        var P = new Uint8Array(E), A = P[0], D = h(E, 1);
        return x && k === "blob" && (D = new x([D])), { type: S[A], data: D };
      }, e.decodeBase64Packet = function(E, k) {
        var R = S[E.charAt(0)];
        if (!l)
          return { type: R, data: { base64: !0, data: E.substr(1) } };
        var P = l.decode(E.substr(1));
        return k === "blob" && x && (P = new x([P])), { type: R, data: P };
      }, e.encodePayload = function(E, k, R) {
        function P(M) {
          return M.length + ":" + M;
        }
        function A(M, I) {
          e.encodePacket(M, !!D && k, !1, function(O) {
            I(null, P(O));
          });
        }
        typeof k == "function" && (R = k, k = null);
        var D = f(E);
        return k && D ? x && !b ? e.encodePayloadAsBlob(E, R) : e.encodePayloadAsArrayBuffer(E, R) : E.length ? void p(E, A, function(M, I) {
          return R(I.join(""));
        }) : R("0:");
      }, e.decodePayload = function(E, k, R) {
        if (typeof E != "string")
          return e.decodePayloadAsBinary(E, k, R);
        typeof k == "function" && (R = k, k = null);
        var P;
        if (E === "")
          return R(T, 0, 1);
        for (var A, D, M = "", I = 0, O = E.length; I < O; I++) {
          var F = E.charAt(I);
          if (F === ":") {
            if (M === "" || M != (A = Number(M)) || (D = E.substr(I + 1, A), M != D.length))
              return R(T, 0, 1);
            if (D.length) {
              if (P = e.decodePacket(D, k, !1), T.type === P.type && T.data === P.data)
                return R(T, 0, 1);
              var U = R(P, I + A, O);
              if (U === !1)
                return;
            }
            I += A, M = "";
          } else
            M += F;
        }
        return M !== "" ? R(T, 0, 1) : void 0;
      }, e.encodePayloadAsArrayBuffer = function(E, k) {
        function R(P, A) {
          e.encodePacket(P, !0, !0, function(D) {
            return A(null, D);
          });
        }
        return E.length ? void p(E, R, function(P, A) {
          var D = A.reduce(function(O, F) {
            var U;
            return U = typeof F == "string" ? F.length : F.byteLength, O + U.toString().length + U + 2;
          }, 0), M = new Uint8Array(D), I = 0;
          return A.forEach(function(O) {
            var F = typeof O == "string", U = O;
            if (F) {
              for (var w = new Uint8Array(O.length), L = 0; L < O.length; L++)
                w[L] = O.charCodeAt(L);
              U = w.buffer;
            }
            F ? M[I++] = 0 : M[I++] = 1;
            for (var ce = U.byteLength.toString(), L = 0; L < ce.length; L++)
              M[I++] = parseInt(ce[L]);
            M[I++] = 255;
            for (var w = new Uint8Array(U), L = 0; L < w.length; L++)
              M[I++] = w[L];
          }), k(M.buffer);
        }) : k(new ArrayBuffer(0));
      }, e.encodePayloadAsBlob = function(E, k) {
        function R(P, A) {
          e.encodePacket(P, !0, !0, function(D) {
            var M = new Uint8Array(1);
            if (M[0] = 1, typeof D == "string") {
              for (var I = new Uint8Array(D.length), O = 0; O < D.length; O++)
                I[O] = D.charCodeAt(O);
              D = I.buffer, M[0] = 0;
            }
            for (var F = D instanceof ArrayBuffer ? D.byteLength : D.size, U = F.toString(), w = new Uint8Array(U.length + 1), O = 0; O < U.length; O++)
              w[O] = parseInt(U[O]);
            if (w[U.length] = 255, x) {
              var L = new x([M.buffer, w.buffer, D]);
              A(null, L);
            }
          });
        }
        p(E, R, function(P, A) {
          return k(new x(A));
        });
      }, e.decodePayloadAsBinary = function(E, k, R) {
        typeof k == "function" && (R = k, k = null);
        for (var P = E, A = []; P.byteLength > 0; ) {
          for (var D = new Uint8Array(P), M = D[0] === 0, I = "", O = 1; D[O] !== 255; O++) {
            if (I.length > 310)
              return R(T, 0, 1);
            I += D[O];
          }
          P = h(P, 2 + I.length), I = parseInt(I);
          var F = h(P, 0, I);
          if (M)
            try {
              F = String.fromCharCode.apply(null, new Uint8Array(F));
            } catch {
              var U = new Uint8Array(F);
              F = "";
              for (var O = 0; O < U.length; O++)
                F += String.fromCharCode(U[O]);
            }
          A.push(F), P = h(P, I);
        }
        var w = A.length;
        A.forEach(function(L, ce) {
          R(e.decodePacket(L, k, !0), ce, w);
        });
      };
    }, function(t, e) {
      t.exports = Object.keys || function(r) {
        var i = [], o = Object.prototype.hasOwnProperty;
        for (var a in r)
          o.call(r, a) && i.push(a);
        return i;
      };
    }, function(t, e, r) {
      function i(p) {
        if (!p || typeof p != "object")
          return !1;
        if (o(p)) {
          for (var l = 0, m = p.length; l < m; l++)
            if (i(p[l]))
              return !0;
          return !1;
        }
        if (typeof Buffer == "function" && Buffer.isBuffer && Buffer.isBuffer(p) || typeof ArrayBuffer == "function" && p instanceof ArrayBuffer || d && p instanceof Blob || u && p instanceof File)
          return !0;
        if (p.toJSON && typeof p.toJSON == "function" && arguments.length === 1)
          return i(p.toJSON(), !0);
        for (var f in p)
          if (Object.prototype.hasOwnProperty.call(p, f) && i(p[f]))
            return !0;
        return !1;
      }
      var o = r(10), a = Object.prototype.toString, d = typeof Blob == "function" || typeof Blob < "u" && a.call(Blob) === "[object BlobConstructor]", u = typeof File == "function" || typeof File < "u" && a.call(File) === "[object FileConstructor]";
      t.exports = i;
    }, function(t, e) {
      t.exports = function(r, i, o) {
        var a = r.byteLength;
        if (i = i || 0, o = o || a, r.slice)
          return r.slice(i, o);
        if (i < 0 && (i += a), o < 0 && (o += a), o > a && (o = a), i >= a || i >= o || a === 0)
          return new ArrayBuffer(0);
        for (var d = new Uint8Array(r), u = new Uint8Array(o - i), p = i, l = 0; p < o; p++, l++)
          u[l] = d[p];
        return u.buffer;
      };
    }, function(t, e) {
      function r(o, a, d) {
        function u(l, m) {
          if (u.count <= 0)
            throw new Error("after called too many times");
          --u.count, l ? (p = !0, a(l), a = d) : u.count !== 0 || p || a(null, m);
        }
        var p = !1;
        return d = d || i, u.count = o, o === 0 ? a() : u;
      }
      function i() {
      }
      t.exports = r;
    }, function(t, e) {
      function r(y) {
        for (var v, b, C = [], S = 0, T = y.length; S < T; )
          v = y.charCodeAt(S++), v >= 55296 && v <= 56319 && S < T ? (b = y.charCodeAt(S++), (64512 & b) == 56320 ? C.push(((1023 & v) << 10) + (1023 & b) + 65536) : (C.push(v), S--)) : C.push(v);
        return C;
      }
      function i(y) {
        for (var v, b = y.length, C = -1, S = ""; ++C < b; )
          v = y[C], v > 65535 && (v -= 65536, S += c(v >>> 10 & 1023 | 55296), v = 56320 | 1023 & v), S += c(v);
        return S;
      }
      function o(y, v) {
        if (y >= 55296 && y <= 57343) {
          if (v)
            throw Error("Lone surrogate U+" + y.toString(16).toUpperCase() + " is not a scalar value");
          return !1;
        }
        return !0;
      }
      function a(y, v) {
        return c(y >> v & 63 | 128);
      }
      function d(y, v) {
        if ((4294967168 & y) == 0)
          return c(y);
        var b = "";
        return (4294965248 & y) == 0 ? b = c(y >> 6 & 31 | 192) : (4294901760 & y) == 0 ? (o(y, v) || (y = 65533), b = c(y >> 12 & 15 | 224), b += a(y, 6)) : (4292870144 & y) == 0 && (b = c(y >> 18 & 7 | 240), b += a(y, 12), b += a(y, 6)), b += c(63 & y | 128);
      }
      function u(y, v) {
        v = v || {};
        for (var b, C = v.strict !== !1, S = r(y), T = S.length, x = -1, E = ""; ++x < T; )
          b = S[x], E += d(b, C);
        return E;
      }
      function p() {
        if (g >= h)
          throw Error("Invalid byte index");
        var y = 255 & f[g];
        if (g++, (192 & y) == 128)
          return 63 & y;
        throw Error("Invalid continuation byte");
      }
      function l(y) {
        var v, b, C, S, T;
        if (g > h)
          throw Error("Invalid byte index");
        if (g == h)
          return !1;
        if (v = 255 & f[g], g++, (128 & v) == 0)
          return v;
        if ((224 & v) == 192) {
          if (b = p(), T = (31 & v) << 6 | b, T >= 128)
            return T;
          throw Error("Invalid continuation byte");
        }
        if ((240 & v) == 224) {
          if (b = p(), C = p(), T = (15 & v) << 12 | b << 6 | C, T >= 2048)
            return o(T, y) ? T : 65533;
          throw Error("Invalid continuation byte");
        }
        if ((248 & v) == 240 && (b = p(), C = p(), S = p(), T = (7 & v) << 18 | b << 12 | C << 6 | S, T >= 65536 && T <= 1114111))
          return T;
        throw Error("Invalid UTF-8 detected");
      }
      function m(y, v) {
        v = v || {};
        var b = v.strict !== !1;
        f = r(y), h = f.length, g = 0;
        for (var C, S = []; (C = l(b)) !== !1; )
          S.push(C);
        return i(S);
      }
      /*! https://mths.be/utf8js v2.1.2 by @mathias */
      var f, h, g, c = String.fromCharCode;
      t.exports = { version: "2.1.2", encode: u, decode: m };
    }, function(t, e) {
      (function(r) {
        e.encode = function(i) {
          var o, a = new Uint8Array(i), d = a.length, u = "";
          for (o = 0; o < d; o += 3)
            u += r[a[o] >> 2], u += r[(3 & a[o]) << 4 | a[o + 1] >> 4], u += r[(15 & a[o + 1]) << 2 | a[o + 2] >> 6], u += r[63 & a[o + 2]];
          return d % 3 === 2 ? u = u.substring(0, u.length - 1) + "=" : d % 3 === 1 && (u = u.substring(0, u.length - 2) + "=="), u;
        }, e.decode = function(i) {
          var o, a, d, u, p, l = 0.75 * i.length, m = i.length, f = 0;
          i[i.length - 1] === "=" && (l--, i[i.length - 2] === "=" && l--);
          var h = new ArrayBuffer(l), g = new Uint8Array(h);
          for (o = 0; o < m; o += 4)
            a = r.indexOf(i[o]), d = r.indexOf(i[o + 1]), u = r.indexOf(i[o + 2]), p = r.indexOf(i[o + 3]), g[f++] = a << 2 | d >> 4, g[f++] = (15 & d) << 4 | u >> 2, g[f++] = (3 & u) << 6 | 63 & p;
          return h;
        };
      })("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");
    }, function(t, e) {
      function r(l) {
        return l.map(function(m) {
          if (m.buffer instanceof ArrayBuffer) {
            var f = m.buffer;
            if (m.byteLength !== f.byteLength) {
              var h = new Uint8Array(m.byteLength);
              h.set(new Uint8Array(f, m.byteOffset, m.byteLength)), f = h.buffer;
            }
            return f;
          }
          return m;
        });
      }
      function i(l, m) {
        m = m || {};
        var f = new a();
        return r(l).forEach(function(h) {
          f.append(h);
        }), m.type ? f.getBlob(m.type) : f.getBlob();
      }
      function o(l, m) {
        return new Blob(r(l), m || {});
      }
      var a = typeof a < "u" ? a : typeof WebKitBlobBuilder < "u" ? WebKitBlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" && MozBlobBuilder, d = function() {
        try {
          var l = new Blob(["hi"]);
          return l.size === 2;
        } catch {
          return !1;
        }
      }(), u = d && function() {
        try {
          var l = new Blob([new Uint8Array([1, 2])]);
          return l.size === 2;
        } catch {
          return !1;
        }
      }(), p = a && a.prototype.append && a.prototype.getBlob;
      typeof Blob < "u" && (i.prototype = Blob.prototype, o.prototype = Blob.prototype), t.exports = function() {
        return d ? u ? Blob : o : p ? i : void 0;
      }();
    }, function(t, e) {
      e.encode = function(r) {
        var i = "";
        for (var o in r)
          r.hasOwnProperty(o) && (i.length && (i += "&"), i += encodeURIComponent(o) + "=" + encodeURIComponent(r[o]));
        return i;
      }, e.decode = function(r) {
        for (var i = {}, o = r.split("&"), a = 0, d = o.length; a < d; a++) {
          var u = o[a].split("=");
          i[decodeURIComponent(u[0])] = decodeURIComponent(u[1]);
        }
        return i;
      };
    }, function(t, e) {
      t.exports = function(r, i) {
        var o = function() {
        };
        o.prototype = i.prototype, r.prototype = new o(), r.prototype.constructor = r;
      };
    }, function(t, e) {
      function r(f) {
        var h = "";
        do
          h = d[f % u] + h, f = Math.floor(f / u);
        while (f > 0);
        return h;
      }
      function i(f) {
        var h = 0;
        for (m = 0; m < f.length; m++)
          h = h * u + p[f.charAt(m)];
        return h;
      }
      function o() {
        var f = r(+new Date());
        return f !== a ? (l = 0, a = f) : f + "." + r(l++);
      }
      for (var a, d = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), u = 64, p = {}, l = 0, m = 0; m < u; m++)
        p[d[m]] = m;
      o.encode = r, o.decode = i, t.exports = o;
    }, function(t, e, r) {
      function i() {
      }
      function o(f) {
        a.call(this, f), this.query = this.query || {}, p || (p = u.___eio = u.___eio || []), this.index = p.length;
        var h = this;
        p.push(function(g) {
          h.onData(g);
        }), this.query.j = this.index, typeof addEventListener == "function" && addEventListener("beforeunload", function() {
          h.script && (h.script.onerror = i);
        }, !1);
      }
      var a = r(20), d = r(31), u = r(18);
      t.exports = o;
      var p, l = /\n/g, m = /\\n/g;
      d(o, a), o.prototype.supportsBinary = !1, o.prototype.doClose = function() {
        this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), a.prototype.doClose.call(this);
      }, o.prototype.doPoll = function() {
        var f = this, h = document.createElement("script");
        this.script && (this.script.parentNode.removeChild(this.script), this.script = null), h.async = !0, h.src = this.uri(), h.onerror = function(y) {
          f.onError("jsonp poll error", y);
        };
        var g = document.getElementsByTagName("script")[0];
        g ? g.parentNode.insertBefore(h, g) : (document.head || document.body).appendChild(h), this.script = h;
        var c = typeof navigator < "u" && /gecko/i.test(navigator.userAgent);
        c && setTimeout(function() {
          var y = document.createElement("iframe");
          document.body.appendChild(y), document.body.removeChild(y);
        }, 100);
      }, o.prototype.doWrite = function(f, h) {
        function g() {
          c(), h();
        }
        function c() {
          if (y.iframe)
            try {
              y.form.removeChild(y.iframe);
            } catch (x) {
              y.onError("jsonp polling iframe removal error", x);
            }
          try {
            var T = '<iframe src="javascript:0" name="' + y.iframeId + '">';
            v = document.createElement(T);
          } catch {
            v = document.createElement("iframe"), v.name = y.iframeId, v.src = "javascript:0";
          }
          v.id = y.iframeId, y.form.appendChild(v), y.iframe = v;
        }
        var y = this;
        if (!this.form) {
          var v, b = document.createElement("form"), C = document.createElement("textarea"), S = this.iframeId = "eio_iframe_" + this.index;
          b.className = "socketio", b.style.position = "absolute", b.style.top = "-1000px", b.style.left = "-1000px", b.target = S, b.method = "POST", b.setAttribute("accept-charset", "utf-8"), C.name = "d", b.appendChild(C), document.body.appendChild(b), this.form = b, this.area = C;
        }
        this.form.action = this.uri(), c(), f = f.replace(m, `\\
`), this.area.value = f.replace(l, "\\n");
        try {
          this.form.submit();
        } catch {
        }
        this.iframe.attachEvent ? this.iframe.onreadystatechange = function() {
          y.iframe.readyState === "complete" && g();
        } : this.iframe.onload = g;
      };
    }, function(t, e, r) {
      function i(g) {
        var c = g && g.forceBase64;
        c && (this.supportsBinary = !1), this.perMessageDeflate = g.perMessageDeflate, this.usingBrowserWebSocket = o && !g.forceNode, this.protocols = g.protocols, this.usingBrowserWebSocket || (h = a), d.call(this, g);
      }
      var o, a, d = r(21), u = r(22), p = r(30), l = r(31), m = r(32), f = r(3)("engine.io-client:websocket");
      if (typeof WebSocket < "u" ? o = WebSocket : typeof self < "u" && (o = self.WebSocket || self.MozWebSocket), typeof window > "u")
        try {
          a = r(35);
        } catch {
        }
      var h = o || a;
      t.exports = i, l(i, d), i.prototype.name = "websocket", i.prototype.supportsBinary = !0, i.prototype.doOpen = function() {
        if (this.check()) {
          var g = this.uri(), c = this.protocols, y = {};
          this.isReactNative || (y.agent = this.agent, y.perMessageDeflate = this.perMessageDeflate, y.pfx = this.pfx, y.key = this.key, y.passphrase = this.passphrase, y.cert = this.cert, y.ca = this.ca, y.ciphers = this.ciphers, y.rejectUnauthorized = this.rejectUnauthorized), this.extraHeaders && (y.headers = this.extraHeaders), this.localAddress && (y.localAddress = this.localAddress);
          try {
            this.ws = this.usingBrowserWebSocket && !this.isReactNative ? c ? new h(g, c) : new h(g) : new h(g, c, y);
          } catch (v) {
            return this.emit("error", v);
          }
          this.ws.binaryType === void 0 && (this.supportsBinary = !1), this.ws.supports && this.ws.supports.binary ? (this.supportsBinary = !0, this.ws.binaryType = "nodebuffer") : this.ws.binaryType = "arraybuffer", this.addEventListeners();
        }
      }, i.prototype.addEventListeners = function() {
        var g = this;
        this.ws.onopen = function() {
          g.onOpen();
        }, this.ws.onclose = function() {
          g.onClose();
        }, this.ws.onmessage = function(c) {
          g.onData(c.data);
        }, this.ws.onerror = function(c) {
          g.onError("websocket error", c);
        };
      }, i.prototype.write = function(g) {
        function c() {
          y.emit("flush"), setTimeout(function() {
            y.writable = !0, y.emit("drain");
          }, 0);
        }
        var y = this;
        this.writable = !1;
        for (var v = g.length, b = 0, C = v; b < C; b++)
          (function(S) {
            u.encodePacket(S, y.supportsBinary, function(T) {
              if (!y.usingBrowserWebSocket) {
                var x = {};
                if (S.options && (x.compress = S.options.compress), y.perMessageDeflate) {
                  var E = typeof T == "string" ? Buffer.byteLength(T) : T.length;
                  E < y.perMessageDeflate.threshold && (x.compress = !1);
                }
              }
              try {
                y.usingBrowserWebSocket ? y.ws.send(T) : y.ws.send(T, x);
              } catch {
                f("websocket closed before onclose event");
              }
              --v || c();
            });
          })(g[b]);
      }, i.prototype.onClose = function() {
        d.prototype.onClose.call(this);
      }, i.prototype.doClose = function() {
        typeof this.ws < "u" && this.ws.close();
      }, i.prototype.uri = function() {
        var g = this.query || {}, c = this.secure ? "wss" : "ws", y = "";
        this.port && (c === "wss" && Number(this.port) !== 443 || c === "ws" && Number(this.port) !== 80) && (y = ":" + this.port), this.timestampRequests && (g[this.timestampParam] = m()), this.supportsBinary || (g.b64 = 1), g = p.encode(g), g.length && (g = "?" + g);
        var v = this.hostname.indexOf(":") !== -1;
        return c + "://" + (v ? "[" + this.hostname + "]" : this.hostname) + y + this.path + g;
      }, i.prototype.check = function() {
        return !(!h || "__initialize" in h && this.name === i.prototype.name);
      };
    }, function(t, e) {
    }, function(t, e) {
      var r = [].indexOf;
      t.exports = function(i, o) {
        if (r)
          return i.indexOf(o);
        for (var a = 0; a < i.length; ++a)
          if (i[a] === o)
            return a;
        return -1;
      };
    }, function(t, e, r) {
      function i(c, y, v) {
        this.io = c, this.nsp = y, this.json = this, this.ids = 0, this.acks = {}, this.receiveBuffer = [], this.sendBuffer = [], this.connected = !1, this.disconnected = !0, this.flags = {}, v && v.query && (this.query = v.query), this.io.autoConnect && this.open();
      }
      var o = r(7), a = r(8), d = r(38), u = r(39), p = r(40), l = r(3)("socket.io-client:socket"), m = r(30), f = r(24);
      t.exports = i;
      var h = { connect: 1, connect_error: 1, connect_timeout: 1, connecting: 1, disconnect: 1, error: 1, reconnect: 1, reconnect_attempt: 1, reconnect_failed: 1, reconnect_error: 1, reconnecting: 1, ping: 1, pong: 1 }, g = a.prototype.emit;
      a(i.prototype), i.prototype.subEvents = function() {
        if (!this.subs) {
          var c = this.io;
          this.subs = [u(c, "open", p(this, "onopen")), u(c, "packet", p(this, "onpacket")), u(c, "close", p(this, "onclose"))];
        }
      }, i.prototype.open = i.prototype.connect = function() {
        return this.connected ? this : (this.subEvents(), this.io.reconnecting || this.io.open(), this.io.readyState === "open" && this.onopen(), this.emit("connecting"), this);
      }, i.prototype.send = function() {
        var c = d(arguments);
        return c.unshift("message"), this.emit.apply(this, c), this;
      }, i.prototype.emit = function(c) {
        if (h.hasOwnProperty(c))
          return g.apply(this, arguments), this;
        var y = d(arguments), v = { type: (this.flags.binary !== void 0 ? this.flags.binary : f(y)) ? o.BINARY_EVENT : o.EVENT, data: y };
        return v.options = {}, v.options.compress = !this.flags || this.flags.compress !== !1, typeof y[y.length - 1] == "function" && (l("emitting packet with ack id %d", this.ids), this.acks[this.ids] = y.pop(), v.id = this.ids++), this.connected ? this.packet(v) : this.sendBuffer.push(v), this.flags = {}, this;
      }, i.prototype.packet = function(c) {
        c.nsp = this.nsp, this.io.packet(c);
      }, i.prototype.onopen = function() {
        if (l("transport is open - connecting"), this.nsp !== "/")
          if (this.query) {
            var c = typeof this.query == "object" ? m.encode(this.query) : this.query;
            l("sending connect packet with query %s", c), this.packet({ type: o.CONNECT, query: c });
          } else
            this.packet({ type: o.CONNECT });
      }, i.prototype.onclose = function(c) {
        l("close (%s)", c), this.connected = !1, this.disconnected = !0, delete this.id, this.emit("disconnect", c);
      }, i.prototype.onpacket = function(c) {
        var y = c.nsp === this.nsp, v = c.type === o.ERROR && c.nsp === "/";
        if (y || v)
          switch (c.type) {
            case o.CONNECT:
              this.onconnect();
              break;
            case o.EVENT:
              this.onevent(c);
              break;
            case o.BINARY_EVENT:
              this.onevent(c);
              break;
            case o.ACK:
              this.onack(c);
              break;
            case o.BINARY_ACK:
              this.onack(c);
              break;
            case o.DISCONNECT:
              this.ondisconnect();
              break;
            case o.ERROR:
              this.emit("error", c.data);
          }
      }, i.prototype.onevent = function(c) {
        var y = c.data || [];
        l("emitting event %j", y), c.id != null && (l("attaching ack callback to event"), y.push(this.ack(c.id))), this.connected ? g.apply(this, y) : this.receiveBuffer.push(y);
      }, i.prototype.ack = function(c) {
        var y = this, v = !1;
        return function() {
          if (!v) {
            v = !0;
            var b = d(arguments);
            l("sending ack %j", b), y.packet({ type: f(b) ? o.BINARY_ACK : o.ACK, id: c, data: b });
          }
        };
      }, i.prototype.onack = function(c) {
        var y = this.acks[c.id];
        typeof y == "function" ? (l("calling ack %s with %j", c.id, c.data), y.apply(this, c.data), delete this.acks[c.id]) : l("bad ack %s", c.id);
      }, i.prototype.onconnect = function() {
        this.connected = !0, this.disconnected = !1, this.emitBuffered(), this.emit("connect");
      }, i.prototype.emitBuffered = function() {
        var c;
        for (c = 0; c < this.receiveBuffer.length; c++)
          g.apply(this, this.receiveBuffer[c]);
        for (this.receiveBuffer = [], c = 0; c < this.sendBuffer.length; c++)
          this.packet(this.sendBuffer[c]);
        this.sendBuffer = [];
      }, i.prototype.ondisconnect = function() {
        l("server disconnect (%s)", this.nsp), this.destroy(), this.onclose("io server disconnect");
      }, i.prototype.destroy = function() {
        if (this.subs) {
          for (var c = 0; c < this.subs.length; c++)
            this.subs[c].destroy();
          this.subs = null;
        }
        this.io.destroy(this);
      }, i.prototype.close = i.prototype.disconnect = function() {
        return this.connected && (l("performing disconnect (%s)", this.nsp), this.packet({ type: o.DISCONNECT })), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
      }, i.prototype.compress = function(c) {
        return this.flags.compress = c, this;
      }, i.prototype.binary = function(c) {
        return this.flags.binary = c, this;
      };
    }, function(t, e) {
      function r(i, o) {
        var a = [];
        o = o || 0;
        for (var d = o || 0; d < i.length; d++)
          a[d - o] = i[d];
        return a;
      }
      t.exports = r;
    }, function(t, e) {
      function r(i, o, a) {
        return i.on(o, a), { destroy: function() {
          i.removeListener(o, a);
        } };
      }
      t.exports = r;
    }, function(t, e) {
      var r = [].slice;
      t.exports = function(i, o) {
        if (typeof o == "string" && (o = i[o]), typeof o != "function")
          throw new Error("bind() requires a function");
        var a = r.call(arguments, 2);
        return function() {
          return o.apply(i, a.concat(r.call(arguments)));
        };
      };
    }, function(t, e) {
      function r(i) {
        i = i || {}, this.ms = i.min || 100, this.max = i.max || 1e4, this.factor = i.factor || 2, this.jitter = i.jitter > 0 && i.jitter <= 1 ? i.jitter : 0, this.attempts = 0;
      }
      t.exports = r, r.prototype.duration = function() {
        var i = this.ms * Math.pow(this.factor, this.attempts++);
        if (this.jitter) {
          var o = Math.random(), a = Math.floor(o * this.jitter * i);
          i = (1 & Math.floor(10 * o)) == 0 ? i - a : i + a;
        }
        return 0 | Math.min(i, this.max);
      }, r.prototype.reset = function() {
        this.attempts = 0;
      }, r.prototype.setMin = function(i) {
        this.ms = i;
      }, r.prototype.setMax = function(i) {
        this.max = i;
      }, r.prototype.setJitter = function(i) {
        this.jitter = i;
      };
    }]);
  });
})(Xr);
const Ai = Xr.exports;
function Di(n, s) {
  return Ai(n, {
    query: {
      ...s
    },
    transports: ["websocket"],
    forceNew: !0,
    reconnectionAttempts: 30,
    reconnectionDelay: 1e3,
    reconnectionDelayMax: 60 * 1e3,
    randomizationFactor: 0.1
  });
}
function Wt(n, s, t, e, r, i) {
  const o = {};
  return e && (o.iceTransportPolicy = "relay"), r && r.length > 0 && (o.iceServers = r.map(({ url: a, credential: d, username: u }) => ({
    urls: a,
    username: u,
    credential: d
  }))), i && (o.encodedInsertableStreams = !0), {
    connectionId: n,
    erizoId: s,
    streamId: t,
    peerConnection: new RTCPeerConnection(o)
  };
}
class ue {
  constructor(s) {
    B(this, "uid");
    B(this, "hasAudio", !1);
    B(this, "hasVideo", !1);
    this.uid = s;
  }
}
const Gt = "1.4.3.1", _ = (n, s, t, e) => ({
  width: n,
  height: s,
  frameRate: t,
  ...e ? {
    bitrateMin: e,
    bitrateMax: e
  } : {}
}), se = {
  "120p": _(160, 120, 15, 130),
  "120p_1": _(160, 120, 15, 130),
  "120p_3": _(120, 120, 15, 130),
  "180p": _(320, 180, 15, 280),
  "180p_1": _(320, 180, 15, 280),
  "180p_3": _(180, 180, 15, 200),
  "180p_4": _(240, 180, 15, 240),
  "240p": _(320, 240, 15, 400),
  "240p_1": _(320, 240, 15, 400),
  "240p_3": _(240, 240, 15, 280),
  "240p_4": _(424, 240, 15, 440),
  "360p": _(640, 360, 15, 800),
  "360p_1": _(640, 360, 15, 800),
  "360p_3": _(360, 360, 15, 520),
  "360p_4": _(640, 360, 30, 1200),
  "360p_6": _(360, 360, 30, 800),
  "360p_7": _(480, 360, 15, 640),
  "360p_8": _(480, 360, 30, 980),
  "360p_9": _(640, 360, 15, 1600),
  "360p_10": _(640, 360, 24, 1600),
  "360p_11": _(640, 360, 24, 2e3),
  "480p": _(640, 480, 15, 1e3),
  "480p_1": _(640, 480, 15, 1e3),
  "480p_2": _(640, 480, 30, 2e3),
  "480p_3": _(480, 480, 15, 800),
  "480p_4": _(640, 480, 30, 1500),
  "480p_6": _(480, 480, 30, 1200),
  "480p_8": _(848, 480, 15, 1220),
  "480p_9": _(848, 480, 30, 1620),
  "480p_10": _(640, 480, 10, 800),
  "540p": _(960, 540, 15, 1600),
  "540p_1": _(960, 540, 15, 1600),
  "540p_2": _(960, 540, 30, 2e3),
  "720p": _(1280, 720, 15, 2500),
  "720p_1": _(1280, 720, 15, 2500),
  "720p_2": _(1280, 720, 30, 4e3),
  "720p_3": _(1280, 720, 30, 2900),
  "720p_5": _(960, 720, 15, 1820),
  "720p_6": _(960, 720, 30, 2760),
  "1080p": _(1920, 1080, 15, 3400),
  "1080p_1": _(1920, 1080, 15, 3400),
  "1080p_2": _(1920, 1080, 30, 3800),
  "1080p_3": _(1920, 1080, 30, 4e3),
  "1080p_5": _(1920, 1080, 60, 4200),
  "1440p": _(2560, 1440, 30, 9700),
  "1440p_1": _(2560, 1440, 30, 9700),
  "1440p_2": _(2560, 1440, 60, 14800),
  "2160p": _(3840, 2160, 30, 17820),
  "2160p_1": _(3840, 2160, 30, 17820),
  "2160p_2": _(3840, 2160, 60, 27e3)
}, Yr = {
  speech_low_quality: {
    sampleRate: 16,
    stereo: !1
  },
  speech_standard: {
    sampleRate: 32,
    stereo: !1
  },
  music_standard: {
    sampleRate: 48,
    stereo: !1
  },
  standard_stereo: {
    sampleRate: 48,
    stereo: !0
  },
  high_quality: {
    sampleRate: 48,
    stereo: !1
  },
  high_quality_stereo: {
    sampleRate: 48,
    stereo: !0
  }
}, Zr = {
  "480p": _(640, 480, 15),
  "480p_1": _(640, 480, 5),
  "480p_2": _(640, 480, 30),
  "480p_3": _(640, 480, 15),
  "720p": _(1280, 720, 15),
  "720p_1": _(1280, 720, 5),
  "720p_2": _(1280, 720, 30),
  "720p_3": _(1280, 720, 15),
  "1080p": _(1920, 1080, 15),
  "1080p_1": _(1920, 1080, 5),
  "1080p_2": _(1920, 1080, 30),
  "1080p_3": _(1920, 1080, 15)
}, ie = se["720p"], Jt = Yr.music_standard, Kt = Zr["720p"], Qr = {
  server: []
}, Mi = () => Qr.server, Ii = (n) => {
  Qr.server = [...n];
}, Xt = (n) => {
  const s = Object.keys(se);
  let t = s[s.length - 1];
  for (const e of s) {
    const r = e.split("p")[0];
    if (Number(r) >= n) {
      t = e;
      break;
    }
  }
  return se[t].bitrateMax;
}, Yt = {
  ENCODE: "encode",
  DECODE: "decode",
  RESOLVED_SEI: "resolved-sei"
}, Je = (n, s) => {
  const t = {
    video: !1,
    audio: !1
  };
  return n && (t.video = !0), s && (t.audio = !0), navigator.mediaDevices.getUserMedia(t).then((e) => {
    e.getTracks().forEach((r) => r.stop());
  }).catch((e) => {
    console.warn("\u8BF7\u6C42\u5A92\u4F53\u8BBE\u5907\u5931\u8D25: ", e.message, t);
  });
}, be = async (n, s) => {
  const t = await navigator.mediaDevices.enumerateDevices();
  let e = [];
  return n && (e = e.concat(t.filter((r) => r.kind === "videoinput"))), s && (e = e.concat(t.filter((r) => r.kind === "audioinput"))), e;
}, en = (n) => {
  const { videoWidth: s, videoHeight: t } = n, e = document.createElement("canvas");
  e.width = s, e.height = t;
  const r = e.getContext("2d");
  return r == null || r.drawImage(n, 0, 0), r == null ? void 0 : r.getImageData(0, 0, s, t);
}, oe = /* @__PURE__ */ new Map(), it = (n, s) => {
  const t = new AudioContext(), e = t.createMediaStreamSource(new MediaStream([s])), r = t.createMediaStreamDestination(), i = new GainNode(t, {
    gain: 1
  }), o = t.createScriptProcessor(4096, 1, 1), a = {
    context: t,
    source: e,
    destination: r,
    gainNode: i,
    checkVolumeProcessor: o,
    volumeLevel: 0
  };
  oe.set(n, a), o.onaudioprocess = (u) => {
    const p = u.inputBuffer.getChannelData(0);
    a.volumeLevel = Math.max(...p);
  }, e.connect(i), i.connect(r), i.connect(o), o.connect(t.destination);
  const d = r.stream.getAudioTracks()[0];
  return console.info("\u589E\u76CA\u540E\u7684stream: ", r.stream, d), d;
}, st = async (n) => {
  const s = oe.get(n);
  s && (s.destination.disconnect(), s.checkVolumeProcessor.disconnect(), s.checkVolumeProcessor.onaudioprocess = null, s.gainNode.disconnect(), s.source.disconnect(), await s.context.close(), oe.delete(n));
}, Oi = (n, s) => {
  const t = oe.get(n);
  t && (t.gainNode.gain.value = s);
}, Bi = (n) => {
  const s = oe.get(n);
  return s ? s.volumeLevel : 0;
};
class tn extends Or {
  constructor(t, e) {
    super();
    B(this, "id");
    B(this, "mediaTrack");
    B(this, "mediaElement");
    B(this, "mediaContainer");
    B(this, "trackMediaType");
    B(this, "isPlaying", !1);
    this.trackMediaType = t, this.mediaTrack = e, this.id = Math.random().toString(16).substring(2, 10);
  }
  getTrackId() {
    return this.id;
  }
  getMediaStreamTrack() {
    return this.mediaTrack;
  }
  play(t) {
    this.isPlaying && this.stop(), this.isPlaying = !0;
    let e = document.body;
    if (typeof t == "string" ? e = document.getElementById(t) || document.body : (t == null ? void 0 : t.nodeType) === 1 && (e = t), this.mediaContainer = e, this.mediaElement)
      this.trackMediaType === "video" && e.appendChild(this.mediaElement), this.mediaElement.play();
    else if (this.trackMediaType === "video") {
      const r = document.createElement("video");
      r.muted = !0, r.autoplay = !0, r.style.width = "100%", r.style.height = "100%", r.srcObject = new MediaStream([this.mediaTrack]), r.onloadedmetadata = () => {
        r.play();
      }, e.appendChild(r), this.mediaElement = r;
    } else if (this.trackMediaType === "audio") {
      const r = new Audio();
      r.srcObject = new MediaStream([this.mediaTrack]), r.onloadedmetadata = () => {
        r.play();
      }, this.mediaElement = r;
    }
  }
  stop() {
    !this.isPlaying || (this.isPlaying = !1, this.mediaElement && (this.mediaElement.pause(), this.trackMediaType === "video" && this.mediaElement.remove()));
  }
  clearMediaElement() {
    this.stop(), this.mediaElement = void 0;
  }
  setMediaTrack(t) {
    this.mediaTrack = t;
  }
  getMediaContainer() {
    return this.mediaContainer || window.document.body;
  }
}
class rn extends tn {
  constructor(t, e) {
    super(t, e);
    B(this, "muted", !1);
    B(this, "enabled", !0);
    B(this, "publishedClients", []);
    this.bindTrackEvent();
  }
  bindTrackEvent() {
    this.mediaTrack.onended = () => {
      this.emit(N.TRACK_ENDED);
    };
  }
  unbindTrackEvent() {
    this.mediaTrack.onended = null;
  }
  getTrackLabel() {
    var t;
    return (t = this.getMediaStreamTrack()) == null ? void 0 : t.label;
  }
  close() {
    this.stop(), this.mediaElement = void 0, this.mediaTrack.stop();
  }
  addPublishedClient(t) {
    this.publishedClients.find((e) => e.channelName === t.channelName) || this.publishedClients.push(t);
  }
  removePublishedClient(t) {
    const e = this.publishedClients.findIndex((r) => r.channelName === t.channelName);
    e >= 0 && this.publishedClients.splice(e, 1);
  }
  async setEnabled(t) {
    if (t) {
      if (this.enabled)
        return;
      if (this.trackMediaType === "video" && !(this instanceof G)) {
        const e = this.mediaTrack.getConstraints(), r = this.mediaTrack.contentHint, o = (await navigator.mediaDevices.getDisplayMedia({
          video: e
        })).getVideoTracks()[0];
        if (!o)
          return Promise.reject(new Error("\u672A\u80FD\u83B7\u53D6\u5230\u89C6\u9891\u6D41"));
        r && (o.contentHint = r), super.setMediaTrack(o);
      }
      this.bindTrackEvent(), this.enabled = t, this.mediaTrack && this.publishedClients.forEach((e) => {
        e.publish(this);
      });
    } else {
      if (!this.enabled)
        return;
      this.unbindTrackEvent(), this.stop(), this.mediaElement = void 0, this.mediaTrack.stop(), this.enabled = t, this.publishedClients.forEach((e) => {
        e.unpublish(this).finally(() => {
          this.addPublishedClient(e);
        });
      });
    }
  }
  async setMuted(t) {
    t ? (this.mediaTrack.enabled = !1, this.publishedClients.forEach((e) => {
      e.unpublish(this).finally(() => {
        this.addPublishedClient(e);
      });
    })) : (this.mediaTrack.enabled = !0, this.publishedClients.forEach((e) => {
      e.publish(this);
    })), this.muted = t;
  }
}
class Ni extends rn {
  constructor(t) {
    super("audio", t);
    B(this, "originAudioTrack");
    super.unbindTrackEvent();
    const e = it(this.id, t);
    super.setMediaTrack(e), super.bindTrackEvent(), this.originAudioTrack = t;
  }
  setVolume(t) {
    Oi(this.id, t / 100);
  }
  getVolumeLevel() {
    return Bi(this.id);
  }
  play() {
    super.play();
  }
  close() {
    super.close(), this.originAudioTrack.stop(), st(this.id);
  }
}
class ot extends rn {
  constructor(t) {
    super("video", t);
    B(this, "encodeConfig");
  }
  play(t, e) {
    super.play(t), this.mediaElement && ((e == null ? void 0 : e.mirror) === !0 ? this.mediaElement.style.transform = "rotateY(180deg)" : (e == null ? void 0 : e.mirror) === !1 ? this.mediaElement.style.transform = "unset" : this instanceof G ? this.mediaElement.style.transform = "rotateY(180deg)" : this.mediaElement.style.transform = "unset", e != null && e.fit ? this.mediaElement.style.objectFit = e.fit : this instanceof G ? this.mediaElement.style.objectFit = "cover" : this.mediaElement.style.objectFit = "contain");
  }
  getCurrentFrameData() {
    let t = new ImageData(1, 1);
    return !this.isPlaying || !this.mediaElement || (t = en(this.mediaElement) || t), t;
  }
  saveEncodeConfig(t) {
    this.encodeConfig ? this.encodeConfig = {
      ...this.encodeConfig,
      ...t
    } : this.encodeConfig = {
      ...t
    };
    const { height: e, bitrateMax: r } = this.encodeConfig;
    if (!r)
      if (typeof e == "number")
        this.encodeConfig.bitrateMax = Xt(this.encodeConfig.height);
      else {
        const { exact: i, ideal: o, max: a, min: d } = this.encodeConfig.height, u = i || o || a || d || 720;
        this.encodeConfig.bitrateMax = Xt(u);
      }
  }
  getEncodeConfig() {
    return this.encodeConfig ? { ...this.encodeConfig } : void 0;
  }
}
class Fi extends Ni {
  constructor(t) {
    super(t);
    B(this, "deviceId", "");
  }
  async setDevice(t) {
    if (this.enabled) {
      const e = this.originAudioTrack.getConstraints();
      await st(this.id), this.originAudioTrack.stop(), e.deviceId = t;
      const i = (await navigator.mediaDevices.getUserMedia({
        audio: e
      })).getAudioTracks()[0];
      if (!i)
        throw new Error("\u672A\u80FD\u83B7\u53D6\u5230\u97F3\u9891\u6D41");
      const o = it(this.id, i);
      super.setMediaTrack(o), this.originAudioTrack = i;
      try {
        await Promise.all(this.publishedClients.map((a) => a.replaceMediaTrack(o)));
      } catch (a) {
        let d = "";
        throw a instanceof Error && (d = a.message), new Error(`\u97F3\u9891\u8F68\u9053\u5207\u6362\u8BBE\u5907\u5931\u8D25\uFF1A${d}`);
      }
    }
    this.deviceId = t;
  }
  async setEnabled(t) {
    if (t && !this.enabled) {
      if (this.trackMediaType === "audio") {
        const e = this.originAudioTrack.getConstraints();
        this.deviceId && (e.deviceId = this.deviceId);
        const i = (await navigator.mediaDevices.getUserMedia({
          audio: e
        })).getAudioTracks()[0];
        if (!i)
          return Promise.reject(new Error("\u672A\u80FD\u83B7\u53D6\u5230\u97F3\u9891\u6D41"));
        const o = it(this.id, i);
        super.setMediaTrack(o), this.originAudioTrack = i;
      }
    } else
      !t && this.enabled && (await st(this.id), this.originAudioTrack.stop());
    return super.setEnabled(t);
  }
}
class G extends ot {
  constructor(t) {
    super(t);
    B(this, "deviceId", "");
  }
  async setDevice(t) {
    if (this.enabled) {
      const e = this.mediaTrack.getConstraints();
      e.deviceId = t, await this.mediaTrack.applyConstraints(e);
    }
    this.deviceId = t;
  }
  async setEnabled(t) {
    if (t && !this.enabled && this.trackMediaType === "video") {
      const e = this.mediaTrack.getConstraints(), r = this.mediaTrack.contentHint;
      this.deviceId && (e.deviceId = this.deviceId);
      const i = this.getEncodeConfig();
      if (i) {
        const { width: d, height: u, frameRate: p } = i;
        d && (e.width = d), u && (e.height = u), p && (e.frameRate = p);
      }
      const a = (await navigator.mediaDevices.getUserMedia({
        video: e
      })).getVideoTracks()[0];
      if (!a)
        return Promise.reject(new Error("\u672A\u80FD\u83B7\u53D6\u5230\u89C6\u9891\u6D41"));
      r && (a.contentHint = r), super.setMediaTrack(a);
    }
    return super.setEnabled(t);
  }
  async setEncoderConfiguration(t) {
    const e = this.mediaTrack.getConstraints();
    let r = {};
    if (typeof t == "object" ? r = t : r = se[t], this.enabled) {
      const { width: i, height: o, frameRate: a } = r;
      i && (e.width = i), o && (e.height = o), a && (e.frameRate = a), await this.mediaTrack.applyConstraints(e);
    }
    this.saveEncodeConfig(r);
  }
}
class nn extends tn {
  constructor(t, e, r) {
    super(t, e);
    B(this, "userId");
    this.userId = r;
  }
  getUserId() {
    return this.userId;
  }
}
class Ui extends nn {
  constructor(t, e) {
    super("audio", t, e);
    B(this, "volumeLevel", 0);
    const r = new AudioContext(), i = r.createMediaStreamSource(new MediaStream([t])), o = r.createScriptProcessor(4096, 1, 1);
    i.connect(o), o.connect(r.destination), o.onaudioprocess = (a) => {
      const d = a.inputBuffer.getChannelData(0);
      this.volumeLevel = Math.max(...d);
    };
  }
  setVolume(t) {
    this.mediaElement && (this.mediaElement.volume = t / 100);
  }
  getVolumeLevel() {
    return this.volumeLevel;
  }
  play() {
    super.play();
  }
}
class Li extends nn {
  constructor(s, t) {
    super("video", s, t);
  }
  play(s, t) {
    super.play(s), this.mediaElement && ((t == null ? void 0 : t.mirror) === !0 ? this.mediaElement.style.transform = "rotateY(180deg)" : this.mediaElement.style.transform = "unset", t != null && t.fit ? this.mediaElement.style.objectFit = t.fit : this.mediaElement.style.objectFit = "cover");
  }
  getCurrentFrameData() {
    let s = new ImageData(1, 1);
    return !this.isPlaying || !this.mediaElement || (s = en(this.mediaElement) || s), s;
  }
}
const sn = (n) => (s) => s.trackMediaType === n, W = sn("video"), Se = sn("audio"), te = (n) => n ? n.some(W) : !1, re = (n) => n ? n.some(Se) : !1, wi = (n, s, t) => {
  const e = /a=fmtp:\d+.*(?=\r?\n)/g;
  return n.replaceAll(/m=video(?:.|\r?\n)+?(?=m=|$)/g, (i) => i.replaceAll(e, (o) => o + `;x-google-min-bitrate=${s};x-google-start-bitrate=${t}`)) || n;
};
var on = /* @__PURE__ */ ((n) => (n.Android = "Android", n.Darwin = "Darwin", n.IOS = "iOS", n.Linux = "Linux", n.Web = "Web", n.Windows = "Windows", n))(on || {});
const ht = navigator.userAgent, V = (n) => n.test(ht.toLowerCase()), Ke = (n) => {
  var s;
  return ((s = ht.toLowerCase().match(n)) == null ? void 0 : s.toString().replace(/[^0-9|_.]/g, "").replace(/_/g, ".")) || "unknown";
}, ji = () => {
  let n = "unknown";
  V(/windows|win32|win64|wow32|wow64/g) ? n = "Windows" : V(/macintosh|macintel/g) ? n = "MacOS" : V(/x11/g) ? n = "Linux" : V(/android|adr/g) ? n = "Android" : V(/ios|iphone|ipad|ipod|iwatch/g) && (n = "iOS");
  let s = "unknown";
  return n === "Windows" ? V(/windows nt 5.0|windows 2000/g) ? s = "2000" : V(/windows nt 5.1|windows xp/g) ? s = "xp" : V(/windows nt 5.2|windows 2003/g) ? s = "2003" : V(/windows nt 6.0|windows vista/g) ? s = "vista" : V(/windows nt 6.1|windows 7/g) ? s = "7" : V(/windows nt 6.2|windows 8/g) ? s = "8" : V(/windows nt 6.3|windows 8.1/g) ? s = "8.1" : V(/windows nt 10.0|windows 10/g) && (s = "10") : n === "MacOS" ? s = Ke(/os x [\d._]+/g) : n === "Android" ? s = Ke(/android [\d._]+/g) : n === "iOS" && (s = Ke(/os [\d._]+/g)), {
    ua: ht,
    system: n,
    version: s
  };
}, an = "KGZ1bmN0aW9uKCl7InVzZSBzdHJpY3QiO2NvbnN0IFM9e0VOQ09ERToiZW5jb2RlIixERUNPREU6ImRlY29kZSIsUkVTT0xWRURfU0VJOiJyZXNvbHZlZC1zZWkifSxsPTEscD02LFQ9NTtmdW5jdGlvbiBmKGUpe2lmKGUuYnl0ZUxlbmd0aDw9NClyZXR1cm47Y29uc3Qgbz1uZXcgRGF0YVZpZXcoZSk7aWYoIShvLmdldFVpbnQzMigwKT09PWwpfHwhKG8uZ2V0VWludDgoNCk9PT1wKSlyZXR1cm47bGV0IHQ9VCxFPTA7Zm9yKDt0PGUuYnl0ZUxlbmd0aDspe2NvbnN0IHM9by5nZXRVaW50OCh0KyspO2lmKEUrPXMscyE9PTI1NSlicmVha31sZXQgYT0wO2Zvcig7dDxlLmJ5dGVMZW5ndGg7KXtjb25zdCBzPW8uZ2V0VWludDgodCsrKTtpZihhKz1zLHMhPT0yNTUpYnJlYWt9Y29uc3QgYz1lLnNsaWNlKHQsdCthKTtyZXR1cm57cGF5bG9hZFR5cGU6RSxwYXlsb2FkU2l6ZTphLHBheWxvYWRDb250ZW50OmN9fWZ1bmN0aW9uIHUoZSxvLHIpe2NvbnN0IGk9bmV3IFRyYW5zZm9ybVN0cmVhbSh7dHJhbnNmb3JtKG4sZCl7Y29uc3QgdD1mKG4uZGF0YSk7aWYodCl7Y29uc3R7cGF5bG9hZFR5cGU6RSxwYXlsb2FkU2l6ZTphLHBheWxvYWRDb250ZW50OmN9PXQ7cG9zdE1lc3NhZ2Uoe29wZXJhdGlvbjpTLlJFU09MVkVEX1NFSSxTRUk6e3VpZDplLHBheWxvYWRUeXBlOkUscGF5bG9hZFNpemU6YSxwYXlsb2FkQ29udGVudDpjfX0sW2NdKX1kLmVucXVldWUobil9fSk7by5waXBlVGhyb3VnaChpKS5waXBlVG8ocil9b25tZXNzYWdlPWU9Pntjb25zdHtvcGVyYXRpb246byx1aWQ6cixyZWFkYWJsZVN0cmVhbTppLHdyaXRhYmxlU3RyZWFtOm59PWUuZGF0YTtvPT09Uy5ERUNPREUmJnUocixpLG4pfX0pKCk7Cg==", Zt = typeof window < "u" && window.Blob && new Blob([atob(an)], { type: "text/javascript;charset=utf-8" });
function Vi() {
  const n = Zt && (window.URL || window.webkitURL).createObjectURL(Zt);
  try {
    return n ? new Worker(n) : new Worker("data:application/javascript;base64," + an);
  } finally {
    n && (window.URL || window.webkitURL).revokeObjectURL(n);
  }
}
let pe = 0;
class qi extends Or {
  constructor(t) {
    super();
    B(this, "uid", 0);
    B(this, "connectionState", "DISCONNECTED");
    B(this, "channelName", "");
    B(this, "localTracks", []);
    B(this, "remoteUsers", []);
    B(this, "config");
    B(this, "socketClient", null);
    B(this, "connectionMap", /* @__PURE__ */ new Map());
    B(this, "userStreamMap", /* @__PURE__ */ new Map());
    B(this, "remoteTracks", /* @__PURE__ */ new Map());
    B(this, "mediaStreamToSend", new MediaStream([]));
    B(this, "dualStreamOptions", {
      enabled: !1,
      templateEnabled: !1,
      lowStreamParams: {
        width: 160,
        height: 120,
        bitrate: 100,
        framerate: 15
      },
      remoteDefaultVideoStreamType: Ir.AUTO_STREAM,
      remoteUserVideoStreamTypeMap: /* @__PURE__ */ new Map()
    });
    B(this, "iceServers", []);
    B(this, "forceIceRelayMode", !1);
    B(this, "userNeedSEIMap", /* @__PURE__ */ new Map());
    this.config = t;
  }
  async join(t, e, r, i) {
    if (this.connectionState !== "DISCONNECTED")
      return Promise.reject(new Error(`\u5F53\u524D\u5DF2\u52A0\u5165\u623F\u95F4\uFF1A${this.channelName}`));
    this.switchConnectionState("CONNECTING");
    const o = Hi(t, r);
    i || (i = 0);
    const { system: a, version: d, ua: u } = ji(), p = Mi(), l = await new Promise((c, y) => {
      const v = new AbortController();
      let b = 0;
      p.forEach((C) => {
        _i(C, {
          roomname: e,
          uid: i,
          platform: on.Web,
          sdk: Gt,
          client: {
            os: `${a} ${d}`,
            ua: u
          }
        }, o, v.signal).then((S) => {
          v.abort(), c(S);
        }).catch(() => {
          ++b === p.length && y();
        });
      });
    }).catch(() => {
      this.switchConnectionState("DISCONNECTED", Z.SERVER_ERROR);
    });
    if (!l)
      return Promise.reject(new Error("\u52A0\u5165\u623F\u95F4\u63A5\u53E3\u8C03\u7528\u5F02\u5E38"));
    const { host: m, signature: f, tokenId: h, userInfo: g } = l;
    return i = g.uid, this.socketClient = Di(m, {
      signature: f,
      tokenId: h,
      sdk: Gt
    }), new Promise((c, y) => {
      const v = (b) => {
        console.info("\u8FDB\u5165\u623F\u95F4\u7684resp: ", b);
        const { errCode: C, errMsg: S, users: T, forceIceRelayMode: x, iceServers: E } = b;
        this.socketClient.off("connectResp", v), C ? (this.switchConnectionState("DISCONNECTED", Z.SERVER_ERROR), this.socketClient.close(), y(new Error(`${C}:${S}`))) : (this.switchConnectionState("CONNECTED"), this.uid = i, this.channelName = e, this.forceIceRelayMode = x, this.iceServers = E, this.bindServerNoticeEvents(), this.initJoinedUsers(T), this.getNetworkQuality(), c(this.uid));
      };
      this.socketClient.on("connectResp", v);
    });
  }
  async leave() {
    if (this.connectionState !== "CONNECTED") {
      console.warn("\u5F53\u524D\u672A\u52A0\u5165\u623F\u95F4");
      return;
    }
    return this.socketClient.emit("clientDisconnection", {
      reason: "\u4E3B\u52A8\u79BB\u5F00"
    }), this.switchConnectionState("DISCONNECTING"), new Promise((t) => {
      const e = () => {
        this.socketClient.close(), this.socketClient = null, this.uid = 0, this.localTracks.forEach((r) => r.close()), this.localTracks = [], this.disableAudioVolumeIndicator(), this.remoteUsers.forEach((r) => {
          r.videoTrack = void 0, r.audioTrack = void 0;
        }), this.remoteUsers = [], this.remoteTracks.forEach((r) => {
          r.stop();
        }), this.remoteTracks.clear(), this.userStreamMap.clear(), this.userNeedSEIMap.clear(), this.connectionMap.forEach((r) => {
          r.peerConnection && (r.peerConnection.close(), r.peerConnection = null);
        }), this.connectionMap.clear(), this.channelName = "", this.switchConnectionState("DISCONNECTED", Z.LEAVE), t();
      };
      this.socketClient.on("onClientDisconnection", e);
    });
  }
  negotiateWithServer(t, e) {
    const { peerConnection: r, connectionId: i, erizoId: o } = t;
    r.onnegotiationneeded = async () => {
      const d = await r.createOffer({
        iceRestart: !1
      });
      await r.setLocalDescription(d), this.socketClient.emit("connectionMessage", {
        connectionId: i,
        erizoId: o,
        msg: d
      }), r.onnegotiationneeded = null;
    };
    const a = (d) => {
      const { connectionId: u, evt: p } = d;
      if (u === i) {
        const { type: l, sdp: m } = p;
        if (l === "answer") {
          let f = m;
          if (e) {
            const g = e.find((c) => c.trackMediaType === "video");
            if (g && "getEncodeConfig" in g) {
              const c = g.getEncodeConfig();
              if (c) {
                const { bitrateMax: y, bitrateMin: v } = c;
                if (v || y) {
                  const b = v || y, C = y || b;
                  f = wi(f, Number(b), Number(C));
                }
              }
            }
          }
          const h = new RTCSessionDescription({
            type: l,
            sdp: f
          });
          r.setRemoteDescription(h), this.socketClient.off("onConnectionMessage", a);
        }
      }
    };
    return this.socketClient.on("onConnectionMessage", a), new Promise((d, u) => {
      const p = (l) => {
        const { connectionId: m, evt: f } = l;
        if (m === i) {
          const { type: h, negotiated: g } = f;
          if (h === "negotiated") {
            this.socketClient.off("onConnectionMessage", p);
            const { errCode: c, errMsg: y } = g;
            c ? u(new Error(`${c}: ${y}`)) : d();
          }
        }
      };
      this.socketClient.on("onConnectionMessage", p);
    });
  }
  async publish(t) {
    const e = t ? t instanceof Array ? t : [t] : [], r = this.cantPublish(e);
    if (r)
      return Promise.reject(new Error(r));
    const { enabled: i, lowStreamParams: o } = this.dualStreamOptions;
    let a = i;
    const d = e.find(W);
    d && a && !(d instanceof G) && (a = !1);
    const u = {
      width: ie.width,
      height: ie.height,
      framerate: ie.frameRate
    };
    let p = 8;
    if (a) {
      const h = e.filter(W)[0];
      if (h) {
        const { width: g, height: c, frameRate: y } = h.getMediaStreamTrack().getSettings();
        u.width = g || u.width, u.height = c || u.height, u.framerate = y || u.framerate;
      }
      p = u.width / o.width, o.height = Math.round(u.height / p);
    }
    let l = this.connectionMap.get(this.uid);
    if (l) {
      const { connectionId: h, erizoId: g, streamId: c } = l;
      let y = {};
      re(e) && (y = {
        muteAudio: !1
      }), te(e) && (y = {
        muteVideo: !1
      }), i && d && !(d instanceof G) && (y.simulcastEnable = !1, this.dualStreamOptions.templateEnabled = !1), i && !this.dualStreamOptions.templateEnabled && d && d instanceof G && (y.simulcastEnable = !0, this.dualStreamOptions.templateEnabled = !0), this.socketClient.emit("updateStreamAttributes", {
        connectionId: h,
        erizoId: g,
        streamId: c,
        attributes: y
      });
    } else {
      this.mediaStreamToSend = new MediaStream([]);
      const h = {
        muteAudio: !re(e),
        muteVideo: !te(e),
        maxVideoBW: 3 * 1024,
        minVideoBW: 0
      };
      a && (h.simulcastEnable = !0, h.simulcastInfos = [
        { simulcastId: 1, width: u.width, height: u.height, framerate: u.framerate },
        { simulcastId: 2, width: o.width, height: o.height, framerate: o.framerate }
      ]);
      const { errCode: g, errMsg: c, erizoId: y, streamId: v, connectionId: b } = await new Promise((C) => {
        this.socketClient.emit("publish", {
          audio: !0,
          video: !0,
          screen: !1,
          data: !0,
          label: this.mediaStreamToSend.id,
          attributes: h,
          metadata: {
            type: "publisher"
          },
          state: "erizo",
          encryptTransport: !0
        }, (S, T) => {
          C(T);
        });
      });
      if (g)
        return Promise.reject(new Error(`${g}: ${c}`));
      l = Wt(b, y, v, this.forceIceRelayMode, this.iceServers, !1), this.connectionMap.set(this.uid, l);
    }
    const { peerConnection: m } = l;
    m.getTransceivers().length === 0 && m.addTransceiver("video", {
      direction: "recvonly"
    }), e.forEach((h) => {
      const g = {
        direction: "sendonly",
        streams: [this.mediaStreamToSend]
      };
      if (h.trackMediaType === "video") {
        g.sendEncodings = [{
          rid: "1",
          scaleResolutionDownBy: 1
        }, {
          rid: "2",
          scaleResolutionDownBy: p,
          maxBitrate: (o.bitrate || 100) * 1e3,
          active: a
        }];
        const c = "getEncodeConfig" in h && h.getEncodeConfig();
        c && "bitrateMax" in c && c.bitrateMax && (g.sendEncodings[0].maxBitrate = c.bitrateMax * 1e3);
      }
      m.addTransceiver(h.getMediaStreamTrack(), g);
    });
    const f = [...e.filter(W), ...this.localTracks.filter(W)];
    return this.negotiateWithServer(l, f).then(() => {
      this.localTracks.push(...e), e.forEach((h) => h.addPublishedClient(this));
    });
  }
  async unpublish(t) {
    const e = t ? t instanceof Array ? t : [t] : [], r = this.cantUnPublish(e);
    if (r)
      return Promise.reject(new Error(r));
    let i = "all";
    e.length > 0 && e.length < this.localTracks.length && (i = "single");
    const o = this.connectionMap.get(this.uid), { streamId: a, connectionId: d, erizoId: u, peerConnection: p } = o;
    if (i === "all") {
      const { errCode: l, errMsg: m } = await new Promise((f) => {
        this.socketClient.emit("unpublish", {
          streamId: a,
          connectionId: d
        }, (h, g) => {
          f(g);
        });
      });
      if (l)
        return Promise.reject(new Error(`${l}: ${m}`));
      this.localTracks.forEach((f) => f.removePublishedClient(this)), this.localTracks = [], p.close(), this.connectionMap.delete(this.uid);
    } else {
      let l;
      re(e) && (l = {
        muteAudio: !0
      }), te(e) && (l = {
        muteVideo: !0
      }), this.socketClient.emit("updateStreamAttributes", {
        connectionId: d,
        erizoId: u,
        streamId: a,
        attributes: l
      }), p.getTransceivers().forEach((h) => {
        e.some((g) => {
          var c;
          return g.getMediaStreamTrack().id === ((c = h.sender.track) == null ? void 0 : c.id);
        }) && h.stop();
      });
      const f = [...this.localTracks.filter(W)];
      return this.negotiateWithServer(o, f).then(() => {
        e.forEach((h) => {
          h.removePublishedClient(this);
          const g = this.localTracks.findIndex((c) => c.getTrackId() === h.getTrackId());
          g > -1 && this.localTracks.splice(g, 1);
        });
      });
    }
  }
  async getRemoteUserTracks(t, e, r) {
    const { uid: i } = t, { streamId: o } = e, { remoteDefaultVideoStreamType: a, remoteUserVideoStreamTypeMap: d } = this.dualStreamOptions;
    let u = "";
    const { errCode: p, errMsg: l, erizoId: m, connectionId: f } = await new Promise((h) => {
      var v;
      let g;
      const c = [], y = (b) => {
        const { connectionId: C, evt: { type: S, sdp: T } } = b;
        S === "offer" && (c.push({
          connectionId: C,
          sdp: T
        }), (g == null ? void 0 : g.connectionId) === C && (this.socketClient.off("onConnectionMessage", y), u = T, h(g)));
      };
      this.socketClient.emit("subscribe", {
        streamId: o,
        audio: !0,
        video: !0,
        data: !0,
        browser: "mozilla",
        muteVideo: !1,
        muteAudio: !1,
        metadata: {
          type: "subscriber"
        },
        simulcastId: (v = d.get(i)) != null ? v : a,
        encryptTransport: !0,
        maxVideoBW: 3 * 1024,
        slideShowMode: !1,
        supportOfferSdp: !1
      }, (b, C) => {
        g = C;
        const S = c.find((T) => T.connectionId === g.connectionId);
        S && (this.socketClient.off("onConnectionMessage", y), u = S.sdp, h(g));
      }), this.socketClient.on("onConnectionMessage", y);
    });
    if (p)
      return Promise.reject(new Error(`${p}: ${l}`));
    {
      const h = Wt(f, m, o, this.forceIceRelayMode, this.iceServers, r);
      this.connectionMap.set(i, h);
      const { peerConnection: g } = h;
      return new Promise((c, y) => {
        let v = !1;
        g.ontrack = (S) => {
          console.info("pc\u6536\u5230\u8FDC\u7AEFtrack: ", S);
          const { track: T } = S;
          T.kind === "audio" ? this.remoteTracks.set(`${i}-audio`, new Ui(T, i)) : T.kind === "video" && this.remoteTracks.set(`${i}-video`, new Li(T, i)), v && c();
        };
        const b = new RTCSessionDescription({
          type: "offer",
          sdp: u
        });
        g.setRemoteDescription(b).then(async () => {
          const S = await g.createAnswer();
          await g.setLocalDescription(S), this.socketClient.emit("connectionMessage", {
            connectionId: f,
            erizoId: m,
            msg: S
          });
        });
        const C = (S) => {
          const { connectionId: T, evt: x } = S;
          if (T === f) {
            const { type: E, negotiated: k } = x;
            if (E === "negotiated") {
              this.socketClient.off("onConnectionMessage", C);
              const { errCode: R, errMsg: P } = k;
              R ? y(new Error(`${R}: ${P}`)) : (v = !0, (this.remoteTracks.get(`${i}-video`) || this.remoteTracks.get(`${i}-audio`)) && c());
            }
          }
        };
        this.socketClient.on("onConnectionMessage", C);
      });
    }
  }
  setRemoteUserTrack(t, e) {
    const { uid: r } = t;
    if (e === "video") {
      const i = this.remoteTracks.get(`${r}-video`);
      return t.videoTrack = i, i;
    } else {
      const i = this.remoteTracks.get(`${r}-audio`);
      return t.audioTrack = i, i;
    }
  }
  async subscribe(t, e, r) {
    const { uid: i } = t, o = this.userStreamMap.get(i);
    if (o)
      if (t.audioTrack || t.videoTrack) {
        const { connectionId: a, streamId: d, erizoId: u } = this.connectionMap.get(i);
        return this.socketClient.emit("mediaSetsMessage", {
          connectionId: a,
          streamId: d,
          erizoId: u,
          type: "config",
          config: e === "video" ? { muteVideo: !1 } : { muteAudio: !1 }
        }), new Promise((p, l) => {
          const m = (f) => {
            const { type: h, errCode: g, errMsg: c, connectionId: y } = f;
            if (y === a)
              if (this.socketClient.off("onMediaSetsMessage", m), h === "failed")
                l(new Error(`\u8BBE\u7F6E\u5A92\u4F53\u72B6\u6001\u5931\u8D25\uFF0C${g}:${c}`));
              else {
                let v = setInterval(() => {
                  const b = this.setRemoteUserTrack(t, e);
                  b && (clearInterval(v), v = null, p(b));
                }, 10);
              }
          };
          this.socketClient.on("onMediaSetsMessage", m);
        });
      } else {
        o.isSubscribing || (o.isSubscribing = !0, o.subscribePromise = this.getRemoteUserTracks(t, o, !!(r != null && r.needSEI)).finally(() => {
          o.isSubscribing = !1;
        }));
        const a = o.subscribePromise;
        return new Promise((d, u) => {
          a.then(() => {
            let p = setInterval(() => {
              const l = this.setRemoteUserTrack(t, e);
              l && (clearInterval(p), p = null, r != null && r.needSEI && this.resolveSEI(i), d(l));
            }, 10);
          }).catch((p) => u(p));
        });
      }
    else
      return Promise.reject(new Error("\u7528\u6237\u5C1A\u672A\u53D1\u5E03\u5185\u5BB9"));
  }
  resolveSEI(t) {
    if (this.userNeedSEIMap.get(t))
      return;
    this.userNeedSEIMap.set(t, !0);
    const r = this.connectionMap.get(t), { peerConnection: i } = r || {};
    if (i) {
      const o = new Vi();
      i.getReceivers().forEach((d) => {
        const { readable: u, writable: p } = d.createEncodedStreams();
        o.postMessage({
          operation: Yt.DECODE,
          uid: t,
          readableStream: u,
          writableStream: p
        }, [u, p]);
      }), o.onmessage = (d) => {
        const { operation: u } = d.data;
        u === Yt.RESOLVED_SEI && this.emit(N.USER_VIDEO_SEI, d.data.SEI);
      };
    }
  }
  async unsubscribe(t, e) {
    var p, l;
    const r = +!!t.videoTrack + +!!t.audioTrack;
    if (r === 0)
      return Promise.reject(new Error("\u76EE\u524D\u5C1A\u672A\u8BA2\u9605\u8BE5\u7528\u6237"));
    const { uid: i } = t, { connectionId: o, streamId: a, erizoId: d, peerConnection: u } = this.connectionMap.get(i);
    if (r === 1) {
      const { errCode: m, errMsg: f } = await new Promise((h) => {
        this.socketClient.emit("unsubscribe", {
          streamId: a,
          connectionId: o
        }, (g, c) => {
          h(c);
        });
      });
      if (m)
        return Promise.reject(new Error(`${m}: ${f}`));
      this.userNeedSEIMap.delete(i), (p = t.videoTrack) == null || p.stop(), t.videoTrack = void 0, (l = t.audioTrack) == null || l.stop(), t.audioTrack = void 0, this.remoteTracks.delete(`${i}-video`), this.remoteTracks.delete(`${i}-audio`), u && u.close(), this.connectionMap.delete(i);
    } else
      return this.socketClient.emit("mediaSetsMessage", {
        connectionId: o,
        streamId: a,
        erizoId: d,
        type: "config",
        config: e === "video" ? { muteVideo: !0 } : { muteAudio: !0 }
      }), new Promise((m, f) => {
        const h = (g) => {
          var C, S;
          const { type: c, errCode: y, errMsg: v, connectionId: b } = g;
          o === b && (this.socketClient.off("onMediaSetsMessage", h), c === "failed" ? f(new Error(`\u8BBE\u7F6E\u5A92\u4F53\u72B6\u6001\u5931\u8D25\uFF0C${y}:${v}`)) : (e === "video" ? ((C = t.videoTrack) == null || C.stop(), t.videoTrack = void 0) : e === "audio" && ((S = t.audioTrack) == null || S.stop(), t.audioTrack = void 0), m()));
        };
        this.socketClient.on("onMediaSetsMessage", h);
      });
  }
  enableAudioVolumeIndicator() {
    pe = window.setInterval(() => {
      const e = this.remoteUsers.filter((i) => i.hasAudio && i.audioTrack).map((i) => {
        var o;
        return {
          level: (((o = i.audioTrack) == null ? void 0 : o.getVolumeLevel()) || 0) * 100,
          uid: i.uid
        };
      }), r = this.localTracks.find(Se);
      r && e.push({
        level: r.getVolumeLevel() * 100,
        uid: this.uid
      }), this.emit(N.VOLUME_INDICATOR, e);
    }, 2 * 1e3);
  }
  disableAudioVolumeIndicator() {
    pe && (window.clearInterval(pe), pe = void 0);
  }
  async enableDualStream() {
    if (this.localTracks.length > 0)
      return Promise.reject(new Error("\u5F00\u542F\u5927\u5C0F\u6D41\u5931\u8D25\uFF0C\u8BF7\u5148\u53D6\u6D88\u53D1\u5E03\u6240\u6709\u672C\u5730\u6D41"));
    this.dualStreamOptions.enabled = !0;
  }
  async disableDualStream() {
    this.dualStreamOptions.enabled = !1;
  }
  setLowStreamParameter(t) {
    t.width < 160 && (console.warn("\u5206\u8FA8\u7387\u4E0D\u5F97\u4F4E\u4E8E160*90\uFF0C\u5DF2\u4FEE\u6539\u4E3A\u6700\u4F4E\u517C\u5BB9\u5206\u8FA8\u7387"), t.width = 160, t.height = 120), Object.assign(this.dualStreamOptions.lowStreamParams, t);
  }
  async setRemoteDefaultVideoStreamType(t) {
    this.dualStreamOptions.remoteDefaultVideoStreamType = t;
  }
  async setRemoteVideoStreamType(t, e) {
    const r = this.userStreamMap.get(t);
    if (!(r != null && r.dualStreamEnabled))
      return Promise.reject(new Error("\u8BE5\u7528\u6237\u5C1A\u672A\u5F00\u542F\u5927\u5C0F\u6D41"));
    this.dualStreamOptions.remoteUserVideoStreamTypeMap.set(t, e);
    const i = this.connectionMap.get(t);
    if (i) {
      const { connectionId: o, streamId: a, erizoId: d } = i;
      return this.socketClient.emit("mediaSetsMessage", {
        connectionId: o,
        streamId: a,
        erizoId: d,
        type: "config",
        config: {
          simulcastId: e
        }
      }), new Promise((u, p) => {
        const l = (m) => {
          const { type: f, errCode: h, errMsg: g, connectionId: c } = m;
          o === c && (this.socketClient.off("onMediaSetsMessage", l), f === "failed" ? p(new Error(`\u8BBE\u7F6E\u5A92\u4F53\u72B6\u6001\u5931\u8D25\uFF0C${h}:${g}`)) : u());
        };
        this.socketClient.on("onMediaSetsMessage", l);
      });
    }
  }
  cantPublish(t) {
    if (t.length === 0)
      return "\u8BF7\u4F20\u5165\u53D1\u5E03\u5185\u5BB9";
    if (this.localTracks.length === 2)
      return "\u5DF2\u53D1\u5E03\u89C6\u9891\u548C\u97F3\u9891\uFF0C\u4E0D\u80FD\u53D1\u5E03\u591A\u4E2A\u8F68\u9053";
    const e = te(this.localTracks), r = te(t);
    if (e && r)
      return "\u5DF2\u53D1\u5E03\u89C6\u9891\uFF0C\u4E0D\u80FD\u53D1\u5E03\u591A\u4E2A\u89C6\u9891";
    const i = re(this.localTracks), o = re(t);
    if (i && o)
      return "\u5DF2\u53D1\u5E03\u97F3\u9891\uFF0C\u4E0D\u80FD\u53D1\u5E03\u591A\u4E2A\u97F3\u9891";
    if (t.filter(W).length > 1)
      return "\u4E0D\u80FD\u53D1\u5E03\u591A\u4E2A\u89C6\u9891";
    if (t.filter(Se).length > 1)
      return "\u4E0D\u80FD\u53D1\u5E03\u591A\u4E2A\u97F3\u9891";
  }
  cantUnPublish(t) {
    if (!this.connectionMap.get(this.uid))
      return "\u5C1A\u672A\u53D1\u5E03\u5185\u5BB9";
    if (t.length === 0)
      return;
    let r = 0, i = "";
    if (t.forEach((o) => {
      this.localTracks.find((a) => a.getTrackId() === o.getTrackId()) ? r++ : i += `,${o.getTrackId()}`;
    }), r !== t.length)
      return `\u5C1A\u672A\u53D1\u5E03\u8BE5\u8F68\u9053${i}`;
  }
  initJoinedUsers(t) {
    t.filter((r) => r.uid !== this.uid).forEach((r) => {
      const { uid: i, streams: o } = r, a = new ue(i);
      this.remoteUsers.push(a), this.emit(N.USER_JOINED, a), o.forEach((d) => {
        const { label: u, streamId: p, attributes: { muteAudio: l, muteVideo: m, simulcastEnable: f } } = d;
        this.userStreamMap.set(i, {
          label: u,
          streamId: p,
          dualStreamEnabled: !!f
        }), m || (a.hasVideo = !0, this.emit(N.USER_PUBLISHED, a, "video")), l || (a.hasAudio = !0, this.emit(N.USER_PUBLISHED, a, "audio"));
      });
    });
  }
  deleteUserStream(t) {
    var e, r;
    if (t) {
      this.userStreamMap.delete(t), this.userNeedSEIMap.delete(t);
      const i = this.remoteUsers.find((a) => a.uid === t);
      i && (i.hasAudio = !1, (e = i.audioTrack) == null || e.stop(), i.audioTrack = void 0, i.hasVideo = !1, (r = i.videoTrack) == null || r.stop(), i.videoTrack = void 0), this.remoteTracks.delete(`${t}-video`), this.remoteTracks.delete(`${t}-audio`);
      const o = this.connectionMap.get(t);
      o && (o.peerConnection.close(), o.peerConnection = null, this.connectionMap.delete(t));
    }
  }
  bindServerNoticeEvents() {
    const t = (e) => {
      console.info("\u91CD\u8FDE\u540EConnectResp\uFF1A", e);
      const { errCode: r, errMsg: i, users: o, forceIceRelayMode: a, iceServers: d } = e;
      if (r) {
        console.error("\u91CD\u8FDE\u5931\u8D25:", r, i), this.switchConnectionState("DISCONNECTED", Z.SERVER_ERROR);
        return;
      }
      if (this.switchConnectionState("CONNECTED"), this.forceIceRelayMode = a, this.iceServers = d, this.localTracks.length > 0) {
        const f = [...this.localTracks];
        this.localTracks = [];
        const { peerConnection: h } = this.connectionMap.get(this.uid) || {};
        h && h.close(), this.connectionMap.delete(this.uid), this.publish(f);
      }
      console.debug("\u91CD\u65B0\u53D1\u5E03\u672C\u5730\u6D41"), [...this.remoteUsers].forEach((f, h) => {
        o.find((g) => g.uid === f.uid) || (f.hasAudio && this.emit(N.USER_UNPUBLISHED, f, "audio"), f.hasVideo && this.emit(N.USER_UNPUBLISHED, f, "video"), this.deleteUserStream(f.uid), this.remoteUsers.splice(h, 1), this.emit(N.USER_LEFT, f));
      }), console.debug("\u5904\u7406\u5DF2\u79BB\u5F00\u7684\u7528\u6237");
      const p = [], l = [];
      this.remoteUsers.forEach((f) => {
        var g, c;
        const h = o.find((y) => y.uid === f.uid);
        if (h) {
          const y = (g = this.userStreamMap.get(f.uid)) == null ? void 0 : g.streamId, v = (c = h.streams[0]) == null ? void 0 : c.streamId;
          y !== v ? p.push({
            uid: f.uid,
            elder: f,
            newer: h
          }) : y && y === v && l.push({
            uid: f.uid,
            elder: f,
            newer: h
          });
        }
      }), console.debug("\u5BF9\u6BD4\u65B0\u65E7\u6570\u636E\uFF1A", JSON.stringify(p), JSON.stringify(l)), p.forEach((f) => {
        f.elder.hasAudio && this.emit(N.USER_UNPUBLISHED, f.elder, "audio"), f.elder.hasVideo && this.emit(N.USER_UNPUBLISHED, f.elder, "video"), this.deleteUserStream(f.uid);
        const h = f.newer.streams[0];
        if (h) {
          const { label: g, streamId: c, attributes: { muteAudio: y, muteVideo: v, simulcastEnable: b } } = h;
          this.userStreamMap.set(f.uid, {
            label: g,
            streamId: c,
            dualStreamEnabled: !!b
          }), v || (f.elder.hasVideo = !0, this.emit(N.USER_PUBLISHED, f.elder, "video")), y || (f.elder.hasAudio = !0, this.emit(N.USER_PUBLISHED, f.elder, "audio"));
        }
      }), console.debug("\u5904\u7406\u53D8\u5316\u7684\u6D41"), l.forEach(async (f) => {
        var R, P;
        const { hasVideo: h, videoTrack: g, hasAudio: c, audioTrack: y } = f.elder, { streamId: v, label: b, attributes: { muteAudio: C, muteVideo: S, simulcastEnable: T } } = f.newer.streams[0], x = !!this.userNeedSEIMap.get(f.uid), E = this.remoteTracks.get(`${f.uid}-video`), k = this.remoteTracks.get(`${f.uid}-audio`);
        if (console.debug(`\u7528\u6237${f.uid}\u539F\u6765\u7684\u8F68\u9053\uFF1A`, JSON.stringify(E), JSON.stringify(k)), E && k) {
          const A = E.isPlaying, D = k.isPlaying;
          this.deleteUserStream(f.uid), this.userStreamMap.set(f.uid, {
            label: b,
            streamId: v,
            dualStreamEnabled: !!T
          }), await this.subscribe(f.elder, "video", {
            needSEI: x
          });
          const M = this.remoteTracks.get(`${f.uid}-video`).getMediaStreamTrack(), I = E;
          I.clearMediaElement(), I.setMediaTrack(M);
          const O = this.remoteTracks.get(`${f.uid}-audio`).getMediaStreamTrack(), F = k;
          F.clearMediaElement(), F.setMediaTrack(O), this.remoteTracks.set(`${f.uid}-video`, E), this.remoteTracks.set(`${f.uid}-audio`, k), f.elder.hasVideo = h, f.elder.hasAudio = c, g && (f.elder.videoTrack = E), y && (f.elder.audioTrack = k), A && !S && E.play(I.getMediaContainer()), D && !C && k.play();
        }
        h && S && (f.elder.hasVideo = !1, (R = f.elder.videoTrack) == null || R.stop(), f.elder.videoTrack = void 0, this.emit(N.USER_UNPUBLISHED, f.elder, "video")), !h && !S && (f.elder.hasVideo = !0, this.emit(N.USER_PUBLISHED, f.elder, "video")), c && C && (f.elder.hasAudio = !1, (P = f.elder.audioTrack) == null || P.stop(), f.elder.audioTrack = void 0, this.emit(N.USER_UNPUBLISHED, f.elder, "audio")), !c && !C && (f.elder.hasAudio = !0, this.emit(N.USER_PUBLISHED, f.elder, "audio"));
      }), console.debug("\u5904\u7406\u672A\u53D8\u5316\u7684\u6D41");
      const m = o.filter((f) => !this.remoteUsers.find((h) => h.uid === f.uid));
      this.initJoinedUsers(m), console.debug("\u5904\u7406\u65B0\u52A0\u5165\u7684\u7528\u6237");
    };
    this.socketClient.on("reconnecting", () => {
      console.info("\u91CD\u8FDE\u4E2D\uFF1A", new Date()), this.switchConnectionState("RECONNECTING");
    }), this.socketClient.on("reconnect", () => {
      console.info("\u91CD\u8FDE\u6210\u529F\uFF1A", new Date()), this.socketClient.once("connectResp", t);
    }), this.socketClient.on("reconnect_failed", () => {
      console.error("\u91CD\u8FDE\u5931\u8D25", new Date()), this.switchConnectionState("DISCONNECTED", Z.NETWORK_ERROR);
    }), this.socketClient.on("onUserJoinRoom", (e) => {
      const { errCode: r, userInfo: { uid: i } } = e;
      if (i !== this.uid && !r) {
        let o = this.remoteUsers.find((a) => a.uid === i);
        o || (o = new ue(i), this.remoteUsers.push(o)), this.emit(N.USER_JOINED, o);
      }
    }), this.socketClient.on("onUserLeaveRoom", (e) => {
      const { errCode: r, userInfo: { uid: i } } = e;
      if (i !== this.uid && !r) {
        this.deleteUserStream(i);
        const o = this.remoteUsers.findIndex((d) => d.uid === i);
        let a = this.remoteUsers[o];
        o >= 0 ? this.remoteUsers.splice(o, 1) : a = new ue(i), this.emit(N.USER_LEFT, a);
      }
    }), this.socketClient.on("onAddStream", (e) => {
      const { label: r, streamId: i, userInfo: { uid: o }, attributes: { muteAudio: a, muteVideo: d, simulcastEnable: u } } = e;
      if (o === this.uid)
        return;
      let p = this.remoteUsers.find((l) => l.uid === o);
      p || (p = new ue(o), this.remoteUsers.push(p)), this.userStreamMap.set(o, {
        label: r,
        streamId: i,
        dualStreamEnabled: !!u
      }), d || (p.hasVideo = !0, this.emit(N.USER_PUBLISHED, p, "video")), a || (p.hasAudio = !0, this.emit(N.USER_PUBLISHED, p, "audio"));
    }), this.socketClient.on("onRemoveStream", (e) => {
      const { streamId: r } = e;
      let i = 0;
      if (this.userStreamMap.forEach((o, a) => {
        o.streamId === r && (i = a);
      }), i) {
        const o = this.remoteUsers.find((a) => a.uid === i);
        o != null && o.hasAudio && this.emit(N.USER_UNPUBLISHED, o, "audio"), o != null && o.hasVideo && this.emit(N.USER_UNPUBLISHED, o, "video"), this.deleteUserStream(i);
      }
    }), this.socketClient.on("onUpdateStreamAttributes", (e) => {
      var l, m;
      const { streamId: r, attributes: { muteAudio: i, muteVideo: o, simulcastEnable: a } } = e;
      let d = 0;
      this.userStreamMap.forEach((f, h) => {
        f.streamId === r && (d = h);
      });
      const u = this.remoteUsers.find((f) => f.uid === d);
      if (u) {
        const { hasAudio: f, hasVideo: h } = u;
        h && o && (u.hasVideo = !1, (l = u.videoTrack) == null || l.stop(), u.videoTrack = void 0, this.emit(N.USER_UNPUBLISHED, u, "video")), !h && !o && (u.hasVideo = !0, this.emit(N.USER_PUBLISHED, u, "video")), f && i && (u.hasAudio = !1, (m = u.audioTrack) == null || m.stop(), u.audioTrack = void 0, this.emit(N.USER_UNPUBLISHED, u, "audio")), !f && !i && (u.hasAudio = !0, this.emit(N.USER_PUBLISHED, u, "audio"));
      }
      const p = this.userStreamMap.get(d);
      p && (p.dualStreamEnabled && !a && (p.dualStreamEnabled = !1, this.emit(N.DUAL_STREAM_CHANGE, d, !1)), !p.dualStreamEnabled && a && (p.dualStreamEnabled = !0, this.emit(N.DUAL_STREAM_CHANGE, d, !0)));
    });
  }
  getNetworkQuality() {
    this.emit(N.NETWORK_QUALITY, {
      downlinkNetworkQuality: 1,
      uplinkNetworkQuality: 1
    });
  }
  switchConnectionState(t, e) {
    const r = this.connectionState;
    this.connectionState = t, r !== t && this.emit(N.CONNECTION_STATE_CHANGE, this.connectionState, r, e);
  }
  async replaceMediaTrack(t) {
    const e = this.connectionMap.get(this.uid), { peerConnection: r } = e || {};
    if (r) {
      const i = this.localTracks.find(Se), o = r.getSenders();
      console.debug(i == null ? void 0 : i.getMediaStreamTrack(), o);
      const a = o.find((d) => {
        var u;
        return ((u = d.track) == null ? void 0 : u.kind) === (i == null ? void 0 : i.getMediaStreamTrack().kind);
      });
      if (console.debug("sender", a), a)
        return a.replaceTrack(t);
    }
    throw new Error("pc\u66FF\u6362\u539F\u6709\u97F3\u9891\u8F68\u9053\u5931\u8D25");
  }
}
function Hi(n, s) {
  const t = {
    realm: "hisrtc.hiar.com",
    method: "HMAC_SHA1",
    appid: n,
    timestamp: Math.floor(new Date().getTime() / 1e3),
    cnonce: Math.random().toString(16).substring(2, 10),
    signature: ""
  }, e = `${n},${t.timestamp},${t.cnonce}`;
  t.signature = In(e, s);
  let r = "LAuth ";
  return Object.entries(t).forEach(([o, a]) => {
    r += `${o}=${a},`;
  }), r.replace(/,$/, "");
}
let q = [];
const de = {
  createClient: (n) => new qi(n),
  async createCameraVideoTrack(n) {
    const s = {
      video: !0
    };
    n ? n.encoderConfig || (n.encoderConfig = ie) : n = {
      encoderConfig: ie
    };
    let t = {};
    if (n && Object.keys(n).length > 0) {
      s.video = {};
      const { cameraId: o, encoderConfig: a, facingMode: d } = n;
      o && (s.video.deviceId = o), d && (s.video.facingMode = d), typeof a == "object" ? t = a : typeof a == "string" && (t = se[a]), t.frameRate || (t.frameRate = 15);
      const { width: u, height: p, frameRate: l } = t;
      u && (s.video.width = u), p && (s.video.height = p), l && (s.video.frameRate = l);
    }
    const r = (await navigator.mediaDevices.getUserMedia(s)).getVideoTracks()[0];
    r.contentHint = n.optimizationMode || "detail";
    const i = new G(r);
    return i.saveEncodeConfig(t), this.getCameras(!0), i;
  },
  createCustomVideoTrack(n) {
    const { mediaStreamTrack: s, bitrateMin: t, bitrateMax: e, optimizationMode: r } = n;
    s || console.error("\u6CA1\u6709\u6B63\u786E\u4F20\u5165MediaStreamTrack");
    const i = {};
    e && (i.bitrateMax = e), t && (i.bitrateMin = t), r && (s.contentHint = r);
    const o = new ot(s);
    return o.saveEncodeConfig(i), o;
  },
  async createMicrophoneAudioTrack(n) {
    const s = {
      audio: !0
    };
    n ? n.encoderConfig || (n.encoderConfig = Jt) : n = {
      encoderConfig: Jt
    };
    let t = {};
    if (n && Object.keys(n).length > 0) {
      s.audio = {};
      const { microphoneId: r, encoderConfig: i, AGC: o, ANS: a, AEC: d } = n;
      r && (s.audio.deviceId = r), o && (s.audio.autoGainControl = !0), a && (s.audio.noiseSuppression = !0), d && (s.audio.echoCancellation = !0), typeof i == "object" ? t = i : typeof i == "string" && (t = Yr[i]);
      const { sampleRate: u, sampleSize: p, stereo: l } = t;
      u && (s.audio.sampleRate = u), p && (s.audio.sampleSize = p), s.audio.channelCount = l ? 2 : 1;
    }
    const e = await navigator.mediaDevices.getUserMedia(s);
    return this.getMicrophones(!0), new Fi(e.getAudioTracks()[0]);
  },
  async createScreenVideoTrack(n) {
    const s = {
      video: !0
    };
    n ? n.encoderConfig || (n.encoderConfig = Kt) : n = {
      encoderConfig: Kt
    };
    let t = {};
    if (n && Object.keys(n).length > 0) {
      s.video = {};
      const { encoderConfig: o } = n;
      typeof o == "object" ? t = o : typeof o == "string" && (t = Zr[o]), t.frameRate || (t.frameRate = 15);
      const { width: a, height: d, frameRate: u } = t;
      a && (s.video.width = a), d && (s.video.height = d), u && (s.video.frameRate = u);
    }
    const r = (await navigator.mediaDevices.getDisplayMedia(s)).getVideoTracks()[0];
    r.contentHint = n.optimizationMode || "detail";
    const i = new ot(r);
    return i.saveEncodeConfig(t), i;
  },
  async getDevices(n) {
    n || await Je(!0, !0);
    const s = await be(!0, !0);
    return Xe(s), s;
  },
  async getMicrophones(n) {
    n || await Je(!1, !0);
    const s = await be(!1, !0);
    return Xe(s), s;
  },
  async getCameras(n) {
    n || await Je(!0, !1);
    const s = await be(!0, !1);
    return Xe(s), s;
  },
  setLoginServer(n) {
    if (!n)
      return;
    const t = n.replaceAll(",", ";").split(";"), e = [];
    t.forEach((r) => {
      const i = r && r.trim();
      i && (/^https?:\/\//.test(i) ? e.push(i) : e.push(`http://${i}`));
    }), Ii(e);
  },
  setLogLevel(n) {
    return n;
  }
};
let Qt = !1;
const zi = () => {
  Qt || navigator.mediaDevices && "ondevicechange" in navigator.mediaDevices && (navigator.mediaDevices.addEventListener("devicechange", () => {
    be(!0, !0).then((n) => Wi(n));
  }), Qt = !0);
}, cn = (n) => !n.deviceId || n.deviceId.length === n.groupId.length, un = (n) => {
  q.forEach((s) => {
    const t = n.find((e) => (!s.device.deviceId || s.device.deviceId === e.deviceId) && s.device.groupId === e.groupId && s.device.kind === e.kind);
    t && (s.device = t);
  });
}, $i = (n) => {
  const s = new Date().getTime();
  q = [], n.forEach((t) => {
    t.deviceId && t.deviceId.length < t.groupId.length || q.push({
      device: t,
      initAt: s,
      updateAt: s,
      state: "ACTIVE"
    });
  });
}, Xe = (n) => {
  if ((n == null ? void 0 : n.length) < 1)
    return;
  if (zi(), q.length < 1) {
    $i(n);
    return;
  }
  n = n.filter(cn), un(n);
  const s = new Date().getTime();
  n.forEach((t) => {
    if (!q.find((e) => e.device.deviceId === t.deviceId && e.device.groupId === t.groupId && e.device.kind === t.kind)) {
      const e = {
        device: t,
        initAt: s,
        updateAt: s,
        state: "ACTIVE"
      };
      q.push(e);
    }
  });
}, Wi = (n) => {
  if ((n == null ? void 0 : n.length) < 1 || q.length < 1)
    return;
  n = n.filter(cn), un(n);
  const s = new Date().getTime();
  if (n.length > q.length) {
    const t = [];
    n.forEach((e) => {
      if (!q.find((r) => r.device.deviceId === e.deviceId && r.device.groupId === e.groupId && r.device.kind === e.kind)) {
        const r = {
          device: e,
          initAt: s,
          updateAt: s,
          state: "ACTIVE"
        };
        t.push(r), q.push(r);
      }
    });
    for (let e = 0; e < t.length; e++) {
      const r = t[e];
      if (r.device.kind === "audioinput") {
        de.onMicrophoneChanged && de.onMicrophoneChanged(r);
        break;
      }
    }
  }
  if (n.length < q.length) {
    const t = [...q], e = [];
    t.forEach((r, i) => {
      n.find((o) => o.deviceId === r.device.deviceId && o.groupId === r.device.groupId && o.kind === r.device.kind) || (q.splice(i, 1), r.updateAt = s, r.state = "INACTIVE", e.push(r));
    });
    for (let r = 0; r < e.length; r++) {
      const i = e[r];
      if (i.device.kind === "audioinput") {
        de.onMicrophoneChanged && de.onMicrophoneChanged(i);
        break;
      }
    }
  }
};
export {
  Z as ConnectionDisconnectedReason,
  N as EventNameMap,
  de as LeiaRTC,
  Ir as RemoteStreamType
};
